/**
 * Simplified outlines of regions. Introduced to conditionally render
 * components on viewport intersection.
 */

import type { Feature, Polygon, Properties } from "@turf/helpers";
import { FeatureCollection } from "geojson";

export const US_OUTLINE_SIMPLIFIED: Feature<Polygon> = {
  type: "Feature",
  properties: {},
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-127.14818319193738, 49.595423464702634],
        [-126.43168050287377, 41.73535885419804],
        [-122.72563337414987, 30.74401431626849],
        [-102.21883926187449, 15.506428141209469],
        [-85.72281195308398, 22.653445824736565],
        [-91.3230609476009, 22.653445824736565],
        [-94.12318544485969, 20.432127743467746],
        [-93.71140243055689, 27.71889664804371],
        [-84.73453271875805, 28.373060701538236],
        [-81.8520516186391, 24.089781783195946],
        [-78.88721391565933, 24.24006126089482],
        [-79.62842334140409, 30.666110970136543],
        [-66.78079329515973, 43.00693227348617],
        [-66.20429707513594, 44.61146269257898],
        [-67.02786310374087, 47.30165323340694],
        [-69.08677817525488, 47.91242698973085],
        [-80.2872761642887, 44.14054117839868],
        [-83.49918367584962, 46.74021005279354],
        [-95.19382128204643, 49.91466415327258],
        [-127.14818319193738, 49.595423464702634],
      ],
    ],
  },
};

export const UK_OUTLINE_SIMPLIFIED: Feature<Polygon> = {
  type: "Feature",
  properties: {},
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-5.965576171875, 50.359480346298696],
        [-6.690673828125, 50.035973672195496],
        [-6.87744140625, 49.674737880665994],
        [-5.548095703125, 49.681846899401286],
        [-3.878173828125, 49.5822260446217],
        [-3.076171875, 49.03786794532644],
        [-2.010498046875, 48.980216985374994],
        [-1.8237304687499998, 49.23912083246698],
        [-2.43896484375, 49.57510247172322],
        [-2.274169921875, 50.169861746007314],
        [-0.50537109375, 50.21909462044748],
        [1.58203125, 51.06211251399775],
        [2.559814453125, 52.214338608258196],
        [2.197265625, 52.98172322390683],
        [0.7470703125, 53.330872983017066],
        [-0.32958984375, 54.94607621987403],
        [-2.318115234375, 56.1883678647531],
        [-1.03271484375, 57.237448817822425],
        [-1.494140625, 57.83890342754204],
        [-3.153076171875, 57.844750992891],
        [-3.69140625, 57.93235062268242],
        [-2.1533203125, 58.55679214448154],
        [-0.6591796875, 59.0009698708429],
        [0, 60.354130331374286],
        [-0.296630859375, 61.1167129205518],
        [-1.34033203125, 60.925093815014655],
        [-3.7902832031250004, 59.40036514079251],
        [-5.888671875, 58.93300426869361],
        [-7.833251953125, 58.274843152138224],
        [-7.811279296874999, 56.9809114245448],
        [-7.207031249999999, 56.05976947910657],
        [-6.459960937499999, 55.33539361201609],
        [-7.36083984375, 55.10351605801967],
        [-7.62451171875, 54.93345430690937],
        [-7.899169921874999, 54.7816821000196],
        [-8.10791015625, 54.635697306063854],
        [-8.2177734375, 54.470037612805754],
        [-8.162841796875, 54.3549556895541],
        [-7.613525390624999, 54.10450206317112],
        [-7.22900390625, 54.09161730232633],
        [-7.086181640625, 54.31011433916155],
        [-6.943359374999999, 54.29729354239265],
        [-6.558837890625, 54.059387886623576],
        [-6.119384765624999, 53.88491634606499],
        [-5.328369140625, 54.31011433916155],
        [-4.888916015625, 53.461890432859114],
        [-5.16357421875, 52.8691297276852],
        [-4.779052734375, 52.64306343665892],
        [-4.603271484375, 52.47608904123904],
        [-5.60302734375, 52.2008737173322],
        [-5.855712890625, 51.77463825786986],
        [-4.976806640625, 51.481382896100975],
        [-4.405517578125, 51.385495069223204],
        [-4.72412109375, 51.06211251399775],
        [-5.965576171875, 50.359480346298696],
      ],
    ],
  },
};

export const GB_OUTLINE_SIMPLE: FeatureCollection<Polygon, Properties> = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        country: "England",
      },
      geometry: {
        coordinates: [
          [
            [-6.619841338784681, 49.8031078017151],
            [-5.130238546953819, 49.808746264300055],
            [-4.470619715380707, 50.10944713695105],
            [-3.693055794718447, 50.02532791677578],
            [-3.2824321512227925, 50.40548764442656],
            [-2.6839700325105866, 50.46391894581197],
            [-1.5831426431307136, 50.383209565681454],
            [0.05935869117331549, 50.62215621822975],
            [0.9933462208130095, 50.762531990378335],
            [1.5618462413200405, 51.04838370432333],
            [1.515768172656891, 51.47145124743287],
            [1.0394470558290152, 51.48580156555366],
            [1.1853983389314067, 51.71487065631197],
            [1.4696765178504165, 51.86218261247666],
            [1.9613702279589518, 52.46538790023459],
            [1.8000390053468607, 52.926333985037274],
            [0.4862910326024803, 53.120419034881905],
            [0.28653987885240895, 53.55164142532337],
            [-0.02077635282435608, 54.13634652190669],
            [-0.3357617924479541, 54.46808465980223],
            [-1.0656428536146905, 54.70402017201795],
            [-1.4651240848070017, 55.7295423374548],
            [-1.9299852265351827, 55.71858968758216],
            [-1.936838995906492, 55.72096561479528],
            [-1.939458729040472, 55.72221140222876],
            [-1.944426089343572, 55.72701713480037],
            [-1.948888265335617, 55.72865523943464],
            [-1.954348733427594, 55.73202012125519],
            [-1.960034649010525, 55.734986494733164],
            [-1.959882171455087, 55.73669971869752],
            [-1.962701265730669, 55.739508643944234],
            [-1.968735433453962, 55.74196219922883],
            [-1.970721133474833, 55.74436019314708],
            [-1.972402626105555, 55.744401020481504],
            [-1.975990886117345, 55.748177773037],
            [-1.983119312361616, 55.75310711635242],
            [-1.988078716266811, 55.757651987284135],
            [-1.989621202779091, 55.76150553324806],
            [-1.983983980045786, 55.76479826795511],
            [-1.983923231707408, 55.76596476617567],
            [-1.987573587607704, 55.76568728786108],
            [-1.988282444340562, 55.7695728477651],
            [-1.986545799925109, 55.77137292033066],
            [-1.987593334379028, 55.7730509836421],
            [-1.990019072133947, 55.77296555002141],
            [-1.988286669266981, 55.774970396546934],
            [-1.988980198434536, 55.77711832190575],
            [-1.991850010889477, 55.77609604161357],
            [-1.994462233491262, 55.77757007576035],
            [-1.9919321744774, 55.77899595433266],
            [-1.992834641067665, 55.78199699407184],
            [-1.990520907457308, 55.78292050347952],
            [-1.994527606758347, 55.7835110448737],
            [-1.996093543717451, 55.78227386564387],
            [-1.995640331055756, 55.78482648617552],
            [-1.9991448860031, 55.78746633409315],
            [-2.001162076543241, 55.78750495955681],
            [-2.004187255495671, 55.79052563215663],
            [-2.009836060939194, 55.791616065648824],
            [-2.012498672365395, 55.79156328812585],
            [-2.014527146271289, 55.79414487293661],
            [-2.014309963839705, 55.795460119581705],
            [-2.018607154341304, 55.79802537784477],
            [-2.02240563068921, 55.802807229026136],
            [-2.026247128454472, 55.80324747418888],
            [-2.030035092282311, 55.80456199205953],
            [-2.029954758589991, 55.806136309723904],
            [-2.025734381139732, 55.80698698517114],
            [-2.026877843383708, 55.808763959160906],
            [-2.033201235364776, 55.81166415447147],
            [-2.03937385060545, 55.80896989368099],
            [-2.041854714080315, 55.807281727651414],
            [-2.047998312562211, 55.80426856930322],
            [-2.052636772077823, 55.802511050298854],
            [-2.055937850251241, 55.802923763711576],
            [-2.062241907109803, 55.80273289993774],
            [-2.067154169848952, 55.80024685720247],
            [-2.067096928274739, 55.79851373762429],
            [-2.072528587438697, 55.797074813488564],
            [-2.076974314776432, 55.79411698942899],
            [-2.081803035884863, 55.79389550499445],
            [-2.086123295458826, 55.79304524091944],
            [-2.088111351609678, 55.79063861381203],
            [-2.088547848408971, 55.78687359810655],
            [-2.085851737983285, 55.78257258566314],
            [-2.086823957653074, 55.778099205605216],
            [-2.086530938936951, 55.77534100612363],
            [-2.08739430262747, 55.77080122231129],
            [-2.085712954120865, 55.76798471406244],
            [-2.085639358184894, 55.76204029557365],
            [-2.095562485485388, 55.762758030678725],
            [-2.103133858965646, 55.76166107774247],
            [-2.107299799509605, 55.76010139249023],
            [-2.109302568011326, 55.75830978703519],
            [-2.108676896183313, 55.75507307583548],
            [-2.105970653474572, 55.75119476368141],
            [-2.107530488119881, 55.74781322509837],
            [-2.113426140111129, 55.74841710534842],
            [-2.115722350575409, 55.747556957735625],
            [-2.117973675548229, 55.74508482054047],
            [-2.119189704280557, 55.74164597079962],
            [-2.117152325712989, 55.739425044723724],
            [-2.119022756506284, 55.73813018032538],
            [-2.125686759961483, 55.737309938661156],
            [-2.130495306726563, 55.73871161396753],
            [-2.131700264979692, 55.739707125098334],
            [-2.138679164079184, 55.74047026022657],
            [-2.145404223003073, 55.73885424522112],
            [-2.149427140617649, 55.73576627551705],
            [-2.149763674287407, 55.732989474353445],
            [-2.148226721973582, 55.72995535503083],
            [-2.147848267616345, 55.72672921643769],
            [-2.150115826441507, 55.723510733837614],
            [-2.15175162149516, 55.72250600562188],
            [-2.15657742845272, 55.72225822339352],
            [-2.158673085053489, 55.722818913233574],
            [-2.166926155029511, 55.72255007596844],
            [-2.173537177420707, 55.72069805497354],
            [-2.176688930336122, 55.71868946082981],
            [-2.176904104000232, 55.71613337651414],
            [-2.174239801309827, 55.712599721171706],
            [-2.171231455201879, 55.70997226719476],
            [-2.167744201963635, 55.70838043755706],
            [-2.16723125055816, 55.70603512533191],
            [-2.170577594734207, 55.70491195897169],
            [-2.180597889611049, 55.70327410525703],
            [-2.186131121608474, 55.70010317888249],
            [-2.188113541969042, 55.69680983800352],
            [-2.191195843700667, 55.6963181565553],
            [-2.195313072928748, 55.69090987964382],
            [-2.198924887308988, 55.687678526759136],
            [-2.203142438053296, 55.686971729445965],
            [-2.207089787869783, 55.68498669094827],
            [-2.209197672192971, 55.68085762289024],
            [-2.218659359882373, 55.67590710262409],
            [-2.219725246968883, 55.67374250382739],
            [-2.217041451046737, 55.66687106224428],
            [-2.218452930823212, 55.664260236319514],
            [-2.220896449782394, 55.66347231528571],
            [-2.226923525146591, 55.66312436581112],
            [-2.230879787189063, 55.66203880538157],
            [-2.233699925249923, 55.65836302712704],
            [-2.237004440321188, 55.65630803288962],
            [-2.245040360306753, 55.653108806463436],
            [-2.248174139406623, 55.6523531715135],
            [-2.24730392199777, 55.65017424427276],
            [-2.242494449995255, 55.64768510059881],
            [-2.235377973728296, 55.64640514626527],
            [-2.232343758301794, 55.645419894932516],
            [-2.23158769604448, 55.64383365890483],
            [-2.233606127653947, 55.64155921193952],
            [-2.237193521590542, 55.640273732401084],
            [-2.245726050276987, 55.639519252331034],
            [-2.248624928142643, 55.63998067346107],
            [-2.251449451553344, 55.64321761269202],
            [-2.255039480500699, 55.64435842549798],
            [-2.25981044495798, 55.64457394353997],
            [-2.26941864693991, 55.6430715030238],
            [-2.276877836654407, 55.64265055171854],
            [-2.289179728890096, 55.643381400905],
            [-2.292870490595985, 55.645303514968965],
            [-2.29730952814019, 55.64675912519751],
            [-2.302731425644117, 55.64725892083109],
            [-2.307629567364216, 55.64680468339897],
            [-2.316956886108713, 55.64313559410738],
            [-2.322589248328883, 55.64355753620906],
            [-2.324702229935149, 55.643166513945566],
            [-2.326784031062804, 55.636570309385306],
            [-2.33339227387783, 55.634551751365336],
            [-2.335047221107423, 55.63449141582326],
            [-2.336097823186156, 55.632167618032064],
            [-2.332162410021737, 55.629764098865905],
            [-2.329804984462891, 55.629145099028435],
            [-2.327773779700596, 55.627251091464906],
            [-2.324310754212696, 55.626165869981286],
            [-2.321141291632928, 55.62640336582394],
            [-2.319816475547817, 55.62772224104045],
            [-2.314999424507882, 55.62788383877096],
            [-2.308626230128619, 55.628875940882175],
            [-2.308934822475551, 55.62247946872449],
            [-2.3160942957295, 55.62045843485315],
            [-2.307286487818951, 55.61110389054882],
            [-2.305949543683289, 55.612083918210296],
            [-2.295135041722746, 55.60862239812261],
            [-2.293885467851461, 55.60455512433924],
            [-2.289232494169494, 55.60377366318329],
            [-2.290264459092273, 55.60274693945642],
            [-2.287861278481837, 55.60117841091437],
            [-2.288954629249334, 55.598362579913896],
            [-2.285935801717588, 55.59654386070002],
            [-2.288607353463789, 55.5949418382],
            [-2.288211054216229, 55.591320896882216],
            [-2.290373663362617, 55.58960945441537],
            [-2.292319209331227, 55.58603504674282],
            [-2.289493738515501, 55.58107562059901],
            [-2.285480284203266, 55.57775158069842],
            [-2.280147917777156, 55.57731996605945],
            [-2.275593587929922, 55.575165746938964],
            [-2.270055491731551, 55.57010862645316],
            [-2.263716784422387, 55.5665140131107],
            [-2.259501962562601, 55.564786129363426],
            [-2.259867329224261, 55.56369279318387],
            [-2.253317767662939, 55.56151681234695],
            [-2.247854397713363, 55.55673070733524],
            [-2.24405197747074, 55.55681748185393],
            [-2.240306703420927, 55.55562713991206],
            [-2.240769020148111, 55.55268351058352],
            [-2.235173025533186, 55.54833473754869],
            [-2.232248868167227, 55.544829797211236],
            [-2.23382417768864, 55.540827529374724],
            [-2.233217423241217, 55.52961325059056],
            [-2.227602559359728, 55.5284080991846],
            [-2.224283515337147, 55.52278764309854],
            [-2.226627865035442, 55.519513620897634],
            [-2.228972438054775, 55.509804252082965],
            [-2.226540697046783, 55.50709788955346],
            [-2.220181921023265, 55.50617323388986],
            [-2.216921054247958, 55.5028158490677],
            [-2.21194142789605, 55.49942373172017],
            [-2.202232975490707, 55.48824268145336],
            [-2.20618834252818, 55.482618454378596],
            [-2.206321037215975, 55.48137375521887],
            [-2.203373372282685, 55.478604003236114],
            [-2.200964574612903, 55.47501657998177],
            [-2.195995608533595, 55.475334644572726],
            [-2.190658580990845, 55.47413454180601],
            [-2.173723789917198, 55.47227107655603],
            [-2.168494824202207, 55.46906166353727],
            [-2.165521417984821, 55.46838186705483],
            [-2.166536208089616, 55.467468464055855],
            [-2.184413734164452, 55.46408500920852],
            [-2.189637646291947, 55.46116577000374],
            [-2.188425969327963, 55.456438548854976],
            [-2.192052802046423, 55.45276691896674],
            [-2.193529198367659, 55.44979935536946],
            [-2.193299916857443, 55.44721373981401],
            [-2.194716625836306, 55.44470455954772],
            [-2.198820280537386, 55.44187473130224],
            [-2.201913218698041, 55.44056498929959],
            [-2.205624497138513, 55.43753876241915],
            [-2.221135823118361, 55.4331420469153],
            [-2.223352223508402, 55.43133290855568],
            [-2.229956227187739, 55.43057660280417],
            [-2.231282109034609, 55.42842925863469],
            [-2.236634820421384, 55.43096196819904],
            [-2.242876164956699, 55.43217435599808],
            [-2.253762260238873, 55.43189711869257],
            [-2.258591702623501, 55.43218531661907],
            [-2.26061147793771, 55.43293397098575],
            [-2.262243336765368, 55.428558152615075],
            [-2.268295408766805, 55.43000248954494],
            [-2.270647123508177, 55.42959289313677],
            [-2.273893024445562, 55.42598073739971],
            [-2.277966035694075, 55.42639651935396],
            [-2.281995847281573, 55.424742068567426],
            [-2.28423311004342, 55.4227717866517],
            [-2.294513629651983, 55.420465153528724],
            [-2.293804007284625, 55.41851873984968],
            [-2.296279129509678, 55.41467867757717],
            [-2.304251946230039, 55.41272542132727],
            [-2.306687106917775, 55.41124838057732],
            [-2.312545159774319, 55.40985519494804],
            [-2.313253764765776, 55.406789304399545],
            [-2.319695329923394, 55.4075615889717],
            [-2.327350296893842, 55.407965405391806],
            [-2.332366551798484, 55.40991068375354],
            [-2.335629343679166, 55.40820803375318],
            [-2.332998747254291, 55.40432175743415],
            [-2.33405222796521, 55.40210306054527],
            [-2.340304162034086, 55.40124302905914],
            [-2.344947016545426, 55.39931340665365],
            [-2.343370547356143, 55.397414626190454],
            [-2.335512515594991, 55.392565453397374],
            [-2.335014648476894, 55.388765044525776],
            [-2.33579773251318, 55.38598274595538],
            [-2.334632893713163, 55.38299999696649],
            [-2.330536350761265, 55.38118894050458],
            [-2.336112891397627, 55.37810777446501],
            [-2.337240616146147, 55.37673348033496],
            [-2.346233400429079, 55.37306101333419],
            [-2.343662168885365, 55.37096566667924],
            [-2.338973453933496, 55.36882765741782],
            [-2.337744503574251, 55.36735751497882],
            [-2.341101926799902, 55.3655357782239],
            [-2.354943749808973, 55.362537370018906],
            [-2.358389566529281, 55.35998706773787],
            [-2.3641988232925, 55.35876140645888],
            [-2.36545644598992, 55.35762094291509],
            [-2.37495957850384, 55.353784050046315],
            [-2.378287711156088, 55.35083993140178],
            [-2.378911999658199, 55.349169397350835],
            [-2.392978618955321, 55.34744735907954],
            [-2.399244727926064, 55.34818540095255],
            [-2.4008562803615, 55.35348699820969],
            [-2.408018229712748, 55.35719229127083],
            [-2.412366512341964, 55.357770735088884],
            [-2.41499683489323, 55.35892187417541],
            [-2.419883054767403, 55.35903361723697],
            [-2.426367354956827, 55.3581377276351],
            [-2.429230699636284, 55.356434856730765],
            [-2.4369040423147, 55.35830536273782],
            [-2.43912758032674, 55.3594025500265],
            [-2.444765330377076, 55.359137806302066],
            [-2.46122382560493, 55.35320918752869],
            [-2.463420815258498, 55.35361506907231],
            [-2.467538032292481, 55.352757491704395],
            [-2.473439504976188, 55.35473489628974],
            [-2.481133185492574, 55.35372003659494],
            [-2.488519396592941, 55.351834309821534],
            [-2.496177260766098, 55.34651453333295],
            [-2.498808752948837, 55.342101772355036],
            [-2.502253672637463, 55.34021953692172],
            [-2.501888188565357, 55.337375284880245],
            [-2.50688614637691, 55.333955346457856],
            [-2.509937974405537, 55.33126135706065],
            [-2.513712488479538, 55.32962533590612],
            [-2.517698581561673, 55.32466462414463],
            [-2.519970757211319, 55.323187570055936],
            [-2.525108912166458, 55.32180875930097],
            [-2.530768798087841, 55.32270891518789],
            [-2.536553931540225, 55.320952930949105],
            [-2.543105053083452, 55.319592300669406],
            [-2.544300080187345, 55.31826339732758],
            [-2.548728116320194, 55.3172451838214],
            [-2.550425393633993, 55.315785501506696],
            [-2.558668880632031, 55.317904648531005],
            [-2.558851438685894, 55.31463653738669],
            [-2.557271229111985, 55.313293228433565],
            [-2.557282556733004, 55.311423269125065],
            [-2.560049956528076, 55.308792148453364],
            [-2.562942376206767, 55.30779581222157],
            [-2.565214354983293, 55.30593333735989],
            [-2.566347475079431, 55.30332035217973],
            [-2.570752533723437, 55.30140832938248],
            [-2.573704610117957, 55.30078614671223],
            [-2.573358669840677, 55.29688797878294],
            [-2.57961815948193, 55.294138383370985],
            [-2.58926644027805, 55.29177298017251],
            [-2.594199458001224, 55.28985126042955],
            [-2.598491587899867, 55.287109349099175],
            [-2.60247852193833, 55.28557111165416],
            [-2.605196162727455, 55.28537440670386],
            [-2.609375277622994, 55.283148490511735],
            [-2.613709411694188, 55.27834722432842],
            [-2.617115131685982, 55.27698480479555],
            [-2.618420641203108, 55.2749887581281],
            [-2.623332905876964, 55.271964238265355],
            [-2.623650642302342, 55.26954188499455],
            [-2.628190901534786, 55.26793259006301],
            [-2.626307335602987, 55.26454200354537],
            [-2.626656267469143, 55.26222090179646],
            [-2.635757302121315, 55.26111980154842],
            [-2.640972788131767, 55.260985608807836],
            [-2.646818030162456, 55.259817108840245],
            [-2.640416912063311, 55.2564631801023],
            [-2.634764893108722, 55.254541002870425],
            [-2.629086589963823, 55.25111713798518],
            [-2.624088676453096, 55.24949481958042],
            [-2.612013178129066, 55.24768692791635],
            [-2.614604105302558, 55.245668189482096],
            [-2.617839633978831, 55.247201921663915],
            [-2.620451882026399, 55.24717249278741],
            [-2.630116022052168, 55.244893560337005],
            [-2.631524602320901, 55.23860062331279],
            [-2.633568241530781, 55.23539104653601],
            [-2.633287774898088, 55.2342629330547],
            [-2.635805858226033, 55.22976587758254],
            [-2.634657165014, 55.22546487619115],
            [-2.631414403246185, 55.22369805509795],
            [-2.638967211573388, 55.22268195316199],
            [-2.642125552700623, 55.220937317032174],
            [-2.647976107909048, 55.219876602842334],
            [-2.65999143220589, 55.21988403759963],
            [-2.666814981724957, 55.22158035552778],
            [-2.683331556537297, 55.201890374365455],
            [-2.681250146888719, 55.19860150713867],
            [-2.682002681176703, 55.19712895170854],
            [-2.685108132021247, 55.19555604470362],
            [-2.686241589443341, 55.194050774198146],
            [-2.684775989608395, 55.19276773711349],
            [-2.687352256337203, 55.189678186306246],
            [-2.692655460860036, 55.18636737470038],
            [-2.693738727133162, 55.18453704071312],
            [-2.699918816337187, 55.177838523176696],
            [-2.700987204090755, 55.175369837081035],
            [-2.705743924986913, 55.172250441756724],
            [-2.713493296302886, 55.17213448807238],
            [-2.719811175947341, 55.1704618538502],
            [-2.724574867015055, 55.16872497787302],
            [-2.729422635575017, 55.16829673946318],
            [-2.733766174998655, 55.16670735430164],
            [-2.73504728015402, 55.16447778082351],
            [-2.737844504696609, 55.16273682157712],
            [-2.741411337228548, 55.16214889275233],
            [-2.740905571847049, 55.16126639858065],
            [-2.745428168355728, 55.16002797788014],
            [-2.746372586688909, 55.15819984554287],
            [-2.748759699874761, 55.15813399277761],
            [-2.751404249591009, 55.1564193804453],
            [-2.757613486088785, 55.15483520017334],
            [-2.760279654827848, 55.15479910879673],
            [-2.76133990409119, 55.15340281434126],
            [-2.765335914147309, 55.15271780093672],
            [-2.766208506628465, 55.150935821612315],
            [-2.774753987541489, 55.14933529287871],
            [-2.775394152893205, 55.147963831713874],
            [-2.781854282706933, 55.14578657923555],
            [-2.78558506793509, 55.14163326662679],
            [-2.790172980052722, 55.14157509104619],
            [-2.790639097303721, 55.13995913182967],
            [-2.792935070067382, 55.14017022092199],
            [-2.796967789394163, 55.13883044019301],
            [-2.801910182167417, 55.1388615913347],
            [-2.803874798910912, 55.13764450723167],
            [-2.813553720292738, 55.136896473979704],
            [-2.819146228199168, 55.13837588426414],
            [-2.825502778650569, 55.13831404347486],
            [-2.827279970433026, 55.136187634438244],
            [-2.832781673507827, 55.1329088151301],
            [-2.832527868092602, 55.13110979214662],
            [-2.826708239646771, 55.12681897513911],
            [-2.82754824206844, 55.12489743595884],
            [-2.832620474354978, 55.12146968106143],
            [-2.835494811625547, 55.12133321760664],
            [-2.840239424115329, 55.12251903339433],
            [-2.842148567624371, 55.121516488578166],
            [-2.837883353912022, 55.1176126944045],
            [-2.840954529161817, 55.11804799058072],
            [-2.846285733743565, 55.11480301892558],
            [-2.844502380089136, 55.11193802359017],
            [-2.850495751199455, 55.11084676769296],
            [-2.852367205201896, 55.1084091796174],
            [-2.861523099057461, 55.10805361679364],
            [-2.864012104612702, 55.106662835511635],
            [-2.86757799836584, 55.107100332631724],
            [-2.871064616711438, 55.10604565150355],
            [-2.87268055229775, 55.10158500582407],
            [-2.871324709818752, 55.10042287977709],
            [-2.87687272101872, 55.09519884821942],
            [-2.87897630031114, 55.09480268777571],
            [-2.883699190930539, 55.09544516741115],
            [-2.886292649908839, 55.0948098635219],
            [-2.885539800751551, 55.093435084043726],
            [-2.882374587860746, 55.09307795363426],
            [-2.883212042969759, 55.090616817454894],
            [-2.8861953339258, 55.08942061835981],
            [-2.883791460216435, 55.08754737090567],
            [-2.886344824537396, 55.08668138321539],
            [-2.889722336369962, 55.087167213607415],
            [-2.89007483236126, 55.088085739475396],
            [-2.893112595469116, 55.087943121460384],
            [-2.892571954727896, 55.08519096811571],
            [-2.896277416457758, 55.07848327760281],
            [-2.899862151586007, 55.07698854087074],
            [-2.906174996025683, 55.07757437073256],
            [-2.910763771126623, 55.07713627226335],
            [-2.91225747154825, 55.078810244149956],
            [-2.915076565665275, 55.07894776813768],
            [-2.917329683363844, 55.077931055209056],
            [-2.917066756260925, 55.07532973303972],
            [-2.921169317697717, 55.072477880515116],
            [-2.926079489754196, 55.070584510982926],
            [-2.930402718359945, 55.070435543529555],
            [-2.934880492727247, 55.07113785241799],
            [-2.939123108386085, 55.06985349596218],
            [-2.94217065272454, 55.06792215758941],
            [-2.943129978759659, 55.06456727979855],
            [-2.941258531681335, 55.06221749530857],
            [-2.936305356435489, 55.059767354084144],
            [-2.943667561125307, 55.05819988840624],
            [-2.948194166855826, 55.055507478426506],
            [-2.955423551951236, 55.05462067764911],
            [-2.958593767408618, 55.04929456149941],
            [-2.964397011275905, 55.050057549803086],
            [-2.971191302963719, 55.05016704442332],
            [-3.000075773309423, 55.05246641867052],
            [-3.021197576232756, 55.05488986973916],
            [-3.034173030400769, 55.055415642446285],
            [-3.039658241027089, 55.05522516271055],
            [-3.043171442648389, 55.05566064883817],
            [-3.048056690951479, 55.05305742793963],
            [-3.05077841260355, 55.05286415999975],
            [-3.051195262516588, 55.051266348769474],
            [-3.053447005937086, 55.04950703633317],
            [-3.05371320499082, 55.04760318317386],
            [-3.050833894455729, 55.048821513129674],
            [-3.046936230674751, 55.0473714058621],
            [-3.0433881242951, 55.047374030295266],
            [-3.04365586456754, 55.04475210678851],
            [-3.039761630103346, 55.044714555050106],
            [-3.038498827644789, 55.04369631651852],
            [-3.040329991236971, 55.04146639671341],
            [-3.038146902363505, 55.04134489391232],
            [-3.035890240126139, 55.039404776705474],
            [-3.03217633056816, 55.03986887596546],
            [-3.031571705137959, 55.0383220320278],
            [-3.025875117784356, 55.036458784923184],
            [-3.026288276950537, 55.035053357296654],
            [-3.030145310938736, 55.03408076788282],
            [-3.032472076862981, 55.03074147156334],
            [-3.034358096459809, 55.029439485347076],
            [-3.032237521372479, 55.028311684364866],
            [-3.030237939583159, 55.024645930318066],
            [-3.034101341609805, 55.02414858636707],
            [-3.036422142275856, 55.02200169914283],
            [-3.039109510996832, 55.02285767093117],
            [-3.042330261056914, 55.019662363644116],
            [-3.040656955893306, 55.01876904164004],
            [-3.039911768329364, 55.0160812102823],
            [-3.041790787235338, 55.01574790540733],
            [-3.041947596041794, 55.01419727282552],
            [-3.04518056278448, 55.012651776072936],
            [-3.045745777379954, 55.01051528506077],
            [-3.04945688466868, 55.00939499684439],
            [-3.048499308257283, 55.00673518703591],
            [-3.045215919985923, 55.007939815281055],
            [-3.045014601981899, 55.006152289914304],
            [-3.046775073294361, 55.004826024231086],
            [-3.046442686759401, 55.00059076539197],
            [-3.044524597680641, 54.9982456219988],
            [-3.048648318348747, 54.99728271665697],
            [-3.052735067181069, 54.99455588596715],
            [-3.051957479539632, 54.993277538187506],
            [-3.058123982763227, 54.991681035921424],
            [-3.056041450498786, 54.987254371351995],
            [-3.057005984259777, 54.985658062488554],
            [-3.064891011320673, 54.98525479664352],
            [-3.07120352618583, 54.98225546876855],
            [-3.072334411862635, 54.98040007700021],
            [-3.075204372442819, 54.979097536863385],
            [-3.086549297510346, 54.978492105439],
            [-3.090008754994291, 54.97746458650781],
            [-3.090230732729001, 54.974258561143735],
            [-3.094051681717539, 54.974394977054004],
            [-3.099084983949353, 54.977216335657346],
            [-3.104883028308762, 54.97769186656865],
            [-3.114850913235927, 54.97592527978747],
            [-3.11814878584787, 54.9748666104537],
            [-3.12211812062008, 54.971947976903856],
            [-3.124685499423981, 54.96932541495729],
            [-3.131687430413421, 54.96547197555662],
            [-3.137137619563209, 54.96078162342816],
            [-3.140148306709821, 54.95590345579445],
            [-3.14309569033379, 54.95390063041364],
            [-3.147665747280001, 54.95242233163395],
            [-3.150899841396718, 54.95225181636933],
            [-3.157496509564664, 54.95366345160277],
            [-3.163116596377355, 54.95582372812773],
            [-3.169199115739689, 54.95713969829842],
            [-3.175355778710142, 54.95895403568393],
            [-3.180833107392865, 54.959280342164625],
            [-3.185383205191959, 54.95778751184456],
            [-3.194360458815506, 54.96081480848164],
            [-3.205318809748164, 54.961306369353004],
            [-3.213687758239759, 54.960889959517544],
            [-3.222644573766395, 54.9598173337632],
            [-3.244169984899031, 54.95788998593036],
            [-3.253106977110798, 54.957808823855636],
            [-3.264723449712831, 54.95999653558494],
            [-3.267046677810443, 54.9601446501207],
            [-3.282166259049789, 54.962345477641946],
            [-3.28759089879729, 54.96390582128933],
            [-3.294207136844308, 54.96644752261064],
            [-3.297466908166055, 54.96687808343654],
            [-3.304233299488768, 54.966365162441406],
            [-3.312116595147553, 54.964042525524626],
            [-3.316223511546685, 54.96185571824231],
            [-3.324753581881365, 54.955502242140305],
            [-3.320775302441601, 54.95328623187139],
            [-3.331841674556526, 54.94893801274428],
            [-3.338743133742939, 54.946593788982454],
            [-3.338586263894368, 54.94506951025162],
            [-3.334275614859607, 54.94280549095793],
            [-3.32946473596973, 54.94376502174374],
            [-3.327216290947126, 54.94489046301281],
            [-3.321189847621814, 54.94945238808455],
            [-3.317215852892096, 54.95130552981317],
            [-3.303888153172757, 54.944083638544406],
            [-3.312612631526124, 54.93947222718897],
            [-3.316648942734445, 54.93813571417543],
            [-3.322407033096779, 54.932363840413856],
            [-3.327690791491729, 54.92812275384129],
            [-3.332556715231381, 54.927423651111624],
            [-3.335036555983757, 54.924497720408894],
            [-3.333209618554549, 54.921734412923634],
            [-3.332143572004651, 54.92259957270137],
            [-3.331447226094554, 54.9193009921272],
            [-3.335097567631387, 54.91505510722337],
            [-3.340136257046504, 54.91164726100987],
            [-3.341762021284352, 54.9095686874153],
            [-3.346373143969148, 54.90777996565335],
            [-3.350754145484388, 54.90710082911377],
            [-3.363470091427695, 54.90429837436491],
            [-3.374108220157384, 54.897908629308134],
            [-3.37837050502685, 54.894019216134474],
            [-3.381109727207295, 54.89027824599634],
            [-3.38419618375196, 54.88884713862958],
            [-3.387842954657958, 54.889516724251656],
            [-3.388225899202929, 54.891510717668034],
            [-3.392429650036237, 54.89074304585927],
            [-3.39118843071931, 54.88897155210066],
            [-3.396362329948513, 54.883481733617],
            [-3.395465358977045, 54.88235067211506],
            [-3.392658368654796, 54.88204048007125],
            [-3.395100742559113, 54.878721491091156],
            [-3.390385409427922, 54.87831426222714],
            [-3.387086791107962, 54.880249513271174],
            [-3.386210114433166, 54.88186219450001],
            [-3.376589141772947, 54.889509449748985],
            [-3.371812370576672, 54.892932797246864],
            [-3.369873280740808, 54.89306357220766],
            [-3.371854614731961, 54.89026199062291],
            [-3.37950878027759, 54.883937928832914],
            [-3.383897514989023, 54.8781711466431],
            [-3.387713708519509, 54.87497170006492],
            [-3.393441176137721, 54.87143500895444],
            [-3.398115031291099, 54.8694557818679],
            [-3.399780157215849, 54.86939919433076],
            [-3.407200755342185, 54.865339930408204],
            [-3.412994061115783, 54.86318446561568],
            [-3.413972689587532, 54.86101251128126],
            [-3.422653184226147, 54.85306280719262],
            [-3.425138199983904, 54.84996146963105],
            [-3.429585184036176, 54.84700141029712],
            [-3.430197811041077, 54.84570312113845],
            [-3.436189151409838, 54.84144309654121],
            [-3.441772614359871, 54.83860603606961],
            [-3.44557410183237, 54.83727707623219],
            [-3.445061464014114, 54.83493779271391],
            [-3.451874677575693, 54.83143000482679],
            [-3.461152957639297, 54.82504791248947],
            [-3.463168528694506, 54.819042969308086],
            [-3.463181901947995, 54.817320608493986],
            [-3.460080493763849, 54.81516534805064],
            [-3.461792304700405, 54.81089197736641],
            [-3.458474126252912, 54.81058355399891],
            [-3.459262759375783, 54.808476738780776],
            [-3.452782590680086, 54.808929041942214],
            [-3.451796501553412, 54.80829523671599],
            [-3.454497033613664, 54.80645803985282],
            [-3.45292413800426, 54.804957393247946],
            [-3.450384500607349, 54.80540927799309],
            [-3.450931449942807, 54.80344094260195],
            [-3.446663376371764, 54.80394670217968],
            [-3.444030455635389, 54.80179221748909],
            [-3.445240566582866, 54.79940832512322],
            [-3.448521932374749, 54.79828856109119],
            [-3.447233222231018, 54.79505677153803],
            [-3.447328407108079, 54.79199297255809],
            [-3.445984600157327, 54.790026526482606],
            [-3.443428302746641, 54.78842032175892],
            [-3.441283912400272, 54.78495315745138],
            [-3.440350127786431, 54.78183372227131],
            [-3.44094207806091, 54.780182222203514],
            [-3.439835379373533, 54.77722921594475],
            [-3.441425865802152, 54.775969226090524],
            [-3.441178382019056, 54.77035866495319],
            [-3.440479316020574, 54.76827050241214],
            [-3.44145073037111, 54.76628544563861],
            [-3.441202482253833, 54.763472726692534],
            [-3.442790223649108, 54.759896444321804],
            [-3.443431513577537, 54.760451596638255],
            [-3.446726693044901, 54.7572971629807],
            [-3.450601522428842, 54.75476348470384],
            [-3.455194457987986, 54.7508422095586],
            [-3.459400587180689, 54.74911945087954],
            [-3.468723765514426, 54.74383877210501],
            [-3.478434258712349, 54.739213865158554],
            [-3.483220412940297, 54.736254156850784],
            [-3.48573844708815, 54.73387662504997],
            [-3.492892982901633, 54.73117438450503],
            [-3.49745025033056, 54.72853187518975],
            [-3.500346095664465, 54.7277948846382],
            [-3.49968512514528, 54.72670873875187],
            [-3.502485270880718, 54.72485051714286],
            [-3.505660172120482, 54.7210084321724],
            [-3.510765274932579, 54.71773760066763],
            [-3.515341793387615, 54.70858923627293],
            [-3.516426351241784, 54.703458625171365],
            [-3.520383508179304, 54.69774145942072],
            [-3.523626250750093, 54.69616269799768],
            [-3.526251709070186, 54.69333684430011],
            [-3.528593518124525, 54.69255141244421],
            [-3.530892687486536, 54.688909052351185],
            [-3.535141689612004, 54.68585168006731],
            [-3.540000559369771, 54.68314790331716],
            [-3.543768888928486, 54.681946855353054],
            [-3.548322456346069, 54.678901892719765],
            [-3.551653539203583, 54.678270722058315],
            [-3.551834833579921, 54.67587175212592],
            [-3.554570938347357, 54.67243333192554],
            [-3.553711919755599, 54.67163671434435],
            [-3.558550934707585, 54.67023182916815],
            [-3.563202196796435, 54.6652967393329],
            [-3.562480461963341, 54.66214804070408],
            [-3.563931877145039, 54.65991897364239],
            [-3.570437077477246, 54.65719956023952],
            [-3.573757596481737, 54.655032687910385],
            [-3.577328919161975, 54.65450720951148],
            [-3.576546923815058, 54.6536157373819],
            [-3.580234823652682, 54.652290427170726],
            [-3.578326266743923, 54.649842938523705],
            [-3.577136728825604, 54.64596587582966],
            [-3.577682571396528, 54.64062832963205],
            [-3.576450344810312, 54.63660898030605],
            [-3.576671602742672, 54.634586482262606],
            [-3.574261242057022, 54.63149485066047],
            [-3.574830535434588, 54.63028855387335],
            [-3.572729313611711, 54.626606582327796],
            [-3.573303378371834, 54.623099281153586],
            [-3.574365203231558, 54.621644555393544],
            [-3.574513027307794, 54.61664603457725],
            [-3.57243286432382, 54.61245865413496],
            [-3.572083313577406, 54.60878211686538],
            [-3.573768260731187, 54.60750548572232],
            [-3.57505265481291, 54.601643606536086],
            [-3.578797716391251, 54.5987985903576],
            [-3.578146196091259, 54.597338719535166],
            [-3.57972751373567, 54.59652082852533],
            [-3.57946766701654, 54.59415452422362],
            [-3.581163725575018, 54.594076808049564],
            [-3.583634606096478, 54.59174478240696],
            [-3.583833360149393, 54.58799200112489],
            [-3.585059210797286, 54.583328297464945],
            [-3.584007053673834, 54.581695472879815],
            [-3.58440267595039, 54.57633878952711],
            [-3.586372512494253, 54.575589413932455],
            [-3.584440731265192, 54.571843876082404],
            [-3.585325223029959, 54.568804180559475],
            [-3.585341767274179, 54.56524394803014],
            [-3.590775315212375, 54.561286564940666],
            [-3.591834508322365, 54.55939500851744],
            [-3.591120204931458, 54.55763243723819],
            [-3.59373959063504, 54.55266960067295],
            [-3.598779150396267, 54.55295486328728],
            [-3.599752350019696, 54.55004839749135],
            [-3.604251010656075, 54.54296992435194],
            [-3.604284083179177, 54.540467118561],
            [-3.605964440901299, 54.53484883185836],
            [-3.607609219408461, 54.53126348984833],
            [-3.612598237805225, 54.52767179420536],
            [-3.614578107499426, 54.52520952570432],
            [-3.623645665395921, 54.5228423687274],
            [-3.62606048269754, 54.52120300238117],
            [-3.638558862780682, 54.518286472879396],
            [-3.640550448136475, 54.51555692470431],
            [-3.639893553597047, 54.51187332499784],
            [-3.636994029395045, 54.507420246612035],
            [-3.633709462456081, 54.504313721645936],
            [-3.630718620376933, 54.50354821780622],
            [-3.627194365600489, 54.50056566460495],
            [-3.624408345111418, 54.497032066549785],
            [-3.620687894383412, 54.49107936598089],
            [-3.617340632016774, 54.48947577096336],
            [-3.61161772668573, 54.489561043041526],
            [-3.605098506877524, 54.48592635646195],
            [-3.597687073928413, 54.481241935057085],
            [-3.593265368205769, 54.47648238192915],
            [-3.593555254114479, 54.47463756327067],
            [-3.590598320459159, 54.47390189289669],
            [-3.58774127198827, 54.471670926792335],
            [-3.587382144375332, 54.46987548913453],
            [-3.585254388899547, 54.46846735405396],
            [-3.584897911030782, 54.466206055762775],
            [-3.581976950307749, 54.46425547254491],
            [-3.582137094948204, 54.4627306895396],
            [-3.576452612570441, 54.45806410886496],
            [-3.570859094695116, 54.45443357468467],
            [-3.5708061232957, 54.45347738666491],
            [-3.565936030386985, 54.44860989469724],
            [-3.562212892098708, 54.447585181982454],
            [-3.557909205186065, 54.44520622783644],
            [-3.556872681522108, 54.4444542656021],
            [-3.644885270499401, 54.38445513774272],
            [-3.2168883385853917, 53.98835098136297],
            [-3.4789272764914756, 53.57029280356497],
            [-3.2443659377652403, 53.44465676690021],
            [-3.263756776797607, 53.4494957504595],
            [-3.261947718985969, 53.445108449255414],
            [-3.242923882981203, 53.4005531583847],
            [-3.240422295178804, 53.394392097679905],
            [-3.229067170106632, 53.36757901798651],
            [-3.213435937959857, 53.3565229946081],
            [-3.203424790112372, 53.35022956672234],
            [-3.19897597975232, 53.34698327384882],
            [-3.204975155965984, 53.34941557537217],
            [-3.204549102883204, 53.34687503557439],
            [-3.201552372284894, 53.34532675128955],
            [-3.204841644815879, 53.34376629005029],
            [-3.211360939558362, 53.34233177728688],
            [-3.211064782587223, 53.34095523804499],
            [-3.216520009291337, 53.33847966269064],
            [-3.186797595466751, 53.32159288526026],
            [-3.170884259020438, 53.31394105459595],
            [-3.165791390203885, 53.31124826540474],
            [-3.144279015683546, 53.29647333515846],
            [-3.131026222371075, 53.28803919473142],
            [-3.121831951486635, 53.28283142556116],
            [-3.113709900742549, 53.277711725125414],
            [-3.099528676961114, 53.265350051082315],
            [-3.095091724497656, 53.2618159110174],
            [-3.090410699867145, 53.25890588802949],
            [-3.086035349112821, 53.25680097367891],
            [-3.080523154014559, 53.25494445590292],
            [-3.069136643946185, 53.25300473613202],
            [-3.036024312516703, 53.2518049487822],
            [-3.025462473875721, 53.248315034973764],
            [-3.008225103961502, 53.24019208624761],
            [-2.998378413415403, 53.23585860665535],
            [-2.992559341263562, 53.233015334478694],
            [-2.984911835180632, 53.228471012102744],
            [-2.977837083401857, 53.22539385517228],
            [-2.966163085103289, 53.21868960792778],
            [-2.953307469623907, 53.21309576658591],
            [-2.949215257998678, 53.21107524699294],
            [-2.943732343625113, 53.20400387856262],
            [-2.937566325776249, 53.19785894088232],
            [-2.935369747485983, 53.19632016113724],
            [-2.929238178185991, 53.19429068419609],
            [-2.922299474144674, 53.189292640871585],
            [-2.920332258485783, 53.18331561542352],
            [-2.920955974103256, 53.177085705624535],
            [-2.922850551568968, 53.17529122661464],
            [-2.926589542494455, 53.17335738099116],
            [-2.927838681377076, 53.171411380499805],
            [-2.933907451625108, 53.169388945624746],
            [-2.944041267746742, 53.165247691102316],
            [-2.946553313795628, 53.16711191941346],
            [-2.948907449490897, 53.16600732024905],
            [-2.953479110092359, 53.165351446988105],
            [-2.956784736643535, 53.16380572705842],
            [-2.962372567041454, 53.16232148023671],
            [-2.966263043172538, 53.15986472299901],
            [-2.970926148736983, 53.1607823656837],
            [-2.975574267400881, 53.15733740542991],
            [-2.981492088668483, 53.15629187864432],
            [-2.984640435529545, 53.15859499961331],
            [-2.988124306161747, 53.15692830057884],
            [-2.989956945901505, 53.157542335948534],
            [-2.992274261093717, 53.15666454263014],
            [-2.993059663126977, 53.15492489241745],
            [-2.995088493468779, 53.15419593344768],
            [-2.987699369773927, 53.15209557724799],
            [-2.984448732461022, 53.147792316836096],
            [-2.980345078566467, 53.1493983943561],
            [-2.979498209958147, 53.15062162901941],
            [-2.963895789345383, 53.13277030415618],
            [-2.96015863586503, 53.13248317450543],
            [-2.957940919204677, 53.13034729654921],
            [-2.946451663099698, 53.12686680953813],
            [-2.944980459800401, 53.12227780406416],
            [-2.942613218064641, 53.12138065752534],
            [-2.940601911533006, 53.122407828051905],
            [-2.938034930734881, 53.12097989190318],
            [-2.934410408288784, 53.121485764331815],
            [-2.931925169585744, 53.120093898566],
            [-2.928584445017886, 53.11983683441224],
            [-2.92313815454485, 53.118102990018045],
            [-2.917378587869725, 53.114833165216865],
            [-2.909637641154935, 53.11269560772153],
            [-2.908022465774225, 53.113114221427864],
            [-2.903391818063997, 53.11179750553178],
            [-2.899194376233831, 53.114113403215235],
            [-2.897066938933488, 53.11397488358271],
            [-2.895251060700131, 53.11638500443191],
            [-2.890427076120796, 53.11922760456266],
            [-2.888033617643854, 53.1198208037171],
            [-2.886499928958089, 53.121383768492116],
            [-2.88543163084643, 53.12044965463175],
            [-2.880942485788024, 53.12137470172364],
            [-2.881619812377813, 53.118255830650575],
            [-2.88413925698132, 53.11325085024542],
            [-2.883878999439977, 53.111343493685446],
            [-2.886831897193913, 53.11073363117549],
            [-2.889087748411399, 53.10885604191101],
            [-2.891817428705032, 53.10923750468517],
            [-2.892814532806964, 53.104081883170885],
            [-2.887492385951175, 53.10566602565806],
            [-2.88730395440486, 53.104422427879776],
            [-2.8903513377765, 53.09966778283403],
            [-2.893796405723063, 53.09611373558066],
            [-2.896791360780568, 53.09521474585185],
            [-2.897883045802259, 53.09657463672131],
            [-2.893914171981517, 53.09783153848529],
            [-2.897535713081898, 53.09889921496275],
            [-2.899519694235372, 53.09764013364811],
            [-2.899452314247251, 53.09384002709236],
            [-2.901999430770788, 53.09310523912645],
            [-2.900506404299716, 53.09075863504357],
            [-2.895789691719744, 53.09185581456078],
            [-2.893449904186298, 53.09150485847663],
            [-2.890865911467194, 53.08742606031096],
            [-2.879638920228432, 53.08345813042637],
            [-2.876048232963007, 53.08176322865932],
            [-2.876048641353412, 53.08060808647173],
            [-2.879007385882081, 53.07811243462552],
            [-2.879605177401597, 53.07616906384042],
            [-2.881782382319874, 53.07496545772494],
            [-2.88072711283177, 53.07394492891318],
            [-2.875671178263337, 53.073562472192314],
            [-2.87779862273092, 53.071016333403634],
            [-2.877652953158813, 53.06892018933022],
            [-2.87296789461578, 53.0702392034008],
            [-2.869153353596708, 53.06951386170749],
            [-2.867360851723746, 53.06669083535427],
            [-2.865818948171201, 53.06578514892355],
            [-2.870478672610534, 53.0646328496119],
            [-2.869626976329029, 53.063767095716685],
            [-2.864111535308503, 53.063322797685075],
            [-2.861604098306422, 53.060914745351866],
            [-2.862419284235393, 53.06011423483509],
            [-2.865160449018905, 53.06078559610982],
            [-2.868292992385594, 53.05955370733991],
            [-2.869679562185068, 53.05993998644097],
            [-2.872555014633621, 53.05861550460077],
            [-2.870287362538306, 53.05685758160317],
            [-2.86761491327617, 53.0570739959945],
            [-2.86567613121854, 53.05874842014946],
            [-2.863161375087184, 53.05865075894834],
            [-2.860886374636397, 53.05732515641725],
            [-2.863027284020379, 53.05657336356242],
            [-2.865598638683568, 53.05727209937007],
            [-2.867494889328478, 53.055999783665854],
            [-2.866498929329075, 53.05514224336826],
            [-2.860456611158043, 53.054782495842296],
            [-2.859913631173955, 53.052617286493835],
            [-2.861664442506617, 53.052212617638446],
            [-2.863732081062393, 53.053324926246596],
            [-2.868551857968437, 53.050550762016265],
            [-2.866082624823656, 53.05009326891762],
            [-2.864827200768979, 53.0518381976765],
            [-2.863007542858102, 53.05163393091538],
            [-2.863118897838014, 53.048622539748536],
            [-2.870109567411534, 53.04545587877008],
            [-2.869596024547163, 53.04454270400043],
            [-2.864998311196045, 53.045560550529075],
            [-2.866560068722744, 53.04407408338772],
            [-2.864185330291491, 53.04332270955521],
            [-2.862380076335353, 53.04419701919104],
            [-2.861026194251068, 53.042799932425766],
            [-2.866684998210692, 53.04070929737026],
            [-2.861873162317161, 53.03860384452679],
            [-2.858796287644416, 53.03890298124358],
            [-2.855737082124418, 53.037154068511406],
            [-2.855530082393105, 53.034463263626556],
            [-2.85639331881218, 53.032643857636515],
            [-2.860454375348474, 53.02877786765007],
            [-2.860073223719573, 53.025434710196194],
            [-2.861044479565492, 53.02284862018975],
            [-2.858617146700853, 53.01983757749067],
            [-2.851627477405266, 53.01698784062052],
            [-2.847913670447793, 53.019015398081365],
            [-2.844062197786045, 53.01766833169927],
            [-2.843163519504094, 53.015162146324876],
            [-2.840384473320032, 53.01351878619502],
            [-2.837751498020129, 53.01056179628423],
            [-2.840700515747775, 53.010457408528985],
            [-2.840621282212177, 53.007222677762904],
            [-2.839357058874593, 53.00635960590424],
            [-2.838042347483032, 53.00304092857488],
            [-2.836197591283333, 53.00157790077936],
            [-2.834899519489789, 52.998254578071],
            [-2.835995770191975, 52.99715011099914],
            [-2.832472705702899, 52.9966481023263],
            [-2.82786236278098, 52.994372623010946],
            [-2.824286689660872, 52.99336189713057],
            [-2.820820738571696, 52.99442862401987],
            [-2.815424611806397, 52.99318295473865],
            [-2.809910209014447, 52.99267594199492],
            [-2.810237046200143, 52.99175588165631],
            [-2.803712160231751, 52.99145766794167],
            [-2.802724176248566, 52.98975448580321],
            [-2.80118051945692, 52.99094523991238],
            [-2.798202002688547, 52.989469383129304],
            [-2.796102051526494, 52.991681393312845],
            [-2.794503015983147, 52.9907661552808],
            [-2.791937530778025, 52.991087110517064],
            [-2.793986213372691, 52.99320668712878],
            [-2.790048060961938, 52.99571222641023],
            [-2.78524180287133, 52.993916466335186],
            [-2.783407655403868, 52.9957201895343],
            [-2.780920942566216, 52.996131139445026],
            [-2.781586678449962, 52.99422189324254],
            [-2.779736049000122, 52.993381787633375],
            [-2.775972271942146, 52.99469006793064],
            [-2.773527672294582, 52.9947086651101],
            [-2.771226911872894, 52.99334821200415],
            [-2.768275538742738, 52.99486047875699],
            [-2.764411431579485, 52.99354760137885],
            [-2.761013824912316, 52.99096238092294],
            [-2.76158167635063, 52.987423163503],
            [-2.758707543259421, 52.98619732799183],
            [-2.753403001093407, 52.986187836527236],
            [-2.750775365507487, 52.98687772423735],
            [-2.743741573313661, 52.98714748363464],
            [-2.740959027151946, 52.98654183194204],
            [-2.737269707221444, 52.98473351232647],
            [-2.734787690941302, 52.98505448594843],
            [-2.727486332938302, 52.98401417947865],
            [-2.726733472227458, 52.98131295956133],
            [-2.72957673259181, 52.97972331032514],
            [-2.72927198922472, 52.97887293537394],
            [-2.732079739715319, 52.9769553253764],
            [-2.730727656997876, 52.9748510439525],
            [-2.735293765222242, 52.96994615119753],
            [-2.73288407734968, 52.96754996726492],
            [-2.728258943663614, 52.96681697557239],
            [-2.72677761457974, 52.96531578911225],
            [-2.72806725232385, 52.9620590687426],
            [-2.727395890192069, 52.95931966598913],
            [-2.724326770644132, 52.95749196118664],
            [-2.724175550891491, 52.95645823111685],
            [-2.727802082794789, 52.953735650425884],
            [-2.72728274927008, 52.948257946580256],
            [-2.728172265705194, 52.94708304860243],
            [-2.726151548626321, 52.94594562867811],
            [-2.725605423304124, 52.94054185954929],
            [-2.727014086963664, 52.939800649749145],
            [-2.726516117485275, 52.93796804427831],
            [-2.727054197052265, 52.93430963180762],
            [-2.725839283869946, 52.93061789837703],
            [-2.726568146771077, 52.92795083048184],
            [-2.728541603141881, 52.92517808888669],
            [-2.744573247677816, 52.92443692754339],
            [-2.755326640545249, 52.92462801271078],
            [-2.776212287413883, 52.91174460668862],
            [-2.781661024658003, 52.90870018111757],
            [-2.793187716632863, 52.901220937935854],
            [-2.79273225154226, 52.8993999803404],
            [-2.794588923292567, 52.89720130788502],
            [-2.800446714112248, 52.89548581321242],
            [-2.801439882889443, 52.89676337469307],
            [-2.802732817224008, 52.901324103550124],
            [-2.807253684917787, 52.90658193479086],
            [-2.812282580452809, 52.90881489912432],
            [-2.813116953844169, 52.91024925948395],
            [-2.812385693851636, 52.91415664935743],
            [-2.817957036961334, 52.9176450014345],
            [-2.819095804025486, 52.91888041180281],
            [-2.822510590065565, 52.919890607053276],
            [-2.824865760324308, 52.92352407537535],
            [-2.834768689978711, 52.92982774099814],
            [-2.835872757099929, 52.9321572671167],
            [-2.838496237080026, 52.932183829708684],
            [-2.841851908477726, 52.93804828210458],
            [-2.840612942405712, 52.93907384462869],
            [-2.840275909691006, 52.942029289108696],
            [-2.842575617821602, 52.94205704709514],
            [-2.849824654714588, 52.94489199005078],
            [-2.854839069273603, 52.943725192908715],
            [-2.866856428425868, 52.94538478471969],
            [-2.869801151005287, 52.94477084324822],
            [-2.883702910300791, 52.94669368789454],
            [-2.886047115937746, 52.948379721907024],
            [-2.88743151455419, 52.95252985453424],
            [-2.890307755097252, 52.95045505949666],
            [-2.892501253896302, 52.951159543287545],
            [-2.898292142048346, 52.950275423255874],
            [-2.901090017441048, 52.947898898364585],
            [-2.902400889460072, 52.944885549751135],
            [-2.908663738826915, 52.94192956477972],
            [-2.914157607482977, 52.94241152385507],
            [-2.918850319732606, 52.94356735286502],
            [-2.927445629452828, 52.94188689429129],
            [-2.927285715246756, 52.93879387406624],
            [-2.929207511141141, 52.93876177512919],
            [-2.9326714302374, 52.9406952498003],
            [-2.943286157721676, 52.94481495308097],
            [-2.951156891579479, 52.947104824689426],
            [-2.959497834104065, 52.951029177295524],
            [-2.962401125156357, 52.953618961079904],
            [-2.961824305048971, 52.95565885848674],
            [-2.966076725232355, 52.95644334138047],
            [-2.968576414147518, 52.958921223884815],
            [-2.970573896349854, 52.95877181550939],
            [-2.972759341048322, 52.960368559103145],
            [-2.968486958403864, 52.96417555239882],
            [-2.9747702686677, 52.96895157122158],
            [-2.979493739053611, 52.965210734104765],
            [-2.979579152080689, 52.96266955004745],
            [-2.981656620968351, 52.9594736476883],
            [-2.985199798177086, 52.95869279969774],
            [-2.990171707707624, 52.959788577685316],
            [-2.993798596780389, 52.95812036506739],
            [-2.997540086616915, 52.95833352564182],
            [-3.003543958910108, 52.95795211130055],
            [-3.009936069585784, 52.955838322386526],
            [-3.012470281735512, 52.94968847383982],
            [-3.014320181672691, 52.94822350056583],
            [-3.017039292147064, 52.94870789365549],
            [-3.017028534594924, 52.94706129417558],
            [-3.020188127122392, 52.9457922894547],
            [-3.020894427899264, 52.943321496336544],
            [-3.024022227353973, 52.942251205405],
            [-3.023029570455778, 52.94070920982864],
            [-3.025588984070518, 52.9382482021439],
            [-3.023868318843297, 52.93644136864695],
            [-3.02821575843068, 52.93682640124584],
            [-3.029109870817934, 52.93427607584526],
            [-3.031082720854604, 52.933812074472414],
            [-3.031320244797088, 52.931550705801875],
            [-3.03512365438524, 52.92946245418369],
            [-3.040829119319948, 52.92793493378274],
            [-3.045200990659684, 52.92914089892129],
            [-3.048176502524178, 52.92789835158134],
            [-3.051195930380592, 52.92919323690966],
            [-3.054922477804185, 52.92900098571411],
            [-3.056432417000468, 52.92802836212609],
            [-3.061514001080861, 52.92910779608883],
            [-3.06340282729525, 52.92654133860025],
            [-3.069770218005153, 52.92680149008554],
            [-3.076220195613197, 52.92547836667606],
            [-3.08435670410854, 52.92659101776668],
            [-3.085602245666403, 52.928394682183985],
            [-3.088288512795398, 52.9293850159843],
            [-3.094231872296714, 52.92968099620494],
            [-3.095953393614294, 52.930281821743435],
            [-3.099734063333859, 52.928006647199524],
            [-3.102522221781689, 52.92462491201777],
            [-3.106139165451174, 52.92132447559121],
            [-3.10850629543481, 52.920068126300905],
            [-3.112912243911095, 52.91149749188316],
            [-3.11275544173413, 52.906366734484465],
            [-3.114696391781393, 52.90453169449131],
            [-3.116881906680897, 52.89949577855214],
            [-3.113813490166457, 52.89532899124748],
            [-3.115335004071228, 52.89460634946449],
            [-3.121869314542662, 52.89544743565552],
            [-3.126655771370182, 52.89434679285731],
            [-3.129627099081702, 52.89427904587591],
            [-3.133395733299044, 52.8951420706049],
            [-3.138045054399669, 52.894835216033954],
            [-3.144695047842508, 52.89299673268163],
            [-3.147504123748138, 52.89016930859286],
            [-3.145755898569807, 52.88925932290153],
            [-3.136187346564402, 52.88621643971968],
            [-3.135566076536857, 52.88496560207491],
            [-3.14012729334108, 52.885588064420105],
            [-3.14670124477037, 52.88469960424056],
            [-3.1483054599653, 52.88123381581945],
            [-3.152535178268615, 52.87973288180689],
            [-3.151659632295293, 52.87804143074876],
            [-3.141826334904968, 52.87343734087695],
            [-3.139757213974637, 52.87357853540623],
            [-3.136304562331387, 52.87080856673315],
            [-3.133340489609224, 52.869607958110535],
            [-3.12883217696328, 52.8691240368683],
            [-3.127713059186365, 52.867103001328374],
            [-3.134673413689313, 52.86182349717874],
            [-3.138551588346633, 52.861413325678],
            [-3.142342084966252, 52.8601021749167],
            [-3.144562628296153, 52.85756452985435],
            [-3.147643766757035, 52.85573229463127],
            [-3.150726299041805, 52.8555910229283],
            [-3.154002066564866, 52.854284455251054],
            [-3.158191947514953, 52.85044540319802],
            [-3.161245380253452, 52.8493458006912],
            [-3.163014934014052, 52.84749091328001],
            [-3.158501428315617, 52.846625262310305],
            [-3.151260561211695, 52.84256485274172],
            [-3.152254631861847, 52.84029775674642],
            [-3.155329979915399, 52.83875402344519],
            [-3.156478775288202, 52.8370140216957],
            [-3.154065916172947, 52.83212626505662],
            [-3.155934965463218, 52.830179734151294],
            [-3.158197099146801, 52.82995905306046],
            [-3.161100630161099, 52.825850120791394],
            [-3.164899845033682, 52.82290006140641],
            [-3.167887720228838, 52.8192666435524],
            [-3.167628482961761, 52.8171286608586],
            [-3.165880902731597, 52.814813882492935],
            [-3.16546400076527, 52.81204635044863],
            [-3.168356984068093, 52.80822502803287],
            [-3.164443772406301, 52.80424586245882],
            [-3.161412408207977, 52.80357633548542],
            [-3.159031447090908, 52.80661733626873],
            [-3.156266302480294, 52.80801534391296],
            [-3.153816602726566, 52.80710692967831],
            [-3.153190826351219, 52.80577263330754],
            [-3.154120806409419, 52.80252084608913],
            [-3.159139273284267, 52.79968771616211],
            [-3.162034653177144, 52.798743307055695],
            [-3.160726573375846, 52.79563208987678],
            [-3.158425472594685, 52.793488076711704],
            [-3.156372315577439, 52.793577310037016],
            [-3.147314681599321, 52.79180971184133],
            [-3.14582853394893, 52.78887620474947],
            [-3.144552570888994, 52.788509163984514],
            [-3.142454469331165, 52.79032650960308],
            [-3.131062427080337, 52.78753193301582],
            [-3.125789389816577, 52.786956387757186],
            [-3.12211607693038, 52.78757914388548],
            [-3.11890989221511, 52.787223688004175],
            [-3.119533380259959, 52.785518738699814],
            [-3.118287021242106, 52.78358238529503],
            [-3.116418354637172, 52.78402877652356],
            [-3.113762056241641, 52.78654936593964],
            [-3.112189477628154, 52.78576586162162],
            [-3.109748463520691, 52.78668674256345],
            [-3.109707831537819, 52.78823070488194],
            [-3.107271522089457, 52.78969549493111],
            [-3.108466110596352, 52.791416654919665],
            [-3.106101271755665, 52.79295534738399],
            [-3.102390866737389, 52.7926123236518],
            [-3.097731127342023, 52.79137357262741],
            [-3.093461787997539, 52.79368563326404],
            [-3.090153800820682, 52.79632142213938],
            [-3.086632371752106, 52.79559312582767],
            [-3.08558761292274, 52.79336151192309],
            [-3.085738251461213, 52.79030353897353],
            [-3.091693801413911, 52.78675181805808],
            [-3.087780346962433, 52.77984666780302],
            [-3.088819827901243, 52.7775393359425],
            [-3.083870724103829, 52.77787864312902],
            [-3.080648769356095, 52.77744051853236],
            [-3.080512251786832, 52.7760600489315],
            [-3.077858052003312, 52.77375575740027],
            [-3.079684232411537, 52.77320970339976],
            [-3.079516250442163, 52.77151388250923],
            [-3.075039806818805, 52.76977729408687],
            [-3.071854888011711, 52.76991306997854],
            [-3.069556387243121, 52.7742220335414],
            [-3.066795774756639, 52.77378476661537],
            [-3.062906635852525, 52.770764892265056],
            [-3.063418888290233, 52.76916280269025],
            [-3.061169547941259, 52.76931065903654],
            [-3.061316815517101, 52.770732394823334],
            [-3.059217868393944, 52.77115846320073],
            [-3.057521313094433, 52.77375098653488],
            [-3.053907192647224, 52.773563775165094],
            [-3.050089402433121, 52.77231055648681],
            [-3.04779160332159, 52.77263554526421],
            [-3.052719713101, 52.77042210555349],
            [-3.052540577738408, 52.76858831696069],
            [-3.049789519707107, 52.76947105432896],
            [-3.046274374718825, 52.76712104944181],
            [-3.043713620795348, 52.76949779691039],
            [-3.04033901576527, 52.769111751869744],
            [-3.039579929496776, 52.77021068023802],
            [-3.03612923904877, 52.76901222592244],
            [-3.032846312058572, 52.766715623746556],
            [-3.036493600399295, 52.76557031818929],
            [-3.035846765368563, 52.764120056989405],
            [-3.033642335152427, 52.764174709976906],
            [-3.033189251770822, 52.76580088273835],
            [-3.028813862775751, 52.76584125565716],
            [-3.025740278833629, 52.76674870655007],
            [-3.026211847202202, 52.76498261031911],
            [-3.023114095323251, 52.76409456333374],
            [-3.017776247639343, 52.767760714923384],
            [-3.01313896749434, 52.76442795804133],
            [-3.010706869880567, 52.761943587132535],
            [-3.010815147732549, 52.75847409979794],
            [-3.012929613309856, 52.756840577097606],
            [-3.01488337315019, 52.75283093190495],
            [-3.016488342278127, 52.75335480667616],
            [-3.021781451301515, 52.75249659340168],
            [-3.018535900988844, 52.750876688732404],
            [-3.0160279947787, 52.74815805648156],
            [-3.013751311737029, 52.749576420098],
            [-3.009768940116824, 52.750346641168406],
            [-3.00828453123866, 52.74785198730965],
            [-3.00562020717002, 52.74769297884209],
            [-2.999795381712055, 52.74473696221497],
            [-2.997035442400929, 52.74388456473844],
            [-2.992318563594553, 52.743943003881256],
            [-2.990582754122478, 52.74219456241667],
            [-2.99320194570202, 52.74025242338748],
            [-2.992563471876774, 52.7385551213338],
            [-2.99666346023096, 52.739012426908324],
            [-2.996561696441499, 52.736110465964074],
            [-2.993626790131702, 52.73535571531332],
            [-2.99131994511227, 52.73381796902349],
            [-2.987068155647129, 52.733367945507624],
            [-2.979360036040291, 52.733852651646245],
            [-2.973652817082767, 52.73573531777244],
            [-2.971121759553751, 52.735478367092675],
            [-2.96904897718426, 52.73197211728668],
            [-2.965065876290419, 52.73226803053883],
            [-2.96663273493989, 52.729123183453495],
            [-2.965499995567142, 52.728319783661675],
            [-2.966698038777027, 52.725646266071436],
            [-2.961806085439527, 52.725731904330175],
            [-2.961100092744297, 52.72069969473351],
            [-2.962279050797772, 52.7199781495778],
            [-2.961100094811094, 52.71638721189939],
            [-2.965599705401715, 52.714407927392934],
            [-2.977694209590052, 52.715270702367256],
            [-2.977134741134447, 52.72037716311815],
            [-2.975408404462511, 52.722565148381655],
            [-2.977681582902063, 52.72648575309464],
            [-2.981012990623171, 52.726010574887894],
            [-2.984935294627818, 52.72285225631741],
            [-2.996863872460784, 52.72176906498158],
            [-3.000554832949908, 52.72027527942554],
            [-3.005607246002785, 52.72056515152655],
            [-3.008367300987613, 52.722119438715],
            [-3.011559059138972, 52.72062865545302],
            [-3.018193008774367, 52.72130909817373],
            [-3.019512579244232, 52.72487482158475],
            [-3.021477466537742, 52.72424478877457],
            [-3.020268794583864, 52.72149796077812],
            [-3.025328329484153, 52.71665280036456],
            [-3.025373803842248, 52.71474114962216],
            [-3.021750082650279, 52.71063347894824],
            [-3.022486138243263, 52.70666791645412],
            [-3.025427959884979, 52.70512498007775],
            [-3.025612964697714, 52.70373626396718],
            [-3.029068379724844, 52.70277674630097],
            [-3.03212294236636, 52.69988958271234],
            [-3.032119252858622, 52.69660012875739],
            [-3.033523489546723, 52.69421727828846],
            [-3.036024421419985, 52.692540406749316],
            [-3.041355804060371, 52.69274353099654],
            [-3.047019499916956, 52.69130830576556],
            [-3.046637984895113, 52.69008273318371],
            [-3.042673532744739, 52.686819288497944],
            [-3.043361496481216, 52.684527905464755],
            [-3.042577505964561, 52.67937546768109],
            [-3.045656777689574, 52.67546368021389],
            [-3.038580463626904, 52.6753731375565],
            [-3.04307735475619, 52.67211252357015],
            [-3.043030443456028, 52.667595385251154],
            [-3.044826677591638, 52.66554531652377],
            [-3.048742143135712, 52.66300258357971],
            [-3.04864108338302, 52.657572492701625],
            [-3.044932327529285, 52.65596934178407],
            [-3.047090828193447, 52.654543872651395],
            [-3.049788600706666, 52.654369859905],
            [-3.052101405678134, 52.651549915625864],
            [-3.051124521204208, 52.64737028866751],
            [-3.058125478414565, 52.647449455384134],
            [-3.061687217067264, 52.64541809551976],
            [-3.069591328378471, 52.64584413226208],
            [-3.073392050441915, 52.644157099742095],
            [-3.077188936730877, 52.643205314882394],
            [-3.081822400297658, 52.6411654313929],
            [-3.083566461722086, 52.64129248215921],
            [-3.081277155484608, 52.6393724577416],
            [-3.079034426972252, 52.63970037143373],
            [-3.074690213491769, 52.638943300962815],
            [-3.072294373746312, 52.63736029145019],
            [-3.069575706298885, 52.63749631530929],
            [-3.068206964377259, 52.63614759633802],
            [-3.063241109674089, 52.63380357364778],
            [-3.059820099595919, 52.63071029820593],
            [-3.064556656805042, 52.629985368327986],
            [-3.067823569607685, 52.630535833778495],
            [-3.069886604598011, 52.629157947153246],
            [-3.073187086008326, 52.62896263009327],
            [-3.07494685502333, 52.627034489163115],
            [-3.072370066889773, 52.62618039485396],
            [-3.079617692771554, 52.6233951093322],
            [-3.082731969684463, 52.61920329506178],
            [-3.082601104987568, 52.61563275017464],
            [-3.088116441891196, 52.61277008577077],
            [-3.088140672785562, 52.612140554560526],
            [-3.092867781553904, 52.60992050821214],
            [-3.091234059771996, 52.60562747091127],
            [-3.08928555607887, 52.60333227848047],
            [-3.089337325480956, 52.59964581207823],
            [-3.094057997729832, 52.597993953749565],
            [-3.094751760088876, 52.59899442702273],
            [-3.100134047127343, 52.59771737266729],
            [-3.102056866360371, 52.59491529873723],
            [-3.105533765957444, 52.594916141697844],
            [-3.109803483507944, 52.59024620660393],
            [-3.111733378715187, 52.59119814061536],
            [-3.113680397022369, 52.590614339104796],
            [-3.113808805664991, 52.58874765002497],
            [-3.11915578411945, 52.58580688127985],
            [-3.121797662249032, 52.58758804495595],
            [-3.124049550586124, 52.58762420961365],
            [-3.127152238302547, 52.5860079377822],
            [-3.12918598378757, 52.58651362037227],
            [-3.134442450812612, 52.58491973713002],
            [-3.136027900316757, 52.58607050858899],
            [-3.139506517478045, 52.58525407173902],
            [-3.135425748929507, 52.58304482568561],
            [-3.138357974087538, 52.58273975740635],
            [-3.137708074078126, 52.57383397746761],
            [-3.134526882446412, 52.57195668649967],
            [-3.132374507498298, 52.56894313668639],
            [-3.127360389111653, 52.566050221215214],
            [-3.126151531326334, 52.56384473382451],
            [-3.117207826044426, 52.551518464579566],
            [-3.113231240911092, 52.543933993131866],
            [-3.11149560422281, 52.54136373219765],
            [-3.115387982207934, 52.53977807679027],
            [-3.117093806811372, 52.53837572091717],
            [-3.125815376052915, 52.53699757730333],
            [-3.128034827426873, 52.536153793840796],
            [-3.130079875684221, 52.53673034748976],
            [-3.137168892237081, 52.533936632659675],
            [-3.135134915879937, 52.530526344673945],
            [-3.134936108730526, 52.52842089154542],
            [-3.131491753586854, 52.52701359053888],
            [-3.128549199907396, 52.528266186487905],
            [-3.122175536870341, 52.527823402859916],
            [-3.119730416406104, 52.52847499098865],
            [-3.10834150611586, 52.52930590543363],
            [-3.106941119605642, 52.53036185941192],
            [-3.100147886741901, 52.530768631530144],
            [-3.098055755124811, 52.53258974114458],
            [-3.095225789934168, 52.532376805177925],
            [-3.088834295075679, 52.53366477088545],
            [-3.082547833821496, 52.53642136557121],
            [-3.080751105677955, 52.539143802962265],
            [-3.082795279145601, 52.53934900031374],
            [-3.083351123993995, 52.541379355689216],
            [-3.090560220424466, 52.54274793967443],
            [-3.093943428901586, 52.54490225493077],
            [-3.092311337731276, 52.54783015370897],
            [-3.090556876910686, 52.54856292320851],
            [-3.086099930350406, 52.54873962347808],
            [-3.0872760114684, 52.551331480560165],
            [-3.080671805007452, 52.55188377168888],
            [-3.074569305120338, 52.55372482417169],
            [-3.071623413811226, 52.55395105827197],
            [-3.065004051164611, 52.556829247416054],
            [-3.060481781470671, 52.55530914591592],
            [-3.057004359414601, 52.5585911747399],
            [-3.053542938099949, 52.558988821538776],
            [-3.049914868741936, 52.560692311826124],
            [-3.049549587996879, 52.56257181069191],
            [-3.047283949146135, 52.56369861687965],
            [-3.043328714331903, 52.568178288845296],
            [-3.036351940915025, 52.5718347122237],
            [-3.028335969826677, 52.572878244976216],
            [-3.02045079957054, 52.574614219351304],
            [-3.014145880263702, 52.57540376681451],
            [-3.006607282683608, 52.573890337041945],
            [-3.000565869619594, 52.56798106745026],
            [-3.000593653166179, 52.56667367544946],
            [-2.997603797415365, 52.56384363600547],
            [-2.999445052021722, 52.55898145044602],
            [-2.997909226439633, 52.558060325723645],
            [-2.99972047115036, 52.55493982505733],
            [-2.996503295101155, 52.55323458751544],
            [-2.994164182242907, 52.552910837415105],
            [-2.994506696160637, 52.55161787828036],
            [-2.997658980830209, 52.54819753923048],
            [-2.999709248266039, 52.541208355598826],
            [-3.001656570479919, 52.538530744071124],
            [-3.003877661912443, 52.53357546522692],
            [-3.001827743138263, 52.53198624027635],
            [-3.005075117950369, 52.529461177132056],
            [-3.001002080781463, 52.52453316729918],
            [-3.001473979049535, 52.522535082305346],
            [-3.003740498987572, 52.52141911271747],
            [-3.003873862886221, 52.519833005900836],
            [-3.006370944762589, 52.520434817846606],
            [-3.011095827388834, 52.52042329514392],
            [-3.013485350866894, 52.52210646453722],
            [-3.016113306585045, 52.521785444162724],
            [-3.020185277498429, 52.52316911071379],
            [-3.028711964281112, 52.523989827520495],
            [-3.032379133123241, 52.52373130757325],
            [-3.030796223645383, 52.51952152799968],
            [-3.033405895066247, 52.51742827113142],
            [-3.034351536129085, 52.51514818784493],
            [-3.036645715439004, 52.51313131116236],
            [-3.036442453216765, 52.51150496963785],
            [-3.032182697466102, 52.509756712141936],
            [-3.034576272152087, 52.505016809746905],
            [-3.030775270371315, 52.50307035617323],
            [-3.029202384065782, 52.50126799334888],
            [-3.044268798492388, 52.50014163996362],
            [-3.046364536266947, 52.4990622950026],
            [-3.055789365149536, 52.49997286876003],
            [-3.075764878064316, 52.49940453947896],
            [-3.085520827183556, 52.4985359064096],
            [-3.089957577296179, 52.49918195442916],
            [-3.093550452139981, 52.499056218630855],
            [-3.098540956187442, 52.499748954681635],
            [-3.108679729516988, 52.49923634109752],
            [-3.113270331507036, 52.49837335737506],
            [-3.116846653567442, 52.49614688241748],
            [-3.117839344978847, 52.4947457387261],
            [-3.120768425424094, 52.494486043598144],
            [-3.124872731097371, 52.49283690805656],
            [-3.12842327841783, 52.492058712556506],
            [-3.139392316352248, 52.4918420988205],
            [-3.142552453961133, 52.4908477437365],
            [-3.145107226273363, 52.48861047284563],
            [-3.148291301011051, 52.48742078458599],
            [-3.157318329966155, 52.48524875954236],
            [-3.17101638693646, 52.47872796537236],
            [-3.178699266450205, 52.47441433829506],
            [-3.180591995691971, 52.47383631396802],
            [-3.194430500576886, 52.476403463665925],
            [-3.197240352861265, 52.47598937709079],
            [-3.196851049745572, 52.4746123092115],
            [-3.202002128758274, 52.47280515145631],
            [-3.206169501305189, 52.47030287308001],
            [-3.212022298623765, 52.4681356057875],
            [-3.215887474104321, 52.46555159420323],
            [-3.21688085839968, 52.46271202679275],
            [-3.21970337313602, 52.45949308428541],
            [-3.222988334112876, 52.45715128821562],
            [-3.231613739473283, 52.453194136857896],
            [-3.233188738064074, 52.451494939009045],
            [-3.234227955658415, 52.448478791120074],
            [-3.233487551345445, 52.44616870498194],
            [-3.235075686524366, 52.44491827312284],
            [-3.235558094280251, 52.44256082844883],
            [-3.233553934322796, 52.439941598718995],
            [-3.22848700336821, 52.43962561294875],
            [-3.230823261499566, 52.4318877615021],
            [-3.230418716509889, 52.43040591586306],
            [-3.224879253695614, 52.42885230807346],
            [-3.220922967972487, 52.42511489388543],
            [-3.21912390992911, 52.4210736458766],
            [-3.214836916127882, 52.42023274470883],
            [-3.211719380195963, 52.418987801742645],
            [-3.198973063265015, 52.41694924310249],
            [-3.194619175779086, 52.41450686294131],
            [-3.191435939648068, 52.4143035900487],
            [-3.188036445268201, 52.41301683464093],
            [-3.18835442297246, 52.412172829378136],
            [-3.178892454370647, 52.40942661689751],
            [-3.173015162960972, 52.406588113328965],
            [-3.171639274861439, 52.40397919600364],
            [-3.166916625137109, 52.40248850439965],
            [-3.164356902068667, 52.40062660700025],
            [-3.160940997284293, 52.400067713343255],
            [-3.159209597690604, 52.39805285500825],
            [-3.160143863369732, 52.395453402027535],
            [-3.16198477616614, 52.39375049192074],
            [-3.160650384555914, 52.391342383942856],
            [-3.158395566682579, 52.39160458103159],
            [-3.155683054099835, 52.389648718263054],
            [-3.154446801178533, 52.387715141824565],
            [-3.152033062646711, 52.387400654104034],
            [-3.14910014074136, 52.38813774418464],
            [-3.148011305773024, 52.38745597142504],
            [-3.141247146255458, 52.386870569998415],
            [-3.134645222515898, 52.385158542155274],
            [-3.129333659545969, 52.38441640509614],
            [-3.125853346882739, 52.38033459172298],
            [-3.120212889479282, 52.37748063698431],
            [-3.110941487618375, 52.37724630438548],
            [-3.10562992211876, 52.373917404776314],
            [-3.104072629993323, 52.373792650275014],
            [-3.101654223902174, 52.371001137502006],
            [-3.101402494118218, 52.3685544050222],
            [-3.099003862255977, 52.36849315126122],
            [-3.097589607959937, 52.36684115952504],
            [-3.092072847625041, 52.36266848832171],
            [-3.085340316987605, 52.36072824203506],
            [-3.083459568970097, 52.35948680738194],
            [-3.074188580374095, 52.35741556395462],
            [-3.070544343538836, 52.35597682948412],
            [-3.070557955635035, 52.35502368960803],
            [-3.065300530685036, 52.353344047975376],
            [-3.065214198405471, 52.350065940138265],
            [-3.0597048925858, 52.34794960898903],
            [-3.052037652269318, 52.347734023039806],
            [-3.046942452548383, 52.346638422869226],
            [-3.04132580885511, 52.34433874151145],
            [-3.036831280769038, 52.34479991122304],
            [-3.026476151850694, 52.346828821872776],
            [-3.02180539613715, 52.34653747224455],
            [-3.013225993415269, 52.348259447840995],
            [-3.010223735894315, 52.34954836083292],
            [-3.005847785288754, 52.34905612903772],
            [-3.0027247190962, 52.34994581679027],
            [-3.003390065260668, 52.35098934977713],
            [-2.996424018663404, 52.351858426891994],
            [-2.993891933439116, 52.35076847278604],
            [-2.990659975000378, 52.351664149182874],
            [-2.989589266374767, 52.35072730707299],
            [-2.985342887638822, 52.35109905755602],
            [-2.983434814018537, 52.35330329616129],
            [-2.981850765412289, 52.352118003884684],
            [-2.978677905688931, 52.353644904095056],
            [-2.974503433883654, 52.35470074204576],
            [-2.972653134717347, 52.3541549589337],
            [-2.970530311408496, 52.35135654694849],
            [-2.969396892647133, 52.35189273804606],
            [-2.963389152174988, 52.35142670213277],
            [-2.961122675732694, 52.349618342049865],
            [-2.954651533899733, 52.349154734211474],
            [-2.956468633197399, 52.34437679440389],
            [-2.960674725857478, 52.339188242110424],
            [-2.961650634278876, 52.33593558843956],
            [-2.966818370515713, 52.33237983992985],
            [-2.966801333863605, 52.32944904245183],
            [-2.971413260758451, 52.32937065030407],
            [-2.974847712280421, 52.32806746434394],
            [-2.977937762582499, 52.327986182751644],
            [-2.981530140570552, 52.32680202419585],
            [-2.986026811562191, 52.32346850969101],
            [-2.990462657193408, 52.324668509406706],
            [-2.997147317149344, 52.32452775397211],
            [-3.000866216313135, 52.32176577291198],
            [-3.002115988017278, 52.319998344732795],
            [-3.001511656167819, 52.31850838118732],
            [-3.003749794261642, 52.311336315541304],
            [-3.003559682615035, 52.30941482125701],
            [-3.00127147469109, 52.30642231440627],
            [-3.000551456256091, 52.30323761400723],
            [-3.00132053529917, 52.29994411212175],
            [-3.003791274175397, 52.29772488148628],
            [-3.005375871074994, 52.294262531441156],
            [-3.004747160100915, 52.29181069143754],
            [-3.005603465139531, 52.29064805213673],
            [-3.008168346826943, 52.29028811933114],
            [-3.011962523091986, 52.28808884954305],
            [-3.009453701499651, 52.28496985386668],
            [-3.009368862879305, 52.28285142610057],
            [-3.012523551110339, 52.27866825369221],
            [-3.011809220339868, 52.27749281034158],
            [-3.001387380051702, 52.274992467715364],
            [-2.99711670319836, 52.27493009437266],
            [-2.996213842109025, 52.27579930811861],
            [-2.994679013109485, 52.27342124446703],
            [-2.990338970144398, 52.27365896370222],
            [-2.98368406242258, 52.27294115985807],
            [-2.976899052354672, 52.27366417750882],
            [-2.975558145496649, 52.27311945915576],
            [-2.970011482767942, 52.27407136060863],
            [-2.963297367201994, 52.27372787920674],
            [-2.961265413848902, 52.272613464486064],
            [-2.951456651674107, 52.27084085766696],
            [-2.949634935569529, 52.26946820370429],
            [-2.955639517849698, 52.27024601095742],
            [-2.961004286271236, 52.26873691098886],
            [-2.965038568685704, 52.26812496374739],
            [-2.964061210730387, 52.264137513617484],
            [-2.964542790065362, 52.26276152606067],
            [-2.967428607065852, 52.261445933702134],
            [-2.97750312465507, 52.25977333470513],
            [-2.978575380722669, 52.262361866175596],
            [-2.984772182839262, 52.262308513961145],
            [-2.989091049307297, 52.26050215419137],
            [-2.992926817091501, 52.26161800577064],
            [-2.995023003655044, 52.26106994950753],
            [-2.998720340688863, 52.264169318942],
            [-3.005776174129455, 52.26425947606781],
            [-3.011373619222875, 52.262454859950196],
            [-3.017007818383328, 52.26151181450574],
            [-3.023280443435353, 52.25941749794732],
            [-3.024839691994474, 52.25835116373068],
            [-3.02878790325531, 52.25802548195962],
            [-3.037138537037377, 52.25606606853979],
            [-3.038845236932318, 52.253615403337605],
            [-3.044153477626599, 52.253590102095664],
            [-3.048318277445222, 52.250232878317235],
            [-3.04528511686657, 52.24682258312671],
            [-3.04949264001616, 52.244867473957264],
            [-3.043679101625244, 52.24554213019833],
            [-3.042876161811873, 52.24421761503673],
            [-3.043822478949577, 52.241536299879286],
            [-3.045524233752813, 52.240785712554185],
            [-3.044146547474546, 52.23930549773693],
            [-3.04539183757431, 52.23857692836964],
            [-3.049158750751516, 52.23890319141964],
            [-3.054576929244424, 52.237965651001275],
            [-3.05868374339404, 52.23608210975475],
            [-3.063279718471607, 52.236299713874914],
            [-3.066707851083114, 52.23587758191676],
            [-3.067544422628452, 52.23674844214346],
            [-3.073036883438869, 52.2358768908604],
            [-3.07393841440174, 52.234644115977126],
            [-3.070373331126197, 52.22923787578827],
            [-3.073178738915724, 52.22370551867039],
            [-3.072133452832455, 52.22285277510093],
            [-3.077225129282655, 52.21909762463563],
            [-3.078010511418104, 52.21604259963198],
            [-3.072211293179262, 52.21500930719158],
            [-3.072091975426698, 52.213087250434256],
            [-3.077226580758189, 52.21316001504949],
            [-3.080935049181671, 52.210727373381616],
            [-3.083652083996606, 52.21015217652912],
            [-3.087071780374847, 52.20730475903268],
            [-3.090164577870694, 52.20612715229682],
            [-3.094443949256754, 52.203633981500815],
            [-3.099970413644525, 52.20224556447546],
            [-3.102082056075213, 52.20272039626728],
            [-3.096304141829244, 52.19458888979926],
            [-3.095642491840097, 52.18974707196849],
            [-3.097104864179733, 52.18674853100672],
            [-3.097186245832144, 52.18410627026984],
            [-3.094651221128743, 52.18374224525204],
            [-3.097303541410492, 52.180069122581],
            [-3.101597101928381, 52.17719694601344],
            [-3.10688752648168, 52.17639751768824],
            [-3.112489840924424, 52.1736233031781],
            [-3.112459520921932, 52.17023127250684],
            [-3.121995032300182, 52.1669168035442],
            [-3.122430649693472, 52.16341957445907],
            [-3.120407949581666, 52.1630998526622],
            [-3.116930722567388, 52.16044726930722],
            [-3.113386663045341, 52.160200251126824],
            [-3.112067456911682, 52.15900159585011],
            [-3.106419211411728, 52.15848916871564],
            [-3.1051162943093, 52.157174333804],
            [-3.101829073607236, 52.157427195140414],
            [-3.098896211684616, 52.154733852454555],
            [-3.094514587945729, 52.155179169964946],
            [-3.093123089334433, 52.156916595248006],
            [-3.085720475107457, 52.16059121808118],
            [-3.084355603182119, 52.1631437199534],
            [-3.074526967365558, 52.16011293729698],
            [-3.071571678420598, 52.15818971170576],
            [-3.072538435807701, 52.155773195251015],
            [-3.078279011387594, 52.15221067231482],
            [-3.082618434045643, 52.148762492828354],
            [-3.093690237662702, 52.144305961170566],
            [-3.097993345761083, 52.143861309192864],
            [-3.107621261094748, 52.14163057763664],
            [-3.115354831085077, 52.13918041577134],
            [-3.124046036486535, 52.13875803508893],
            [-3.128188279862289, 52.13787598762805],
            [-3.13596816111591, 52.13783635275182],
            [-3.134137382339782, 52.13357788762924],
            [-3.135776160321996, 52.133268099222775],
            [-3.137205211640643, 52.13131945936105],
            [-3.141229741194933, 52.12992555727911],
            [-3.141660265361414, 52.127962252775376],
            [-3.136815024096316, 52.123320212899436],
            [-3.133993465246961, 52.12305606887197],
            [-3.130213598868673, 52.124403246052665],
            [-3.127841856952538, 52.12448357318572],
            [-3.124493281393623, 52.122198504532136],
            [-3.121576436132962, 52.1216202842761],
            [-3.117473405943472, 52.1220305595836],
            [-3.112626412418155, 52.12018918004254],
            [-3.106717494540532, 52.11873976807279],
            [-3.104922299933697, 52.11674186273781],
            [-3.107188709299773, 52.115200388659424],
            [-3.107744914081022, 52.113072281238516],
            [-3.104581504611446, 52.10641276702817],
            [-3.105933249626561, 52.10510500167539],
            [-3.12184167327266, 52.1037805510341],
            [-3.122721578493603, 52.102992810483904],
            [-3.121143345615937, 52.09451949932066],
            [-3.118804390227617, 52.08903925156983],
            [-3.122906563153588, 52.082245985178076],
            [-3.125895793302966, 52.078310790377],
            [-3.121204278654973, 52.07603575174879],
            [-3.121723816121575, 52.07481877330636],
            [-3.119597227289161, 52.072805242921504],
            [-3.120045185987949, 52.07170310943292],
            [-3.118186921113968, 52.06996753852581],
            [-3.118666415540594, 52.06866376558453],
            [-3.116413325852599, 52.065833149694384],
            [-3.111371170287962, 52.06481445206303],
            [-3.107926241124884, 52.0620164963733],
            [-3.105902830972891, 52.05928958471312],
            [-3.101416038422554, 52.058275224146236],
            [-3.097713027977182, 52.054836528183785],
            [-3.090781047890893, 52.050825261801194],
            [-3.092941652274734, 52.048707556173596],
            [-3.092738683836813, 52.04732214524311],
            [-3.086776744516072, 52.04163831378535],
            [-3.086268155829452, 52.040326643720014],
            [-3.092354638086207, 52.033189010740074],
            [-3.092700982461215, 52.0291020528966],
            [-3.099199086219327, 52.02268578101022],
            [-3.092471171604144, 52.01740230611976],
            [-3.08699319891014, 52.01402830455788],
            [-3.084226852356157, 52.00435511474595],
            [-3.082218771768185, 52.00239827713611],
            [-3.078902214567515, 51.99762921345554],
            [-3.075908369041186, 51.99608856866098],
            [-3.072333687815155, 51.99199338604976],
            [-3.069674076359827, 51.98978510616584],
            [-3.068313570420424, 51.98389479120458],
            [-3.062852120106693, 51.98016709937681],
            [-3.059590793994917, 51.97863205301118],
            [-3.0570289949295, 51.975260945599935],
            [-3.051393288761268, 51.97208810773507],
            [-3.042113811073351, 51.9680527142714],
            [-3.03832717318448, 51.96513260473423],
            [-3.035196259590851, 51.95969808253144],
            [-3.030059754139833, 51.95878560916874],
            [-3.025928423099907, 51.95727073924197],
            [-3.022388005876188, 51.9525688092031],
            [-3.021323497526861, 51.949728671208184],
            [-3.0130900337564, 51.94488428012565],
            [-3.010642401737243, 51.94058865516336],
            [-3.00849961592361, 51.938003097298306],
            [-3.008584527250466, 51.93627608705657],
            [-3.010289160762744, 51.932833984415886],
            [-3.010085811000294, 51.9305834283779],
            [-3.007927435024264, 51.9270125538818],
            [-3.002051484531344, 51.923923854417794],
            [-2.998894877858695, 51.92348857202273],
            [-2.987129417703553, 51.92576642352501],
            [-2.983661527454212, 51.92572984185138],
            [-2.976665511563386, 51.92749016624655],
            [-2.974614027254164, 51.92523687977871],
            [-2.974107350805892, 51.921248892176685],
            [-2.976205897566452, 51.92119015141704],
            [-2.974953019113333, 51.918602963085604],
            [-2.971172550172627, 51.91342011222454],
            [-2.973880247729221, 51.911432259701186],
            [-2.972382874332194, 51.910762213475905],
            [-2.97527146369531, 51.90968627131898],
            [-2.972894972485332, 51.908967781987045],
            [-2.97285122615351, 51.90620150528169],
            [-2.967863757151668, 51.90458105778429],
            [-2.965329467538382, 51.904751085118036],
            [-2.960781559725193, 51.90674578046711],
            [-2.953851721161517, 51.90611613379117],
            [-2.951958650589501, 51.90643977803062],
            [-2.948580362125149, 51.90940281215673],
            [-2.946805234917768, 51.908641113978256],
            [-2.942631248231647, 51.9093850349454],
            [-2.938880430063993, 51.911883103928645],
            [-2.935641912982613, 51.91261301179843],
            [-2.934134929231513, 51.91495102936726],
            [-2.930761139226192, 51.91488336097684],
            [-2.928313392092619, 51.91388944618438],
            [-2.92026446498127, 51.91743148181498],
            [-2.916243631776199, 51.91769209862747],
            [-2.912926777227762, 51.920110538281996],
            [-2.911816244912403, 51.91955537757051],
            [-2.908161424831682, 51.9211742301006],
            [-2.905097632106301, 51.924499523863346],
            [-2.900886889318803, 51.92590929524342],
            [-2.899729281980429, 51.92540391480471],
            [-2.892990777836716, 51.92520980215909],
            [-2.887046354197282, 51.92832982825085],
            [-2.889113799176104, 51.93190438275333],
            [-2.888440196906039, 51.933585411234716],
            [-2.882699393098963, 51.93434212576941],
            [-2.875422756228943, 51.93308869351545],
            [-2.874107771409735, 51.931295591687],
            [-2.871557710767763, 51.92981931174179],
            [-2.87137960868788, 51.92769719089319],
            [-2.869900578710301, 51.92678749254062],
            [-2.863009471095804, 51.926867466671645],
            [-2.859445702531435, 51.92775015711849],
            [-2.854249248768135, 51.923722806931266],
            [-2.847992770007478, 51.92363295153599],
            [-2.844996597676244, 51.92208716167132],
            [-2.846446924892993, 51.919898683835406],
            [-2.851088405933399, 51.918850959274415],
            [-2.862386851371053, 51.91748646645882],
            [-2.86381854370436, 51.91668894503017],
            [-2.862230039449547, 51.91420677024982],
            [-2.856356705948414, 51.91470664027654],
            [-2.854118164651289, 51.913299418966126],
            [-2.853866580237444, 51.91561633260905],
            [-2.84852912991323, 51.91586645460172],
            [-2.848104384673153, 51.91682763429815],
            [-2.844996358993743, 51.91525504614071],
            [-2.84294378716261, 51.91785792811463],
            [-2.841254275425749, 51.91721447690954],
            [-2.840119504726554, 51.914726244474764],
            [-2.837176689946311, 51.913938020501284],
            [-2.837359349313493, 51.91141753252859],
            [-2.836106695882219, 51.90605350698143],
            [-2.832112555658892, 51.90517049022315],
            [-2.825386219276376, 51.90501947784935],
            [-2.820831152360222, 51.90535241623913],
            [-2.817725395067609, 51.90378350755066],
            [-2.815976462495833, 51.89927927006634],
            [-2.814327404586082, 51.898025633222645],
            [-2.805452878717028, 51.895592182716626],
            [-2.802416421797868, 51.89367730064297],
            [-2.801689263720526, 51.890343597793084],
            [-2.798859043614117, 51.89029949147915],
            [-2.797520290052241, 51.88871532396532],
            [-2.793668522385513, 51.888198946187615],
            [-2.791746527231634, 51.88662008851587],
            [-2.784834988502595, 51.884297787161664],
            [-2.778892390622994, 51.88382527138991],
            [-2.776799020930938, 51.88166610862757],
            [-2.775717022665891, 51.882117337175565],
            [-2.769335184215616, 51.88027489369914],
            [-2.773383443008839, 51.876025323443066],
            [-2.774146656995181, 51.874451311519294],
            [-2.776744405269895, 51.87346401229045],
            [-2.776632644292149, 51.87093998709047],
            [-2.778998717270667, 51.869007381748226],
            [-2.77764495635751, 51.867573291651254],
            [-2.779102168755131, 51.8669279525865],
            [-2.777828905579717, 51.864846769437584],
            [-2.772311418418288, 51.86220370350193],
            [-2.769508318337969, 51.8623588144332],
            [-2.76851734250561, 51.86036116505967],
            [-2.764881866411911, 51.8580039443795],
            [-2.76251231066049, 51.853813225833655],
            [-2.758141961319345, 51.84992482743728],
            [-2.756992991972275, 51.84599047663773],
            [-2.74611737377288, 51.84452433118769],
            [-2.743275096563545, 51.84188356218915],
            [-2.740302454826477, 51.84162000048918],
            [-2.741821571215664, 51.83857769598189],
            [-2.738848775640062, 51.83661648356003],
            [-2.736392298194408, 51.83896611518532],
            [-2.73154309916705, 51.841391657994144],
            [-2.72758061534251, 51.84014221674163],
            [-2.72578300914026, 51.84379935633434],
            [-2.719665497077767, 51.84886966234199],
            [-2.717794734119763, 51.84744943742002],
            [-2.718554743573776, 51.84439410407923],
            [-2.716101522591425, 51.84073522041591],
            [-2.71009070670965, 51.839066125052774],
            [-2.707248248120261, 51.83940247495528],
            [-2.707144197231188, 51.84304362162697],
            [-2.705112836846606, 51.845695737786926],
            [-2.699608505813886, 51.8434780761267],
            [-2.697302290380555, 51.844809095623745],
            [-2.693424627915755, 51.837701053072855],
            [-2.693365851809238, 51.833872925373356],
            [-2.687002668252762, 51.833056140195545],
            [-2.686771644233101, 51.836378915420376],
            [-2.682850993431577, 51.83845625211095],
            [-2.676820696877144, 51.83635033694926],
            [-2.671529017989445, 51.836247699108256],
            [-2.666197708725148, 51.8356235218363],
            [-2.660444146968137, 51.83380651438899],
            [-2.65762811126607, 51.83177766203392],
            [-2.657832872789246, 51.8279021992839],
            [-2.654358239595872, 51.82614581019938],
            [-2.65040088931262, 51.82612465919689],
            [-2.650164503764918, 51.82411465112911],
            [-2.660871625195112, 51.82275382697605],
            [-2.658888637060133, 51.81980049260416],
            [-2.661107024771335, 51.8181165652518],
            [-2.65883232175479, 51.813551835072424],
            [-2.659538928181561, 51.810682342561684],
            [-2.665393511056243, 51.810099021099404],
            [-2.668978587803028, 51.8090770313861],
            [-2.672610948316919, 51.808906152015176],
            [-2.67348621005736, 51.807097448044196],
            [-2.678302857526724, 51.80331852562165],
            [-2.67754352488435, 51.79987743533208],
            [-2.674948455280009, 51.79720671567482],
            [-2.669810767477185, 51.79427341768528],
            [-2.672714785838596, 51.79307713663402],
            [-2.673042454602766, 51.78908494511486],
            [-2.675844400378236, 51.78806903770082],
            [-2.673361851153367, 51.78473396153776],
            [-2.676197944914973, 51.77991359543576],
            [-2.675198759794732, 51.77629485975078],
            [-2.677664510415184, 51.77302040973491],
            [-2.67992549780761, 51.77138620892638],
            [-2.680452316002565, 51.76892937877885],
            [-2.676353328181251, 51.764140762554455],
            [-2.674370105588332, 51.76086852890253],
            [-2.671546800157727, 51.75886975341675],
            [-2.665871171807786, 51.75687533371447],
            [-2.662692251719053, 51.75389470884843],
            [-2.665711432684572, 51.747989114850185],
            [-2.668563825661343, 51.744961636216736],
            [-2.671267921093908, 51.74094588905209],
            [-2.671721461431111, 51.736952947934874],
            [-2.675394708564271, 51.734670547238856],
            [-2.68600726546571, 51.73193586524631],
            [-2.6875346216019, 51.73020334156164],
            [-2.686377788538866, 51.728297570058466],
            [-2.680696800742814, 51.72486628384165],
            [-2.681669769848892, 51.72130641367342],
            [-2.679321774282417, 51.71407124856016],
            [-2.672123865178979, 51.709986581436574],
            [-2.668497612832414, 51.70601331889362],
            [-2.668977242954521, 51.70232681399183],
            [-2.672881086968172, 51.700339905728036],
            [-2.676831201228203, 51.7008072564523],
            [-2.679086368403961, 51.70288735706935],
            [-2.68279199210726, 51.70323996933321],
            [-2.683791651895226, 51.70062748385875],
            [-2.681659127890653, 51.69949893276444],
            [-2.67369899531291, 51.69743818176752],
            [-2.670189478400152, 51.69474193003816],
            [-2.669169096673288, 51.69314998009575],
            [-2.669007338206574, 51.68883682980383],
            [-2.673171172422407, 51.682216798098835],
            [-2.671348339797116, 51.68023375851085],
            [-2.668272682497031, 51.67861487782391],
            [-2.661766683178097, 51.677500821533776],
            [-2.657825271105407, 51.675883855672716],
            [-2.656844962449901, 51.67429784934042],
            [-2.658239276200772, 51.67210777317577],
            [-2.660128969684873, 51.67108472055343],
            [-2.668799831166706, 51.66923645104886],
            [-2.67739434451805, 51.66976887997363],
            [-2.680054264497131, 51.66961681458123],
            [-2.684503965898295, 51.668207034454625],
            [-2.68616972234854, 51.664079689051185],
            [-2.686039564120802, 51.66206309470059],
            [-2.682939181157096, 51.66034850167834],
            [-2.679891011345765, 51.65973320606948],
            [-2.675728669127385, 51.660316562380046],
            [-2.672789459099661, 51.66188092323046],
            [-2.668410094905584, 51.66512583210492],
            [-2.665922950729215, 51.66432351048054],
            [-2.66651529583978, 51.66123610312546],
            [-2.670904597327168, 51.656125354930104],
            [-2.679300755445772, 51.649342346595816],
            [-2.680326432046058, 51.64746344505515],
            [-2.677983717912777, 51.64466443315929],
            [-2.675023125892809, 51.64480915852018],
            [-2.671663857776972, 51.64644521874861],
            [-2.669054637745758, 51.64601949326092],
            [-2.666446883941884, 51.643320733354095],
            [-2.665992844917188, 51.64093780044391],
            [-2.668760732263166, 51.634564087755315],
            [-2.665745969026128, 51.63027422730348],
            [-2.663723187262893, 51.62828419199615],
            [-2.657190840181423, 51.623826907999316],
            [-2.656533762270275, 51.62203592183133],
            [-2.657515120519188, 51.61997039309047],
            [-2.660112755876956, 51.61819150741341],
            [-2.662309066876036, 51.61462198697983],
            [-2.661825064022955, 51.60969851750218],
            [-2.66255597465559, 51.6066445046966],
            [-2.66465846154856, 51.60164491154365],
            [-2.665959739576952, 51.594704793393994],
            [-2.67164758350328, 51.59259719294079],
            [-2.676909556539472, 51.58976486397889],
            [-2.682684549125011, 51.58792081395876],
            [-2.694057317687271, 51.58538306526199],
            [-2.700025109477045, 51.58283347314684],
            [-2.702848787594627, 51.581005624199214],
            [-2.706477409504461, 51.57675044512643],
            [-2.710700113390614, 51.569640357589144],
            [-2.692835263362671, 51.57100504183305],
            [-2.697700685756708, 51.569308251798965],
            [-2.697204791630696, 51.56848844307508],
            [-2.700890881784193, 51.56424485592941],
            [-2.702216857767228, 51.561818147387704],
            [-2.701182876960772, 51.558839049620424],
            [-2.695039493975244, 51.56037268731841],
            [-2.69486675016282, 51.56181689248869],
            [-2.69275687495274, 51.563474851738626],
            [-2.69356735762835, 51.560799505833224],
            [-2.690645733459083, 51.562201454728665],
            [-2.685140560716809, 51.56305643991503],
            [-2.68252896341269, 51.56013583126404],
            [-2.680422844722101, 51.56110119657384],
            [-2.679045045669066, 51.56002566479544],
            [-2.68219850829479, 51.558382556801355],
            [-2.686037743728833, 51.55364583558883],
            [-2.698282752030305, 51.54700973968618],
            [-2.701761424809398, 51.54627416659551],
            [-2.701445790926264, 51.544972250954245],
            [-2.697607541701347, 51.544347705538364],
            [-2.693609671825277, 51.547923110258],
            [-2.691515923076895, 51.54775112431918],
            [-2.694667597521196, 51.54541716122369],
            [-2.693650863908521, 51.54398899059424],
            [-2.695608589853701, 51.541868854124274],
            [-2.694755307045174, 51.539333751944135],
            [-2.697251556854326, 51.536616948105966],
            [-2.697452978149808, 51.53375638746549],
            [-2.696126793386159, 51.533768756507],
            [-2.698029532351145, 51.5313926372555],
            [-2.699680193366111, 51.52654166726748],
            [-2.70224288202932, 51.525270675133235],
            [-2.699079654715433, 51.524848518472176],
            [-2.702289802463354, 51.52268499963581],
            [-2.722076919967927, 51.52328425767092],
            [-2.78142934913957, 51.525284034025866],
            [-3.031278537192406, 51.39705219398144],
            [-3.1063001422948626, 51.34504583210714],
            [-3.1097649615562895, 51.34324164517568],
            [-3.114030245796831, 51.3405277603765],
            [-3.115287758753215, 51.33957342722728],
            [-3.111909301315488, 51.33807512155239],
            [-3.103812556936416, 51.33849960390773],
            [-3.101643957661687, 51.34055937879826],
            [-3.103266475619853, 51.341347166248966],
            [-3.1053478327856006, 51.34187865917569],
            [-3.090950353382082, 51.34816611250825],
            [-2.88797570302795, 51.427882677085925],
            [-2.8900839566369, 51.42346156427268],
            [-2.893892840680066, 51.41934998594284],
            [-2.900643167080931, 51.41130016481668],
            [-2.906514450618686, 51.40569851106091],
            [-2.914763097499806, 51.400898950295606],
            [-2.919769580918453, 51.39932398629559],
            [-2.92633276798797, 51.39847610293919],
            [-2.936110646207241, 51.39846653078658],
            [-2.93694035885903, 51.399202202220174],
            [-2.942953603068185, 51.39844146677823],
            [-2.952574829912821, 51.3953699670876],
            [-2.959383445782115, 51.39386617144763],
            [-2.967601114471076, 51.39254386135072],
            [-2.976612158234859, 51.38950056415178],
            [-2.983677175836291, 51.3881128117245],
            [-2.981145334080894, 51.387797722903116],
            [-2.980854669489764, 51.38246545999261],
            [-2.981466326857013, 51.380158609258885],
            [-2.983822472265994, 51.37615342789546],
            [-2.98663490025656, 51.37264082022421],
            [-2.991479269171807, 51.36778012589207],
            [-2.997705536129912, 51.36277258807239],
            [-2.992828665518439, 51.36126103858625],
            [-2.994798496697999, 51.35896975642651],
            [-2.995604453804713, 51.361430379233354],
            [-2.997803914410327, 51.36267283635018],
            [-2.999472633320956, 51.36051262802886],
            [-3.002407254116707, 51.358319999681456],
            [-3.001532216683747, 51.354608404207895],
            [-2.99688493821845, 51.35693148865917],
            [-2.997289902030436, 51.35577209940661],
            [-3.001175890867395, 51.3541131908708],
            [-3.002450506636943, 51.35172773506168],
            [-3.008295978350104, 51.3470068257151],
            [-3.019154459050781, 51.33607656873593],
            [-3.020196912139294, 51.33121413167369],
            [-3.022043295809544, 51.32872889571537],
            [-3.024920875001108, 51.327880992051064],
            [-3.031564190294248, 51.32855558564731],
            [-3.037928790364453, 51.330124264885534],
            [-3.039307321327523, 51.32976761583675],
            [-3.035966824726974, 51.32804356844368],
            [-3.031892713277594, 51.32483662904792],
            [-3.027495072337025, 51.323178549],
            [-3.029912606020728, 51.31912463854251],
            [-3.03080935541769, 51.31163395383847],
            [-3.030769533682379, 51.30749288772381],
            [-3.032537307249182, 51.298047626573045],
            [-3.036174345207158, 51.28717661099432],
            [-3.037958169852828, 51.284085345045945],
            [-3.041217111080698, 51.280239686372425],
            [-3.044086244781229, 51.277738566856804],
            [-3.05198180018635, 51.27344817571469],
            [-3.05741162937389, 51.27133374725008],
            [-3.06875606983951, 51.267895288371825],
            [-3.07405278683284, 51.26548680918085],
            [-4.138059415042676, 51.324873235366596],
            [-4.93727817565761, 51.253860376482834],
            [-5.063930328979552, 50.70669662432479],
            [-6.3566557559857415, 50.690099012417136],
            [-6.619841338784681, 49.8031078017151],
          ],
        ],
        type: "Polygon",
      },
    },
    {
      type: "Feature",
      properties: {
        country: "Scotland",
      },
      geometry: {
        coordinates: [
          [
            [-9.500914938257552, 58.00824339335426],
            [-7.9670861203809125, 56.992897533162335],
            [-6.971923375448711, 55.754327947277005],
            [-6.2963076825831195, 55.49142102271756],
            [-6.013280364274692, 55.30477281014029],
            [-5.428964624130742, 55.01267976958101],
            [-4.9907278190235616, 54.485749122855054],
            [-4.545342343047928, 54.729644633091795],
            [-4.543898114344642, 54.7276247368817],
            [-4.546486700178733, 54.724643455203896],
            [-4.548743056129966, 54.72605409166137],
            [-4.546199328814532, 54.723008044897874],
            [-4.542180259749336, 54.720009087618756],
            [-4.539777620555053, 54.71894425312223],
            [-4.538822147590315, 54.720196346923544],
            [-4.534638154408055, 54.721881323408574],
            [-4.527904373651622, 54.72041604023747],
            [-4.524657977557985, 54.71693115954297],
            [-4.523663223103924, 54.7149913199682],
            [-4.526547110866701, 54.71539866820745],
            [-4.526389984693182, 54.713871069859444],
            [-4.522972777499823, 54.71149988065541],
            [-4.513261888192588, 54.70828801323597],
            [-4.510131025130494, 54.70862169037372],
            [-4.508705336744016, 54.70753205584312],
            [-4.502160385356057, 54.70493645980486],
            [-4.49757067794604, 54.70211594956449],
            [-4.494924625020556, 54.701162773769354],
            [-4.489509287008299, 54.70027905900957],
            [-4.481004262151826, 54.697671354362534],
            [-4.474517253632354, 54.69630281878399],
            [-4.470289751742212, 54.694950813722855],
            [-4.464845327907501, 54.69420412753535],
            [-4.456749801902523, 54.694395519599745],
            [-4.449581369894288, 54.69274372279548],
            [-4.436380301982641, 54.68883975479386],
            [-4.428539521729926, 54.685485921948825],
            [-4.422854518989895, 54.6837910811016],
            [-4.41600206577322, 54.68063062557753],
            [-4.413693975231351, 54.68094990511926],
            [-4.409301289711002, 54.67947049438244],
            [-4.408426458227793, 54.67808375350069],
            [-4.403572044960024, 54.67783856128388],
            [-4.397248946795067, 54.67818497748358],
            [-4.393832130017594, 54.67720941810584],
            [-4.387135501317066, 54.67877929807154],
            [-4.381228230507801, 54.6810844324872],
            [-4.378335082159447, 54.68323575703353],
            [-4.377767476549784, 54.68483170358428],
            [-4.374429059735067, 54.68587520011713],
            [-4.373291118002693, 54.68708677073445],
            [-4.369066341329032, 54.68821399267944],
            [-4.364380290963138, 54.69024000859177],
            [-4.362344582378221, 54.692031714616974],
            [-4.364350602367205, 54.693731995195286],
            [-4.364058392445246, 54.69744933398376],
            [-4.359829332031534, 54.694809845919714],
            [-4.358390225244315, 54.695576775961705],
            [-4.359516803799225, 54.69992475306062],
            [-4.356221782989094, 54.702449807218386],
            [-4.353432074564584, 54.7030047103263],
            [-4.351138170707576, 54.70555718659954],
            [-4.35134611361424, 54.70660217466505],
            [-4.347841458787096, 54.710881469210555],
            [-4.349268708463541, 54.7139235357298],
            [-4.351035520661219, 54.715451551147424],
            [-4.350762518244274, 54.71768250772951],
            [-4.354491730200379, 54.718370574376074],
            [-4.355977165151375, 54.717798773443455],
            [-4.361511441132685, 54.71916524163128],
            [-4.361777187304881, 54.72138482735295],
            [-4.364409837028981, 54.723286792613706],
            [-4.362099473031692, 54.72612380886833],
            [-4.363830098226059, 54.72818628748259],
            [-4.365993811562375, 54.72858902113394],
            [-4.365183575264942, 54.73147679985982],
            [-4.363611364065599, 54.73328017602721],
            [-4.361923834897749, 54.7371907167586],
            [-4.3646350594247, 54.74035886091385],
            [-4.364582070608019, 54.74213412898176],
            [-4.36280745564595, 54.742849193023915],
            [-4.363081448012987, 54.74509917030607],
            [-4.359857507056093, 54.750791722103315],
            [-4.357392607949723, 54.75175025300582],
            [-4.35876877453497, 54.75457027100775],
            [-4.355048830731892, 54.75835589802144],
            [-4.356544865625112, 54.7601614607926],
            [-4.356634968303889, 54.76283480023981],
            [-4.354756111065138, 54.76543942346432],
            [-4.354573593668876, 54.76815850592997],
            [-4.356372397257643, 54.76984403546592],
            [-4.360530814339915, 54.77044901017152],
            [-4.361627803643413, 54.77270543424608],
            [-4.359470411666458, 54.774988356191],
            [-4.357160769617619, 54.77492540469477],
            [-4.35425786481377, 54.780173849993574],
            [-4.356166446100943, 54.781598374156665],
            [-4.357418584216426, 54.78742803274165],
            [-4.355499755276411, 54.78958533064818],
            [-4.345178687044001, 54.788953766449794],
            [-4.343318604863298, 54.789872417846176],
            [-4.342410115166861, 54.79495426448246],
            [-4.340450780734967, 54.79941008322726],
            [-4.341640305831847, 54.800043310429906],
            [-4.343313346194254, 54.804513494834836],
            [-4.346065707937746, 54.80692412907836],
            [-4.346459524021009, 54.808590227197335],
            [-4.351674239115612, 54.811558935387836],
            [-4.352534377849343, 54.81345058526092],
            [-4.356622482288774, 54.81523013704733],
            [-4.359308317995815, 54.817220197112924],
            [-4.365590856661052, 54.82313204770095],
            [-4.367014686596494, 54.827297828145525],
            [-4.361561641423532, 54.83028394535532],
            [-4.356497405206802, 54.82711125402072],
            [-4.354063016210146, 54.824475355801745],
            [-4.354223127586589, 54.82923181052798],
            [-4.356258813493833, 54.83318780278529],
            [-4.329020893293611, 54.84810343610375],
            [-4.322572396340607, 54.844960627413286],
            [-4.322444801412007, 54.845573096372334],
            [-4.327252161948572, 54.84828973931611],
            [-4.328108047590653, 54.84860331537799],
            [-4.327245070951974, 54.84907588608127],
            [-4.323561601892297, 54.84865417159669],
            [-4.309056925689891, 54.84588471789368],
            [-4.305851860837769, 54.843913654495964],
            [-4.300295761265348, 54.84236285659675],
            [-4.29223988019193, 54.840939663427],
            [-4.288873943408055, 54.840769474652234],
            [-4.282901558356112, 54.84141649195989],
            [-4.280109487410892, 54.84016284370076],
            [-4.276063989195942, 54.839477732059564],
            [-4.270294706459513, 54.83635802692971],
            [-4.264553712930526, 54.835140126604955],
            [-4.263182996182668, 54.835884871194644],
            [-4.260648206757107, 54.83452800370094],
            [-4.256993468146665, 54.835424598826926],
            [-4.255432570614488, 54.83725346020919],
            [-4.251247865563211, 54.83870291367554],
            [-4.25215900995214, 54.83701492816404],
            [-4.251047146595736, 54.8352075677118],
            [-4.247301104793801, 54.83561517293422],
            [-4.243142964712849, 54.832869499992825],
            [-4.238449373854695, 54.8310411578198],
            [-4.23684618466884, 54.83133727176942],
            [-4.23634075615778, 54.833408421617136],
            [-4.234788259862571, 54.83289953986813],
            [-4.235501150376535, 54.83119586535147],
            [-4.227069884747861, 54.82956721170594],
            [-4.223879543040713, 54.826057446180734],
            [-4.223815288483718, 54.82361000622915],
            [-4.227970362352634, 54.81969785925289],
            [-4.229207419191656, 54.81691449572504],
            [-4.227958946982822, 54.815900517137884],
            [-4.223980772967804, 54.81521056893612],
            [-4.220672906412528, 54.81748765271952],
            [-4.220058598992988, 54.81993796619992],
            [-4.218187827649547, 54.82134797916778],
            [-4.214871404642532, 54.821349230705316],
            [-4.212209950559335, 54.82009213455014],
            [-4.21122475783283, 54.81820769244325],
            [-4.212334711862086, 54.81309180966682],
            [-4.215405294167384, 54.81143241178592],
            [-4.217457576415235, 54.80923677610076],
            [-4.217503784422065, 54.807609006851585],
            [-4.215790794256079, 54.80607989331655],
            [-4.21094120681123, 54.80538096957335],
            [-4.21058628169157, 54.80888307262902],
            [-4.21158442123331, 54.80960643620586],
            [-4.209959271974243, 54.81230563740313],
            [-4.206462902625854, 54.81234679677145],
            [-4.204814451921544, 54.81148420322915],
            [-4.202882925679989, 54.812453191568785],
            [-4.203308393574549, 54.8103772112808],
            [-4.200360141177525, 54.8086177317684],
            [-4.197726674394413, 54.80869602221009],
            [-4.194403771009101, 54.805874456602886],
            [-4.192147008906272, 54.80684286406547],
            [-4.19051564928557, 54.8057397793132],
            [-4.188149367877646, 54.80736085466705],
            [-4.186790443544021, 54.80614314752207],
            [-4.187997740289965, 54.80441177303084],
            [-4.185377393665477, 54.804872469645844],
            [-4.186896351761845, 54.80352379406678],
            [-4.185930257838289, 54.80156733418833],
            [-4.185878401469827, 54.798503196121665],
            [-4.181727591462705, 54.79551526977975],
            [-4.177109295970737, 54.79050384182725],
            [-4.174707459588997, 54.79009480465491],
            [-4.171173249582127, 54.7865798053993],
            [-4.168708852538002, 54.786478277694705],
            [-4.168201395220843, 54.78530806309293],
            [-4.165732270579011, 54.78561104169979],
            [-4.165401610925972, 54.78678634323007],
            [-4.161497770167091, 54.78407323731893],
            [-4.161775763709102, 54.78225890796246],
            [-4.159716855467955, 54.779635364252535],
            [-4.154024632913715, 54.77935817373157],
            [-4.153619314829414, 54.778227433801526],
            [-4.143273306170108, 54.77696589766036],
            [-4.140322397724894, 54.77564817190179],
            [-4.136503588617009, 54.776297053191534],
            [-4.133746652674577, 54.77538023127269],
            [-4.134005432254024, 54.7768102285763],
            [-4.12890011700129, 54.78098031988661],
            [-4.127338185432944, 54.78338236651628],
            [-4.125121481894298, 54.78292686208215],
            [-4.124912425501674, 54.77760643419614],
            [-4.115240938646308, 54.77539698417826],
            [-4.113014264687484, 54.7764388983352],
            [-4.112449781648122, 54.77259002546548],
            [-4.111171443904555, 54.77235701469042],
            [-4.110744897359891, 54.769122335803],
            [-4.106316073395452, 54.767213628685546],
            [-4.100260158645368, 54.766538278313476],
            [-4.095190278099731, 54.76532193327674],
            [-4.092031557733166, 54.76523133292328],
            [-4.090497939760775, 54.76645752365437],
            [-4.091482547195299, 54.76860017699123],
            [-4.089378037224358, 54.772905999023365],
            [-4.089572278928386, 54.775280155756676],
            [-4.092220355965406, 54.77706003342824],
            [-4.091176778401621, 54.78032802715131],
            [-4.088944394207333, 54.78236198818994],
            [-4.091940340375363, 54.786593287392414],
            [-4.090951312295484, 54.787861510866264],
            [-4.091282054865833, 54.7903815224533],
            [-4.090328397918443, 54.79361199769396],
            [-4.086770103121395, 54.799363753478694],
            [-4.084916738998491, 54.7996938494596],
            [-4.083770884062569, 54.79762591210911],
            [-4.083195449886758, 54.79975820094458],
            [-4.081247711789644, 54.79790219905562],
            [-4.079818492880661, 54.79487994815457],
            [-4.075605798693788, 54.79234055388446],
            [-4.071487592408265, 54.791917941536894],
            [-4.06725883719333, 54.789495295590115],
            [-4.06626085370447, 54.78445738344514],
            [-4.065113530279609, 54.78303160702423],
            [-4.065595257505631, 54.78113317201863],
            [-4.059316076978544, 54.777526886879805],
            [-4.059305578667168, 54.776616554146216],
            [-4.0561167523704, 54.77570261684819],
            [-4.054773989303771, 54.7734217503172],
            [-4.052037630773081, 54.773428886541446],
            [-4.048631748275585, 54.77202692255327],
            [-4.046487010721953, 54.769949056987215],
            [-4.040512796596338, 54.7692044303313],
            [-4.034317147599916, 54.77036795170404],
            [-4.031004229160959, 54.771920026915026],
            [-4.02686740540701, 54.771564962337735],
            [-4.024667125799874, 54.77039366713287],
            [-4.014811605283032, 54.76991328762396],
            [-4.009291718083738, 54.77050270429575],
            [-4.006985426847314, 54.770079779724476],
            [-4.004890247963363, 54.771673001912326],
            [-4.00124270678959, 54.77137270631296],
            [-3.995375673020218, 54.77002222880264],
            [-3.994279213331733, 54.76893918937589],
            [-3.988183457925557, 54.76910917505409],
            [-3.984498914595279, 54.76806160671555],
            [-3.977692153181384, 54.76874352258408],
            [-3.966849432350014, 54.77054667691922],
            [-3.960808378726717, 54.7725445820229],
            [-3.958994070318881, 54.77376753061507],
            [-3.957698449352213, 54.77729655628907],
            [-3.952189005988179, 54.78082054233756],
            [-3.947771411962208, 54.7822811175181],
            [-3.941495664643028, 54.78513217921122],
            [-3.938644980251669, 54.78725349420079],
            [-3.92616081791673, 54.788581668798926],
            [-3.920300659677112, 54.790375466731476],
            [-3.907988517287904, 54.79251444122158],
            [-3.905484162309709, 54.79371973041389],
            [-3.90493227757763, 54.79593174289285],
            [-3.901852546336153, 54.796899529218955],
            [-3.895674019435321, 54.79775640996362],
            [-3.887164749033591, 54.799663277570936],
            [-3.88378139260005, 54.80097506821674],
            [-3.873789075487526, 54.8014664380043],
            [-3.86824589644772, 54.8058176190765],
            [-3.865244781921094, 54.810450359675585],
            [-3.862647484259166, 54.812341767882685],
            [-3.856078048376905, 54.814702879762024],
            [-3.853459788825645, 54.81350164958725],
            [-3.843916078039294, 54.81420741100672],
            [-3.835488805446872, 54.816511306315036],
            [-3.833547348115764, 54.818796419511],
            [-3.824329228963876, 54.823756358238455],
            [-3.825795642045349, 54.82755414749523],
            [-3.819455438091471, 54.835048546567506],
            [-3.814367290455333, 54.837108284089005],
            [-3.812983924339935, 54.83646924134916],
            [-3.814880666441824, 54.834110374056976],
            [-3.813742208597448, 54.83389639644528],
            [-3.813116482184538, 54.83127680276311],
            [-3.809540020882853, 54.83014195787398],
            [-3.807031305414529, 54.83243166257296],
            [-3.807493247961342, 54.83576825365855],
            [-3.801041750317237, 54.84216456253974],
            [-3.796638224975414, 54.84530269596424],
            [-3.791948165742173, 54.84693100391354],
            [-3.791568018653873, 54.848078866956236],
            [-3.787491717802645, 54.848178959484564],
            [-3.785347889676256, 54.84914479048802],
            [-3.779020137360753, 54.84977011140471],
            [-3.775719725617616, 54.85187344912086],
            [-3.775331102724828, 54.853240769845605],
            [-3.772338030678736, 54.85443670807244],
            [-3.767182387959979, 54.85545284426906],
            [-3.765544167382434, 54.85669566983905],
            [-3.762850736911566, 54.85623596343488],
            [-3.755841749717685, 54.85873727954724],
            [-3.754682642446271, 54.857546165739045],
            [-3.750018971809935, 54.85781745543838],
            [-3.743895556600694, 54.85902411500775],
            [-3.739089029719882, 54.85913830863272],
            [-3.737934622870372, 54.857110121293445],
            [-3.744074112034507, 54.85533244971135],
            [-3.754384403578217, 54.84988123231545],
            [-3.755091418771823, 54.84804650885147],
            [-3.754276647270089, 54.84595963926638],
            [-3.75060920075693, 54.843451040651836],
            [-3.748586639255905, 54.84313863857324],
            [-3.73703260348273, 54.8473533725558],
            [-3.726008297247826, 54.849618120919935],
            [-3.720720069918042, 54.851081736776315],
            [-3.699572977386734, 54.85382854986444],
            [-3.690982432995733, 54.85421805837386],
            [-3.67121332957196, 54.85232111936653],
            [-3.663625495452459, 54.85114454230937],
            [-3.660121984932543, 54.85003757262387],
            [-3.6509386398255, 54.84600599864012],
            [-3.643375292355157, 54.84462112444724],
            [-3.634682994088601, 54.844190173625606],
            [-3.631799738306573, 54.84452552809264],
            [-3.628443790852144, 54.84627369319023],
            [-3.60994056609431, 54.85780857220446],
            [-3.605702059682874, 54.860734697129544],
            [-3.602398669927259, 54.86119742956416],
            [-3.598451256342468, 54.86281732269304],
            [-3.59123771397638, 54.8671939942015],
            [-3.580789404453093, 54.877824497745856],
            [-3.567437005397575, 54.8854213513806],
            [-3.562922549833316, 54.888207233559335],
            [-3.560638951142133, 54.88842537856193],
            [-3.555439796179932, 54.89335848958473],
            [-3.552608788269888, 54.89674130727812],
            [-3.550805495845554, 54.89783973696131],
            [-3.548914366459679, 54.90193885972101],
            [-3.531841801275855, 54.902118575205314],
            [-3.528334971052855, 54.903462860490464],
            [-3.521600996243857, 54.90825434758245],
            [-3.513205065665964, 54.91575660679142],
            [-3.511624576938865, 54.91624558770881],
            [-3.513144913495549, 54.91304724678838],
            [-3.508982755896315, 54.91122434225579],
            [-3.499515465272923, 54.91270227531523],
            [-3.501329166283283, 54.910322713261046],
            [-3.498234328852437, 54.91002109429359],
            [-3.4925406908047, 54.91309853995807],
            [-3.488163170369702, 54.91624956735597],
            [-3.483654935151044, 54.921362233654115],
            [-3.481258468047558, 54.925148111927015],
            [-3.476704313130618, 54.93394805032726],
            [-3.4719800460157, 54.94049409806258],
            [-3.47119083556084, 54.94025650369145],
            [-3.467146901143003, 54.94518132940107],
            [-3.465429215673678, 54.94455543141659],
            [-3.4727110823507, 54.936791503253794],
            [-3.474424011733304, 54.93326574841961],
            [-3.478111467872459, 54.923159818079064],
            [-3.475546306275534, 54.92427389765155],
            [-3.470468668775113, 54.924744402402915],
            [-3.461731223212647, 54.92929394259306],
            [-3.452466903165426, 54.93357055201093],
            [-3.445167033567825, 54.935657188679066],
            [-3.443405921665482, 54.93420428272495],
            [-3.437889715849099, 54.93314623714111],
            [-3.435121310809219, 54.933641845368925],
            [-3.415227905361575, 54.93449524116762],
            [-3.415026329292074, 54.933643784171906],
            [-3.421217258789039, 54.934155722410104],
            [-3.437892939806914, 54.93280020181599],
            [-3.443295057982135, 54.93372474326268],
            [-3.445372733873657, 54.93529976081785],
            [-3.460696681623854, 54.92787737813597],
            [-3.465538624324816, 54.92498812693028],
            [-3.467753360539498, 54.92259782072107],
            [-3.469099773872802, 54.917584673001755],
            [-3.461079221067703, 54.92164015433405],
            [-3.458291765378463, 54.92201064349209],
            [-3.452239078162137, 54.924217590913074],
            [-3.448277397087665, 54.925136646206376],
            [-3.450685255807534, 54.92288360397087],
            [-3.455326504260825, 54.92091385437482],
            [-3.459198124586593, 54.91859818958449],
            [-3.459920063868297, 54.91720543865556],
            [-3.4520556654265, 54.91977562993226],
            [-3.443219358555754, 54.92071673371642],
            [-3.429336766127414, 54.9201662738338],
            [-3.424965211516174, 54.92052767558992],
            [-3.421104353338909, 54.92166038657025],
            [-3.416166716658895, 54.92612173826586],
            [-3.414194702800494, 54.92618064166959],
            [-3.415380968175469, 54.922410196148036],
            [-3.413071673629012, 54.92241011785844],
            [-3.407603999848192, 54.925353942126044],
            [-3.404043504021228, 54.926397179529616],
            [-3.400524217358896, 54.93132682324496],
            [-3.402677964893825, 54.936033699755946],
            [-3.400928161495226, 54.94025083541553],
            [-3.397482772400724, 54.94353041385884],
            [-3.390223034059163, 54.94917211486411],
            [-3.380329568590368, 54.9548029660982],
            [-3.369127937541247, 54.957872872786346],
            [-3.36534089259886, 54.959946584852354],
            [-3.357823975284353, 54.962120198521134],
            [-3.351467616916143, 54.96353015332728],
            [-3.344384344040708, 54.96446688663591],
            [-3.339923109266799, 54.96441282032354],
            [-3.332009024509995, 54.96527272650015],
            [-3.330228737542898, 54.96457769363969],
            [-3.33584274902012, 54.964538585746105],
            [-3.342978127335904, 54.961880720779995],
            [-3.354334695021263, 54.96054146832368],
            [-3.361928577580713, 54.95833576106922],
            [-3.372286337931115, 54.95385605303608],
            [-3.381038104244159, 54.949510501622804],
            [-3.381300070250671, 54.948725694070234],
            [-3.375908109374449, 54.94994162513694],
            [-3.366447932843968, 54.951149300227904],
            [-3.34926593633036, 54.952365737289824],
            [-3.341274491336793, 54.95364049898363],
            [-3.334270982580977, 54.95552848743709],
            [-3.32878251604971, 54.957722061907425],
            [-3.324753581881365, 54.955502242140305],
            [-3.316223511546685, 54.96185571824231],
            [-3.312116595147553, 54.964042525524626],
            [-3.304233299488768, 54.966365162441406],
            [-3.297466908166055, 54.96687808343654],
            [-3.294207136844308, 54.96644752261064],
            [-3.28759089879729, 54.96390582128933],
            [-3.282166259049789, 54.962345477641946],
            [-3.267046677810443, 54.9601446501207],
            [-3.264723449712831, 54.95999653558494],
            [-3.253106977110798, 54.957808823855636],
            [-3.244169984899031, 54.95788998593036],
            [-3.222644573766395, 54.9598173337632],
            [-3.213687758239759, 54.960889959517544],
            [-3.205318809748164, 54.961306369353004],
            [-3.194360458815506, 54.96081480848164],
            [-3.185383205191959, 54.95778751184456],
            [-3.180833107392865, 54.959280342164625],
            [-3.175355778710142, 54.95895403568393],
            [-3.169199115739689, 54.95713969829842],
            [-3.163116596377355, 54.95582372812773],
            [-3.157496509564664, 54.95366345160277],
            [-3.150899841396718, 54.95225181636933],
            [-3.147665747280001, 54.95242233163395],
            [-3.14309569033379, 54.95390063041364],
            [-3.140148306709821, 54.95590345579445],
            [-3.137137619563209, 54.96078162342816],
            [-3.131687430413421, 54.96547197555662],
            [-3.124685499423981, 54.96932541495729],
            [-3.12211812062008, 54.971947976903856],
            [-3.11814878584787, 54.9748666104537],
            [-3.114850913235927, 54.97592527978747],
            [-3.104883028308762, 54.97769186656865],
            [-3.099084983949353, 54.977216335657346],
            [-3.094051681717539, 54.974394977054004],
            [-3.090230732729001, 54.974258561143735],
            [-3.090008754994291, 54.97746458650781],
            [-3.086549297510346, 54.978492105439],
            [-3.075204372442819, 54.979097536863385],
            [-3.072334411862635, 54.98040007700021],
            [-3.07120352618583, 54.98225546876855],
            [-3.064891011320673, 54.98525479664352],
            [-3.057005984259777, 54.985658062488554],
            [-3.056041450498786, 54.987254371351995],
            [-3.058123982763227, 54.991681035921424],
            [-3.051957479539632, 54.993277538187506],
            [-3.052735067181069, 54.99455588596715],
            [-3.048648318348747, 54.99728271665697],
            [-3.044524597680641, 54.9982456219988],
            [-3.046442686759401, 55.00059076539197],
            [-3.046775073294361, 55.004826024231086],
            [-3.045014601981899, 55.006152289914304],
            [-3.045215919985923, 55.007939815281055],
            [-3.048499308257283, 55.00673518703591],
            [-3.04945688466868, 55.00939499684439],
            [-3.045745777379954, 55.01051528506077],
            [-3.04518056278448, 55.012651776072936],
            [-3.041947596041794, 55.01419727282552],
            [-3.041790787235338, 55.01574790540733],
            [-3.039911768329364, 55.0160812102823],
            [-3.040656955893306, 55.01876904164004],
            [-3.042330261056914, 55.019662363644116],
            [-3.039109510996832, 55.02285767093117],
            [-3.036422142275856, 55.02200169914283],
            [-3.034101341609805, 55.02414858636707],
            [-3.030237939583159, 55.024645930318066],
            [-3.032237521372479, 55.028311684364866],
            [-3.034358096459809, 55.029439485347076],
            [-3.032472076862981, 55.03074147156334],
            [-3.030145310938736, 55.03408076788282],
            [-3.026288276950537, 55.035053357296654],
            [-3.025875117784356, 55.036458784923184],
            [-3.031571705137959, 55.0383220320278],
            [-3.03217633056816, 55.03986887596546],
            [-3.035890240126139, 55.039404776705474],
            [-3.038146902363505, 55.04134489391232],
            [-3.040329991236971, 55.04146639671341],
            [-3.038498827644789, 55.04369631651852],
            [-3.039761630103346, 55.044714555050106],
            [-3.04365586456754, 55.04475210678851],
            [-3.0433881242951, 55.047374030295266],
            [-3.046936230674751, 55.0473714058621],
            [-3.050833894455729, 55.048821513129674],
            [-3.05371320499082, 55.04760318317386],
            [-3.053447005937086, 55.04950703633317],
            [-3.051195262516588, 55.051266348769474],
            [-3.05077841260355, 55.05286415999975],
            [-3.048056690951479, 55.05305742793963],
            [-3.043171442648389, 55.05566064883817],
            [-3.039658241027089, 55.05522516271055],
            [-3.034173030400769, 55.055415642446285],
            [-3.021197576232756, 55.05488986973916],
            [-3.000075773309423, 55.05246641867052],
            [-2.971191302963719, 55.05016704442332],
            [-2.964397011275905, 55.050057549803086],
            [-2.958593767408618, 55.04929456149941],
            [-2.955423551951236, 55.05462067764911],
            [-2.948194166855826, 55.055507478426506],
            [-2.943667561125307, 55.05819988840624],
            [-2.936305356435489, 55.059767354084144],
            [-2.941258531681335, 55.06221749530857],
            [-2.943129978759659, 55.06456727979855],
            [-2.94217065272454, 55.06792215758941],
            [-2.939123108386085, 55.06985349596218],
            [-2.934880492727247, 55.07113785241799],
            [-2.930402718359945, 55.070435543529555],
            [-2.926079489754196, 55.070584510982926],
            [-2.921169317697717, 55.072477880515116],
            [-2.917066756260925, 55.07532973303972],
            [-2.917329683363844, 55.077931055209056],
            [-2.915076565665275, 55.07894776813768],
            [-2.91225747154825, 55.078810244149956],
            [-2.910763771126623, 55.07713627226335],
            [-2.906174996025683, 55.07757437073256],
            [-2.899862151586007, 55.07698854087074],
            [-2.896277416457758, 55.07848327760281],
            [-2.892571954727896, 55.08519096811571],
            [-2.893112595469116, 55.087943121460384],
            [-2.89007483236126, 55.088085739475396],
            [-2.889722336369962, 55.087167213607415],
            [-2.886344824537396, 55.08668138321539],
            [-2.883791460216435, 55.08754737090567],
            [-2.8861953339258, 55.08942061835981],
            [-2.883212042969759, 55.090616817454894],
            [-2.882374587860746, 55.09307795363426],
            [-2.885539800751551, 55.093435084043726],
            [-2.886292649908839, 55.0948098635219],
            [-2.883699190930539, 55.09544516741115],
            [-2.87897630031114, 55.09480268777571],
            [-2.87687272101872, 55.09519884821942],
            [-2.871324709818752, 55.10042287977709],
            [-2.87268055229775, 55.10158500582407],
            [-2.871064616711438, 55.10604565150355],
            [-2.86757799836584, 55.107100332631724],
            [-2.864012104612702, 55.106662835511635],
            [-2.861523099057461, 55.10805361679364],
            [-2.852367205201896, 55.1084091796174],
            [-2.850495751199455, 55.11084676769296],
            [-2.844502380089136, 55.11193802359017],
            [-2.846285733743565, 55.11480301892558],
            [-2.840954529161817, 55.11804799058072],
            [-2.837883353912022, 55.1176126944045],
            [-2.842148567624371, 55.121516488578166],
            [-2.840239424115329, 55.12251903339433],
            [-2.835494811625547, 55.12133321760664],
            [-2.832620474354978, 55.12146968106143],
            [-2.82754824206844, 55.12489743595884],
            [-2.826708239646771, 55.12681897513911],
            [-2.832527868092602, 55.13110979214662],
            [-2.832781673507827, 55.1329088151301],
            [-2.827279970433026, 55.136187634438244],
            [-2.825502778650569, 55.13831404347486],
            [-2.819146228199168, 55.13837588426414],
            [-2.813553720292738, 55.136896473979704],
            [-2.803874798910912, 55.13764450723167],
            [-2.801910182167417, 55.1388615913347],
            [-2.796967789394163, 55.13883044019301],
            [-2.792935070067382, 55.14017022092199],
            [-2.790639097303721, 55.13995913182967],
            [-2.790172980052722, 55.14157509104619],
            [-2.78558506793509, 55.14163326662679],
            [-2.781854282706933, 55.14578657923555],
            [-2.775394152893205, 55.147963831713874],
            [-2.774753987541489, 55.14933529287871],
            [-2.766208506628465, 55.150935821612315],
            [-2.765335914147309, 55.15271780093672],
            [-2.76133990409119, 55.15340281434126],
            [-2.760279654827848, 55.15479910879673],
            [-2.757613486088785, 55.15483520017334],
            [-2.751404249591009, 55.1564193804453],
            [-2.748759699874761, 55.15813399277761],
            [-2.746372586688909, 55.15819984554287],
            [-2.745428168355728, 55.16002797788014],
            [-2.740905571847049, 55.16126639858065],
            [-2.741411337228548, 55.16214889275233],
            [-2.737844504696609, 55.16273682157712],
            [-2.73504728015402, 55.16447778082351],
            [-2.733766174998655, 55.16670735430164],
            [-2.729422635575017, 55.16829673946318],
            [-2.724574867015055, 55.16872497787302],
            [-2.719811175947341, 55.1704618538502],
            [-2.713493296302886, 55.17213448807238],
            [-2.705743924986913, 55.172250441756724],
            [-2.700987204090755, 55.175369837081035],
            [-2.699918816337187, 55.177838523176696],
            [-2.693738727133162, 55.18453704071312],
            [-2.692655460860036, 55.18636737470038],
            [-2.687352256337203, 55.189678186306246],
            [-2.684775989608395, 55.19276773711349],
            [-2.686241589443341, 55.194050774198146],
            [-2.685108132021247, 55.19555604470362],
            [-2.682002681176703, 55.19712895170854],
            [-2.681250146888719, 55.19860150713867],
            [-2.683331556537297, 55.201890374365455],
            [-2.666814981724957, 55.22158035552778],
            [-2.65999143220589, 55.21988403759963],
            [-2.647976107909048, 55.219876602842334],
            [-2.642125552700623, 55.220937317032174],
            [-2.638967211573388, 55.22268195316199],
            [-2.631414403246185, 55.22369805509795],
            [-2.634657165014, 55.22546487619115],
            [-2.635805858226033, 55.22976587758254],
            [-2.633999920993283, 55.23217635057953],
            [-2.633568241530781, 55.23539104653601],
            [-2.631524602320901, 55.23860062331279],
            [-2.630116022052168, 55.244893560337005],
            [-2.62411262787304, 55.246404427951155],
            [-2.617839633978831, 55.247201921663915],
            [-2.614604105302558, 55.245668189482096],
            [-2.612013178129066, 55.24768692791635],
            [-2.624088676453096, 55.24949481958042],
            [-2.629086589963823, 55.25111713798518],
            [-2.634764893108722, 55.254541002870425],
            [-2.640416912063311, 55.2564631801023],
            [-2.646818030162456, 55.259817108840245],
            [-2.640972788131767, 55.260985608807836],
            [-2.635757302121315, 55.26111980154842],
            [-2.626656267469143, 55.26222090179646],
            [-2.626307335602987, 55.26454200354537],
            [-2.628190901534786, 55.26793259006301],
            [-2.623650642302342, 55.26954188499455],
            [-2.623332905876964, 55.271964238265355],
            [-2.618420641203108, 55.2749887581281],
            [-2.617115131685982, 55.27698480479555],
            [-2.613709411694188, 55.27834722432842],
            [-2.609375277622994, 55.283148490511735],
            [-2.605196162727455, 55.28537440670386],
            [-2.60247852193833, 55.28557111165416],
            [-2.598491587899867, 55.287109349099175],
            [-2.594199458001224, 55.28985126042955],
            [-2.58926644027805, 55.29177298017251],
            [-2.57961815948193, 55.294138383370985],
            [-2.573358669840677, 55.29688797878294],
            [-2.573704610117957, 55.30078614671223],
            [-2.570752533723437, 55.30140832938248],
            [-2.566347475079431, 55.30332035217973],
            [-2.565214354983293, 55.30593333735989],
            [-2.562942376206767, 55.30779581222157],
            [-2.560049956528076, 55.308792148453364],
            [-2.557282556733004, 55.311423269125065],
            [-2.557271229111985, 55.313293228433565],
            [-2.558851438685894, 55.31463653738669],
            [-2.558668880632031, 55.317904648531005],
            [-2.550425393633993, 55.315785501506696],
            [-2.548728116320194, 55.3172451838214],
            [-2.544300080187345, 55.31826339732758],
            [-2.543105053083452, 55.319592300669406],
            [-2.536553931540225, 55.320952930949105],
            [-2.530768798087841, 55.32270891518789],
            [-2.525108912166458, 55.32180875930097],
            [-2.519970757211319, 55.323187570055936],
            [-2.517698581561673, 55.32466462414463],
            [-2.513712488479538, 55.32962533590612],
            [-2.509937974405537, 55.33126135706065],
            [-2.50688614637691, 55.333955346457856],
            [-2.501888188565357, 55.337375284880245],
            [-2.502253672637463, 55.34021953692172],
            [-2.498808752948837, 55.342101772355036],
            [-2.496177260766098, 55.34651453333295],
            [-2.488519396592941, 55.351834309821534],
            [-2.481133185492574, 55.35372003659494],
            [-2.473439504976188, 55.35473489628974],
            [-2.467538032292481, 55.352757491704395],
            [-2.463420815258498, 55.35361506907231],
            [-2.46122382560493, 55.35320918752869],
            [-2.444765330377076, 55.359137806302066],
            [-2.43912758032674, 55.3594025500265],
            [-2.4369040423147, 55.35830536273782],
            [-2.429230699636284, 55.356434856730765],
            [-2.426367354956827, 55.3581377276351],
            [-2.419883054767403, 55.35903361723697],
            [-2.41499683489323, 55.35892187417541],
            [-2.412366512341964, 55.357770735088884],
            [-2.408018229712748, 55.35719229127083],
            [-2.4008562803615, 55.35348699820969],
            [-2.399244727926064, 55.34818540095255],
            [-2.392978618955321, 55.34744735907954],
            [-2.378911999658199, 55.349169397350835],
            [-2.378287711156088, 55.35083993140178],
            [-2.37495957850384, 55.353784050046315],
            [-2.36545644598992, 55.35762094291509],
            [-2.3641988232925, 55.35876140645888],
            [-2.358389566529281, 55.35998706773787],
            [-2.354943749808973, 55.362537370018906],
            [-2.341101926799902, 55.3655357782239],
            [-2.337744503574251, 55.36735751497882],
            [-2.338973453933496, 55.36882765741782],
            [-2.343662168885365, 55.37096566667924],
            [-2.346233400429079, 55.37306101333419],
            [-2.337240616146147, 55.37673348033496],
            [-2.336112891397627, 55.37810777446501],
            [-2.330536350761265, 55.38118894050458],
            [-2.334632893713163, 55.38299999696649],
            [-2.33579773251318, 55.38598274595538],
            [-2.335014648476894, 55.388765044525776],
            [-2.335512515594991, 55.392565453397374],
            [-2.343370547356143, 55.397414626190454],
            [-2.344947016545426, 55.39931340665365],
            [-2.340304162034086, 55.40124302905914],
            [-2.33405222796521, 55.40210306054527],
            [-2.332998747254291, 55.40432175743415],
            [-2.335629343679166, 55.40820803375318],
            [-2.332366551798484, 55.40991068375354],
            [-2.327350296893842, 55.407965405391806],
            [-2.313253764765776, 55.406789304399545],
            [-2.312545159774319, 55.40985519494804],
            [-2.306687106917775, 55.41124838057732],
            [-2.304251946230039, 55.41272542132727],
            [-2.296279129509678, 55.41467867757717],
            [-2.293804007284625, 55.41851873984968],
            [-2.294513629651983, 55.420465153528724],
            [-2.28423311004342, 55.4227717866517],
            [-2.281995847281573, 55.424742068567426],
            [-2.277966035694075, 55.42639651935396],
            [-2.273893024445562, 55.42598073739971],
            [-2.270647123508177, 55.42959289313677],
            [-2.268295408766805, 55.43000248954494],
            [-2.262243336765368, 55.428558152615075],
            [-2.26061147793771, 55.43293397098575],
            [-2.258591702623501, 55.43218531661907],
            [-2.253762260238873, 55.43189711869257],
            [-2.242876164956699, 55.43217435599808],
            [-2.236634820421384, 55.43096196819904],
            [-2.231282109034609, 55.42842925863469],
            [-2.229956227187739, 55.43057660280417],
            [-2.223352223508402, 55.43133290855568],
            [-2.221135823118361, 55.4331420469153],
            [-2.205624497138513, 55.43753876241915],
            [-2.201913218698041, 55.44056498929959],
            [-2.198820280537386, 55.44187473130224],
            [-2.194716625836306, 55.44470455954772],
            [-2.193299916857443, 55.44721373981401],
            [-2.193529198367659, 55.44979935536946],
            [-2.192052802046423, 55.45276691896674],
            [-2.188425969327963, 55.456438548854976],
            [-2.189637646291947, 55.46116577000374],
            [-2.184413734164452, 55.46408500920852],
            [-2.166536208089616, 55.467468464055855],
            [-2.165521417984821, 55.46838186705483],
            [-2.168494824202207, 55.46906166353727],
            [-2.173723789917198, 55.47227107655603],
            [-2.190658580990845, 55.47413454180601],
            [-2.195995608533595, 55.475334644572726],
            [-2.200964574612903, 55.47501657998177],
            [-2.203373372282685, 55.478604003236114],
            [-2.206321037215975, 55.48137375521887],
            [-2.20618834252818, 55.482618454378596],
            [-2.202232975490707, 55.48824268145336],
            [-2.207031582719302, 55.494070542587615],
            [-2.21194142789605, 55.49942373172017],
            [-2.216921054247958, 55.5028158490677],
            [-2.220181921023265, 55.50617323388986],
            [-2.226540697046783, 55.50709788955346],
            [-2.228972438054775, 55.509804252082965],
            [-2.226627865035442, 55.519513620897634],
            [-2.224283515337147, 55.52278764309854],
            [-2.227602559359728, 55.5284080991846],
            [-2.233217423241217, 55.52961325059056],
            [-2.23382417768864, 55.540827529374724],
            [-2.232248868167227, 55.544829797211236],
            [-2.235173025533186, 55.54833473754869],
            [-2.240769020148111, 55.55268351058352],
            [-2.240306703420927, 55.55562713991206],
            [-2.24405197747074, 55.55681748185393],
            [-2.247854397713363, 55.55673070733524],
            [-2.253317767662939, 55.56151681234695],
            [-2.259867329224261, 55.56369279318387],
            [-2.259501962562601, 55.564786129363426],
            [-2.263716784422387, 55.5665140131107],
            [-2.270055491731551, 55.57010862645316],
            [-2.275593587929922, 55.575165746938964],
            [-2.280147917777156, 55.57731996605945],
            [-2.285480284203266, 55.57775158069842],
            [-2.289493738515501, 55.58107562059901],
            [-2.292319209331227, 55.58603504674282],
            [-2.290373663362617, 55.58960945441537],
            [-2.288211054216229, 55.591320896882216],
            [-2.288607353463789, 55.5949418382],
            [-2.285935801717588, 55.59654386070002],
            [-2.288954629249334, 55.598362579913896],
            [-2.287861278481837, 55.60117841091437],
            [-2.290264459092273, 55.60274693945642],
            [-2.289232494169494, 55.60377366318329],
            [-2.293885467851461, 55.60455512433924],
            [-2.295135041722746, 55.60862239812261],
            [-2.305949543683289, 55.612083918210296],
            [-2.307286487818951, 55.61110389054882],
            [-2.3160942957295, 55.62045843485315],
            [-2.308934822475551, 55.62247946872449],
            [-2.308626230128619, 55.628875940882175],
            [-2.314999424507882, 55.62788383877096],
            [-2.319816475547817, 55.62772224104045],
            [-2.321141291632928, 55.62640336582394],
            [-2.324310754212696, 55.626165869981286],
            [-2.327773779700596, 55.627251091464906],
            [-2.329804984462891, 55.629145099028435],
            [-2.332162410021737, 55.629764098865905],
            [-2.336097823186156, 55.632167618032064],
            [-2.335047221107423, 55.63449141582326],
            [-2.33339227387783, 55.634551751365336],
            [-2.326784031062804, 55.636570309385306],
            [-2.324702229935149, 55.643166513945566],
            [-2.322589248328883, 55.64355753620906],
            [-2.316956886108713, 55.64313559410738],
            [-2.307629567364216, 55.64680468339897],
            [-2.302731425644117, 55.64725892083109],
            [-2.29730952814019, 55.64675912519751],
            [-2.292870490595985, 55.645303514968965],
            [-2.289179728890096, 55.643381400905],
            [-2.276877836654407, 55.64265055171854],
            [-2.26941864693991, 55.6430715030238],
            [-2.25981044495798, 55.64457394353997],
            [-2.255039480500699, 55.64435842549798],
            [-2.251449451553344, 55.64321761269202],
            [-2.248624928142643, 55.63998067346107],
            [-2.245726050276987, 55.639519252331034],
            [-2.237193521590542, 55.640273732401084],
            [-2.233606127653947, 55.64155921193952],
            [-2.23158769604448, 55.64383365890483],
            [-2.232343758301794, 55.645419894932516],
            [-2.235377973728296, 55.64640514626527],
            [-2.242494449995255, 55.64768510059881],
            [-2.24730392199777, 55.65017424427276],
            [-2.248174139406623, 55.6523531715135],
            [-2.245040360306753, 55.653108806463436],
            [-2.237004440321188, 55.65630803288962],
            [-2.233699925249923, 55.65836302712704],
            [-2.230879787189063, 55.66203880538157],
            [-2.226923525146591, 55.66312436581112],
            [-2.220896449782394, 55.66347231528571],
            [-2.218452930823212, 55.664260236319514],
            [-2.217041451046737, 55.66687106224428],
            [-2.219725246968883, 55.67374250382739],
            [-2.218659359882373, 55.67590710262409],
            [-2.209197672192971, 55.68085762289024],
            [-2.207089787869783, 55.68498669094827],
            [-2.203142438053296, 55.686971729445965],
            [-2.198924887308988, 55.687678526759136],
            [-2.195313072928748, 55.69090987964382],
            [-2.191195843700667, 55.6963181565553],
            [-2.188113541969042, 55.69680983800352],
            [-2.186131121608474, 55.70010317888249],
            [-2.180597889611049, 55.70327410525703],
            [-2.170577594734207, 55.70491195897169],
            [-2.16723125055816, 55.70603512533191],
            [-2.167744201963635, 55.70838043755706],
            [-2.171231455201879, 55.70997226719476],
            [-2.174239801309827, 55.712599721171706],
            [-2.176904104000232, 55.71613337651414],
            [-2.176688930336122, 55.71868946082981],
            [-2.173537177420707, 55.72069805497354],
            [-2.166926155029511, 55.72255007596844],
            [-2.158673085053489, 55.722818913233574],
            [-2.15657742845272, 55.72225822339352],
            [-2.15175162149516, 55.72250600562188],
            [-2.150115826441507, 55.723510733837614],
            [-2.147848267616345, 55.72672921643769],
            [-2.148226721973582, 55.72995535503083],
            [-2.149763674287407, 55.732989474353445],
            [-2.149427140617649, 55.73576627551705],
            [-2.145404223003073, 55.73885424522112],
            [-2.138679164079184, 55.74047026022657],
            [-2.131700264979692, 55.739707125098334],
            [-2.130495306726563, 55.73871161396753],
            [-2.125686759961483, 55.737309938661156],
            [-2.119022756506284, 55.73813018032538],
            [-2.117152325712989, 55.739425044723724],
            [-2.119189704280557, 55.74164597079962],
            [-2.117973675548229, 55.74508482054047],
            [-2.115722350575409, 55.747556957735625],
            [-2.113426140111129, 55.74841710534842],
            [-2.107530488119881, 55.74781322509837],
            [-2.105970653474572, 55.75119476368141],
            [-2.108676896183313, 55.75507307583548],
            [-2.109302568011326, 55.75830978703519],
            [-2.107299799509605, 55.76010139249023],
            [-2.103133858965646, 55.76166107774247],
            [-2.095562485485388, 55.762758030678725],
            [-2.085639358184894, 55.76204029557365],
            [-2.085712954120865, 55.76798471406244],
            [-2.08739430262747, 55.77080122231129],
            [-2.086530938936951, 55.77534100612363],
            [-2.086823957653074, 55.778099205605216],
            [-2.085851737983285, 55.78257258566314],
            [-2.088547848408971, 55.78687359810655],
            [-2.088111351609678, 55.79063861381203],
            [-2.086123295458826, 55.79304524091944],
            [-2.081803035884863, 55.79389550499445],
            [-2.076974314776432, 55.79411698942899],
            [-2.072528587438697, 55.797074813488564],
            [-2.067096928274739, 55.79851373762429],
            [-2.067154169848952, 55.80024685720247],
            [-2.062241907109803, 55.80273289993774],
            [-2.055937850251241, 55.802923763711576],
            [-2.052636772077823, 55.802511050298854],
            [-2.047998312562211, 55.80426856930322],
            [-2.041854714080315, 55.807281727651414],
            [-2.03937385060545, 55.80896989368099],
            [-2.033201235364776, 55.81166415447147],
            [-2.037144960557773, 55.814039365341294],
            [-2.039551744463196, 55.81715548039575],
            [-2.043625498129248, 55.81677914801151],
            [-2.043503232699744, 55.81869127709835],
            [-2.047502434108627, 55.82308045534375],
            [-2.048292715024788, 55.82634203461587],
            [-2.051033459532849, 55.82663751268135],
            [-2.051048477063527, 55.82904941829519],
            [-2.052897423993497, 55.8302183779584],
            [-2.055096676181385, 55.837294549858704],
            [-2.057657968415151, 55.83947948418033],
            [-2.061963084145118, 55.84029257727417],
            [-2.062557142646302, 55.84257093429611],
            [-2.068329454218666, 55.84329562292399],
            [-2.06547038319562, 55.84601727488416],
            [-2.070568392321357, 55.85208939788371],
            [-2.070908903593883, 55.85616393250672],
            [-2.074874529203115, 55.857548300318285],
            [-2.074276198749607, 55.86003270272796],
            [-2.072034534344092, 55.863158867634176],
            [-2.073764023707541, 55.86679642287459],
            [-2.072633581862104, 55.867994767734956],
            [-2.073650100039901, 55.87082814808621],
            [-2.081336362401403, 55.87486854022969],
            [-2.082289317347485, 55.8762138269202],
            [-2.084681220147277, 55.87521328089111],
            [-2.087419866169186, 55.87556357817403],
            [-2.087991054052048, 55.87365471309781],
            [-2.090559124416615, 55.87394612240558],
            [-2.091495977235801, 55.87524607281943],
            [-2.0902720237733, 55.87700475241904],
            [-2.091240427700703, 55.878505306067595],
            [-2.093851378668814, 55.877419788962435],
            [-2.095770778711274, 55.87937295199761],
            [-2.102214313708812, 55.87751504405635],
            [-2.105595280672452, 55.87807582014041],
            [-2.109141430822025, 55.88073493594584],
            [-2.113117900597567, 55.88086353528715],
            [-2.113582077784965, 55.881845598501314],
            [-2.118136144049418, 55.88379499427423],
            [-2.121285599842416, 55.883430578696135],
            [-2.124553884465486, 55.88544647142441],
            [-2.12605700444293, 55.88971351279279],
            [-2.13045859727666, 55.89017301550052],
            [-2.130091648821081, 55.89126549855316],
            [-2.132642082303288, 55.892883637086484],
            [-2.12845886671672, 55.89502793333081],
            [-2.12668991858206, 55.898618872785555],
            [-2.128832655402122, 55.89949105508529],
            [-2.134093684827106, 55.90309642481915],
            [-2.129269830551999, 55.907209350143034],
            [-2.129056069609812, 55.90935421797852],
            [-2.131443856596718, 55.9093233175622],
            [-2.131130747572037, 55.91119722573803],
            [-2.133295324941534, 55.91135098048666],
            [-2.13613955290616, 55.91312416042448],
            [-2.136496041528313, 55.91632545761864],
            [-2.141064790009461, 55.917714673950094],
            [-2.144936510914296, 55.91792844456603],
            [-2.146293706875941, 55.919018577267906],
            [-2.149352393513269, 55.91800954384874],
            [-2.150081962336017, 55.91486106224111],
            [-2.157256566260644, 55.91454156262427],
            [-2.159551496941522, 55.91570600626449],
            [-2.167124090745076, 55.91539251649275],
            [-2.168601233888864, 55.91642276331874],
            [-2.173804321017622, 55.916614130471054],
            [-2.178229182747416, 55.918879432842644],
            [-2.180325929663222, 55.91859239089508],
            [-2.188538485719788, 55.9220458965282],
            [-2.191161769172163, 55.92211644476984],
            [-2.196971554921187, 55.9236960933145],
            [-2.203854126495626, 55.926854549676925],
            [-2.203302894005502, 55.92925248187866],
            [-2.206003946507604, 55.92856076397002],
            [-2.210903777233508, 55.92980576153841],
            [-2.210199128294234, 55.93167281508984],
            [-2.212325789282512, 55.93118265433691],
            [-2.216197450865745, 55.932222832260656],
            [-2.221711420278311, 55.931503232217906],
            [-2.223950039637451, 55.932994411478695],
            [-2.226532359269008, 55.93226820588874],
            [-2.236810703559561, 55.931927172506384],
            [-2.239794171582291, 55.93115318085828],
            [-2.246272093047157, 55.92778346510476],
            [-2.250701335194967, 55.9262686500724],
            [-2.259572310101578, 55.9245455249078],
            [-2.265089624283928, 55.92477047710241],
            [-2.270689253564042, 55.926053856048455],
            [-2.278841775121479, 55.92598924687295],
            [-2.279559489676702, 55.928277469323874],
            [-2.289850216484497, 55.93043240525968],
            [-2.300903053141755, 55.93058811183714],
            [-2.301781614486683, 55.93232153954825],
            [-2.308246269446843, 55.93102282150825],
            [-2.313381627482943, 55.93194298118205],
            [-2.321427217559852, 55.93183306271692],
            [-2.321037769754392, 55.93314297805536],
            [-2.328524537644781, 55.931925340334566],
            [-2.335620897431077, 55.93482440601301],
            [-2.334120770580211, 55.93664970234787],
            [-2.336281156068977, 55.93768424109374],
            [-2.339014085063994, 55.937841993034844],
            [-2.1787143382221075, 56.0256230066864],
            [-2.4252222348532086, 56.15296250069423],
            [-2.4800022332002243, 56.36594655728612],
            [-2.2426237929041406, 56.482078636313474],
            [-1.5304898693027553, 57.176402602581646],
            [-1.4300607262306926, 57.60445588500781],
            [-1.7039583891538541, 57.78012229111252],
            [-2.5713009884123323, 57.78985657648872],
            [-3.5664624970348484, 57.77525416411598],
            [-3.730845885065264, 57.94039964459023],
            [-3.1464860805526484, 58.20595378151546],
            [-2.7109739024577095, 58.685967988551226],
            [-2.3259149035399105, 59.03557827554229],
            [-1.0319985202745272, 59.33194511208339],
            [0.23320762549155916, 60.93986842531473],
            [-0.6813930194715851, 61.087447632952205],
            [-1.7678526779522201, 60.950320119117805],
            [-5.775896069150633, 59.374408716154335],
            [-7.620148649669687, 59.03318277226839],
            [-9.500914938257552, 58.00824339335426],
          ],
        ],
        type: "Polygon",
      },
    },
    {
      type: "Feature",
      properties: {
        country: "Scotland",
      },
      geometry: {
        coordinates: [
          [
            [-4.089396975497331, 54.76518356558498],
            [-4.086527234433851, 54.763228359451695],
            [-4.080595112710316, 54.76661658227604],
            [-4.083658458442135, 54.76896503472289],
            [-4.086023445314143, 54.76891180257745],
            [-4.089396975497331, 54.76518356558498],
          ],
        ],
        type: "Polygon",
      },
    },
    {
      type: "Feature",
      properties: {
        country: "Wales",
      },
      geometry: {
        coordinates: [
          [
            [-5.670287364109547, 51.72076072909672],
            [-5.668980638567739, 51.72020249992449],
            [-5.669139681519909, 51.721092569650075],
            [-5.670287364109547, 51.72076072909672],
          ],
        ],
        type: "Polygon",
      },
    },
    {
      type: "Feature",
      properties: {
        country: "Wales",
      },
      geometry: {
        coordinates: [
          [
            [-5.657976054904083, 51.63689369163981],
            [-4.643325164201173, 51.392125137679216],
            [-3.27245026575099, 51.324548675778345],
            [-3.106044019544612, 51.36811271190018],
            [-3.055831965127453, 51.447256279977694],
            [-3.0870522745296394, 51.49059033590367],
            [-3.073201714108095, 51.49704329784932],
            [-3.054266635909938, 51.50439312549361],
            [-3.031904596935409, 51.51175890255932],
            [-3.030529009080206, 51.51145145263166],
            [-3.024563889376997, 51.51251257952367],
            [-3.022351628110647, 51.51449580502492],
            [-3.014591007825965, 51.51624466216154],
            [-3.00434813276962, 51.51897642035141],
            [-2.989709253685817, 51.523366675148104],
            [-2.981290950515089, 51.52703772906732],
            [-2.971302236081443, 51.52736543996293],
            [-2.963534208059297, 51.52882234899983],
            [-2.953745496449931, 51.5298464683601],
            [-2.948114070766043, 51.531007083529474],
            [-2.936795868001072, 51.53193670371472],
            [-2.913286964495346, 51.53103091397246],
            [-2.908136501915751, 51.53021093995976],
            [-2.902393859039771, 51.528560217800866],
            [-2.899631305486221, 51.529045442634775],
            [-2.900060429000648, 51.529969219721956],
            [-2.896973143636938, 51.52963767302069],
            [-2.896923876436414, 51.531967800619604],
            [-2.890527551684585, 51.532796598259786],
            [-2.888658771283748, 51.53210350768424],
            [-2.887812682532727, 51.53383818476737],
            [-2.884279638766527, 51.53445699555321],
            [-2.884309673159699, 51.53319261297583],
            [-2.887381715326125, 51.5334779115259],
            [-2.885883182048557, 51.52981267737518],
            [-2.887492632680984, 51.52927399712537],
            [-2.889780795482193, 51.53075218685106],
            [-2.893916362426319, 51.53189983232566],
            [-2.894763583221954, 51.53034979313805],
            [-2.89306510928062, 51.527206721230286],
            [-2.891227704836691, 51.527104778088905],
            [-2.885934015325923, 51.52831080534214],
            [-2.87711404699931, 51.53624914354212],
            [-2.874533166286121, 51.537449036814586],
            [-2.852853054345052, 51.54188580930393],
            [-2.846038369500279, 51.54299389205849],
            [-2.857287957384755, 51.53901481338375],
            [-2.874797155172641, 51.53610191858782],
            [-2.878339525327626, 51.533852708604776],
            [-2.878852706772488, 51.53227440137431],
            [-2.876048005885387, 51.52864014185502],
            [-2.876861858061758, 51.527485780488725],
            [-2.879464026996911, 51.52734227099205],
            [-2.883645044211322, 51.525665401283995],
            [-2.882467852801811, 51.523976538590816],
            [-2.877182726008539, 51.52347839506583],
            [-2.8713149772659, 51.5237181326748],
            [-2.868288269647373, 51.52683555239814],
            [-2.866990606292371, 51.53022968269485],
            [-2.863588641451734, 51.53222483096646],
            [-2.851694879314553, 51.5350793834471],
            [-2.840910357454435, 51.537025594605396],
            [-2.840714866706731, 51.53924706430454],
            [-2.846062378496297, 51.54015370401614],
            [-2.843351528898475, 51.54077835521463],
            [-2.841924985502043, 51.539973895234596],
            [-2.840184762185076, 51.541389124822025],
            [-2.841540772022157, 51.542358614363074],
            [-2.837582132899052, 51.54265128195855],
            [-2.832481161047925, 51.54388517977574],
            [-2.829326938690681, 51.546153718236596],
            [-2.828350030992541, 51.54564355275369],
            [-2.830337115205155, 51.54350204460832],
            [-2.828155920729546, 51.543696419434625],
            [-2.828166275499735, 51.54236189753431],
            [-2.832523372308608, 51.539484297333665],
            [-2.83102105029017, 51.53957143524818],
            [-2.836250391023352, 51.53537823835282],
            [-2.838149149820703, 51.534904364829025],
            [-2.834817118623292, 51.53426810556546],
            [-2.837648841864824, 51.532938751754536],
            [-2.838333456203573, 51.53410543464454],
            [-2.844665284877345, 51.534016021645385],
            [-2.84650109432469, 51.531708120702405],
            [-2.84522908005206, 51.531141790090274],
            [-2.860931964233592, 51.52834551833669],
            [-2.856973706150569, 51.52736012019301],
            [-2.862411249283867, 51.52515777190615],
            [-2.866787508704258, 51.52417062487465],
            [-2.869870128255561, 51.52096652903002],
            [-2.873033325902604, 51.51981013775259],
            [-2.880785482129493, 51.51843586005002],
            [-2.885852571707841, 51.51805057826299],
            [-2.889083790715884, 51.519526020690314],
            [-2.891863555467358, 51.51950763730048],
            [-2.89519708175862, 51.51758678699478],
            [-2.895138696695496, 51.5165244274162],
            [-2.891709302631188, 51.5153716640812],
            [-2.888407165108652, 51.51312986290198],
            [-2.873365418509075, 51.51057476952945],
            [-2.865367489367252, 51.511084524590345],
            [-2.86097049857388, 51.51228122827778],
            [-2.857359441542937, 51.51236796563653],
            [-2.855453885694139, 51.51165166402948],
            [-2.853871821399104, 51.51242933443537],
            [-2.853341383994853, 51.5158141460028],
            [-2.858086451561945, 51.51685405882938],
            [-2.863563223211851, 51.51610897418614],
            [-2.865397384740342, 51.516690743146256],
            [-2.869539134472131, 51.51592635305403],
            [-2.870369947582576, 51.513844931392235],
            [-2.874602504544488, 51.51467483845333],
            [-2.869440204942571, 51.51663382322025],
            [-2.867183373013581, 51.518073963079914],
            [-2.862030827363592, 51.5185983966513],
            [-2.859132122548362, 51.519807390773174],
            [-2.852647598769995, 51.52125922190801],
            [-2.848517246763582, 51.5229903547801],
            [-2.844571511118975, 51.52357900790397],
            [-2.836776234071414, 51.52608420002941],
            [-2.835487683208964, 51.52561856135342],
            [-2.833602653610325, 51.52698079407418],
            [-2.831549141047757, 51.52693773174103],
            [-2.827862165754665, 51.529896970934246],
            [-2.827720705360382, 51.52846193716128],
            [-2.818580721390693, 51.53309297821737],
            [-2.814497270022787, 51.534356855577556],
            [-2.808785714536117, 51.53520734623055],
            [-2.803536351971258, 51.5379984922719],
            [-2.800204711602842, 51.53926211184252],
            [-2.804424702913471, 51.536209310236984],
            [-2.802457227202963, 51.536734439153136],
            [-2.812803905133606, 51.53156314485672],
            [-2.818753087945987, 51.52912186504953],
            [-2.821966411268718, 51.528321669675975],
            [-2.822350595603582, 51.52452714137213],
            [-2.819435539585331, 51.52345766606126],
            [-2.811021070072437, 51.526647939808264],
            [-2.810008745301514, 51.52710309701072],
            [-2.809137824264305, 51.527344296028346],
            [-2.807144372526746, 51.52800901804826],
            [-2.807328426970051, 51.52545499118975],
            [-2.809167226024706, 51.52299294931459],
            [-2.811633701133072, 51.52122167622869],
            [-2.813116607922771, 51.51902280839049],
            [-2.812296841951512, 51.51750525845405],
            [-2.807545094590489, 51.517420280862744],
            [-2.805279476645326, 51.51962804620064],
            [-2.805779637902768, 51.52150390145888],
            [-2.804363811185136, 51.523770535161795],
            [-2.805780109469165, 51.52397926061606],
            [-2.805386542259077, 51.52887443675224],
            [-2.794620381926449, 51.534059603827416],
            [-2.793341552934151, 51.53082944080332],
            [-2.795470559923874, 51.528582383328065],
            [-2.794336760300713, 51.52613977932067],
            [-2.792452643755757, 51.528625266063365],
            [-2.790986321207292, 51.52503749146117],
            [-2.7896057026391583, 51.52498537755011],
            [-2.788385104148997, 51.52433486661377],
            [-2.78584486224859, 51.525106580132714],
            [-2.786262926139165, 51.52823171578401],
            [-2.786267133603322, 51.530150523434365],
            [-2.784530780964602, 51.531953236041815],
            [-2.783050966771736, 51.52730003955495],
            [-2.78199682545207, 51.52904511400622],
            [-2.779327598386694, 51.52848824245526],
            [-2.780132300472183, 51.53187281459353],
            [-2.782579470025301, 51.53443178007733],
            [-2.784620835490426, 51.535175342024125],
            [-2.783722155230796, 51.53715947549427],
            [-2.779468853781349, 51.54146509234969],
            [-2.777759074000722, 51.541826165449685],
            [-2.781886597936953, 51.5375717887128],
            [-2.783455492279182, 51.53724844496344],
            [-2.783560876509052, 51.53524712506227],
            [-2.78177787921711, 51.53468619631537],
            [-2.777700124957201, 51.53119387427406],
            [-2.7775560448145415, 51.528288326760936],
            [-2.776529505004679, 51.52637029781869],
            [-2.7747656855388834, 51.52622415040259],
            [-2.772285686726539, 51.52634961887532],
            [-2.770470826537166, 51.526705117294874],
            [-2.77031868452642, 51.52793797466838],
            [-2.76766568635101, 51.52876007477796],
            [-2.759458869530885, 51.529788938851546],
            [-2.756988119097257, 51.53074898968447],
            [-2.75164291488251, 51.5361782714014],
            [-2.747546896526873, 51.53740927212931],
            [-2.742658562992826, 51.53958027165734],
            [-2.744900142076984, 51.53646396384308],
            [-2.745196540067397, 51.533872483245325],
            [-2.74413768590556, 51.53303846889503],
            [-2.74348481055419, 51.535434385190094],
            [-2.740090059421995, 51.5399021857378],
            [-2.740773519958302, 51.54114322675671],
            [-2.738566393123605, 51.54197085854594],
            [-2.737275391578554, 51.54595328374477],
            [-2.734507085591432, 51.548668117160965],
            [-2.73339538971031, 51.55128265287424],
            [-2.727771562812407, 51.55858293823626],
            [-2.725777460098814, 51.55882006751869],
            [-2.723897177658444, 51.56714005334166],
            [-2.722515365010293, 51.56884200378146],
            [-2.710700113390614, 51.569640357589144],
            [-2.706477409504461, 51.57675044512643],
            [-2.702848787594627, 51.581005624199214],
            [-2.700025109477045, 51.58283347314684],
            [-2.694057317687271, 51.58538306526199],
            [-2.682684549125011, 51.58792081395876],
            [-2.676909556539472, 51.58976486397889],
            [-2.67164758350328, 51.59259719294079],
            [-2.665959739576952, 51.594704793393994],
            [-2.66465846154856, 51.60164491154365],
            [-2.66255597465559, 51.6066445046966],
            [-2.661825064022955, 51.60969851750218],
            [-2.662309066876036, 51.61462198697983],
            [-2.660112755876956, 51.61819150741341],
            [-2.657515120519188, 51.61997039309047],
            [-2.656533762270275, 51.62203592183133],
            [-2.657190840181423, 51.623826907999316],
            [-2.663723187262893, 51.62828419199615],
            [-2.665745969026128, 51.63027422730348],
            [-2.668760732263166, 51.634564087755315],
            [-2.665992844917188, 51.64093780044391],
            [-2.666446883941884, 51.643320733354095],
            [-2.669054637745758, 51.64601949326092],
            [-2.671663857776972, 51.64644521874861],
            [-2.675023125892809, 51.64480915852018],
            [-2.677983717912777, 51.64466443315929],
            [-2.680326432046058, 51.64746344505515],
            [-2.679300755445772, 51.649342346595816],
            [-2.670904597327168, 51.656125354930104],
            [-2.66651529583978, 51.66123610312546],
            [-2.665922950729215, 51.66432351048054],
            [-2.668410094905584, 51.66512583210492],
            [-2.672789459099661, 51.66188092323046],
            [-2.675728669127385, 51.660316562380046],
            [-2.679891011345765, 51.65973320606948],
            [-2.682939181157096, 51.66034850167834],
            [-2.686039564120802, 51.66206309470059],
            [-2.68616972234854, 51.664079689051185],
            [-2.684503965898295, 51.668207034454625],
            [-2.680054264497131, 51.66961681458123],
            [-2.67739434451805, 51.66976887997363],
            [-2.668799831166706, 51.66923645104886],
            [-2.660128969684873, 51.67108472055343],
            [-2.658239276200772, 51.67210777317577],
            [-2.656844962449901, 51.67429784934042],
            [-2.657825271105407, 51.675883855672716],
            [-2.661766683178097, 51.677500821533776],
            [-2.668272682497031, 51.67861487782391],
            [-2.671348339797116, 51.68023375851085],
            [-2.673171172422407, 51.682216798098835],
            [-2.669007338206574, 51.68883682980383],
            [-2.669169096673288, 51.69314998009575],
            [-2.670189478400152, 51.69474193003816],
            [-2.67369899531291, 51.69743818176752],
            [-2.681659127890653, 51.69949893276444],
            [-2.683791651895226, 51.70062748385875],
            [-2.68279199210726, 51.70323996933321],
            [-2.679086368403961, 51.70288735706935],
            [-2.676831201228203, 51.7008072564523],
            [-2.672881086968172, 51.700339905728036],
            [-2.668977242954521, 51.70232681399183],
            [-2.668497612832414, 51.70601331889362],
            [-2.672123865178979, 51.709986581436574],
            [-2.679321774282417, 51.71407124856016],
            [-2.681669769848892, 51.72130641367342],
            [-2.680696800742814, 51.72486628384165],
            [-2.686377788538866, 51.728297570058466],
            [-2.6875346216019, 51.73020334156164],
            [-2.68600726546571, 51.73193586524631],
            [-2.675394708564271, 51.734670547238856],
            [-2.671721461431111, 51.736952947934874],
            [-2.671267921093908, 51.74094588905209],
            [-2.668563825661343, 51.744961636216736],
            [-2.665711432684572, 51.747989114850185],
            [-2.662692251719053, 51.75389470884843],
            [-2.665871171807786, 51.75687533371447],
            [-2.671546800157727, 51.75886975341675],
            [-2.674370105588332, 51.76086852890253],
            [-2.676353328181251, 51.764140762554455],
            [-2.680452316002565, 51.76892937877885],
            [-2.67992549780761, 51.77138620892638],
            [-2.677664510415184, 51.77302040973491],
            [-2.675198759794732, 51.77629485975078],
            [-2.676197944914973, 51.77991359543576],
            [-2.673361851153367, 51.78473396153776],
            [-2.675844400378236, 51.78806903770082],
            [-2.673042454602766, 51.78908494511486],
            [-2.672714785838596, 51.79307713663402],
            [-2.669810767477185, 51.79427341768528],
            [-2.674948455280009, 51.79720671567482],
            [-2.67754352488435, 51.79987743533208],
            [-2.678302857526724, 51.80331852562165],
            [-2.67348621005736, 51.807097448044196],
            [-2.672610948316919, 51.808906152015176],
            [-2.668978587803028, 51.8090770313861],
            [-2.665393511056243, 51.810099021099404],
            [-2.659538928181561, 51.810682342561684],
            [-2.65883232175479, 51.813551835072424],
            [-2.661107024771335, 51.8181165652518],
            [-2.658888637060133, 51.81980049260416],
            [-2.660871625195112, 51.82275382697605],
            [-2.650164503764918, 51.82411465112911],
            [-2.65040088931262, 51.82612465919689],
            [-2.654358239595872, 51.82614581019938],
            [-2.657832872789246, 51.8279021992839],
            [-2.65762811126607, 51.83177766203392],
            [-2.660444146968137, 51.83380651438899],
            [-2.666197708725148, 51.8356235218363],
            [-2.671529017989445, 51.836247699108256],
            [-2.676820696877144, 51.83635033694926],
            [-2.682850993431577, 51.83845625211095],
            [-2.686771644233101, 51.836378915420376],
            [-2.687002668252762, 51.833056140195545],
            [-2.693365851809238, 51.833872925373356],
            [-2.693424627915755, 51.837701053072855],
            [-2.697302290380555, 51.844809095623745],
            [-2.699608505813886, 51.8434780761267],
            [-2.705112836846606, 51.845695737786926],
            [-2.707144197231188, 51.84304362162697],
            [-2.707248248120261, 51.83940247495528],
            [-2.71009070670965, 51.839066125052774],
            [-2.716101522591425, 51.84073522041591],
            [-2.718554743573776, 51.84439410407923],
            [-2.717794734119763, 51.84744943742002],
            [-2.719665497077767, 51.84886966234199],
            [-2.72578300914026, 51.84379935633434],
            [-2.72758061534251, 51.84014221674163],
            [-2.73154309916705, 51.841391657994144],
            [-2.736392298194408, 51.83896611518532],
            [-2.738848775640062, 51.83661648356003],
            [-2.741821571215664, 51.83857769598189],
            [-2.740302454826477, 51.84162000048918],
            [-2.743275096563545, 51.84188356218915],
            [-2.74611737377288, 51.84452433118769],
            [-2.756992991972275, 51.84599047663773],
            [-2.758141961319345, 51.84992482743728],
            [-2.76041140601274, 51.85157263546763],
            [-2.764251456329145, 51.85593730066408],
            [-2.764881866411911, 51.8580039443795],
            [-2.76851734250561, 51.86036116505967],
            [-2.769508318337969, 51.8623588144332],
            [-2.772311418418288, 51.86220370350193],
            [-2.777828905579717, 51.864846769437584],
            [-2.779102168755131, 51.8669279525865],
            [-2.77764495635751, 51.867573291651254],
            [-2.778998717270667, 51.869007381748226],
            [-2.776632644292149, 51.87093998709047],
            [-2.776744405269895, 51.87346401229045],
            [-2.774146656995181, 51.874451311519294],
            [-2.773383443008839, 51.876025323443066],
            [-2.769335184215616, 51.88027489369914],
            [-2.775717022665891, 51.882117337175565],
            [-2.776799020930938, 51.88166610862757],
            [-2.778892390622994, 51.88382527138991],
            [-2.784834988502595, 51.884297787161664],
            [-2.791746527231634, 51.88662008851587],
            [-2.793668522385513, 51.888198946187615],
            [-2.797520290052241, 51.88871532396532],
            [-2.798859043614117, 51.89029949147915],
            [-2.801689263720526, 51.890343597793084],
            [-2.802416421797868, 51.89367730064297],
            [-2.805452878717028, 51.895592182716626],
            [-2.814327404586082, 51.898025633222645],
            [-2.815976462495833, 51.89927927006634],
            [-2.817725395067609, 51.90378350755066],
            [-2.820831152360222, 51.90535241623913],
            [-2.825386219276376, 51.90501947784935],
            [-2.832112555658892, 51.90517049022315],
            [-2.836106695882219, 51.90605350698143],
            [-2.837406310790585, 51.912292682588394],
            [-2.837176689946311, 51.913938020501284],
            [-2.840119504726554, 51.914726244474764],
            [-2.841254275425749, 51.91721447690954],
            [-2.84294378716261, 51.91785792811463],
            [-2.844996358993743, 51.91525504614071],
            [-2.848104384673153, 51.91682763429815],
            [-2.84852912991323, 51.91586645460172],
            [-2.853866580237444, 51.91561633260905],
            [-2.854118164651289, 51.913299418966126],
            [-2.856356705948414, 51.91470664027654],
            [-2.862230039449547, 51.91420677024982],
            [-2.86381854370436, 51.91668894503017],
            [-2.862386851371053, 51.91748646645882],
            [-2.851088405933399, 51.918850959274415],
            [-2.846446924892993, 51.919898683835406],
            [-2.844996597676244, 51.92208716167132],
            [-2.847992770007478, 51.92363295153599],
            [-2.854249248768135, 51.923722806931266],
            [-2.859445702531435, 51.92775015711849],
            [-2.863009471095804, 51.926867466671645],
            [-2.869900578710301, 51.92678749254062],
            [-2.87137960868788, 51.92769719089319],
            [-2.871557710767763, 51.92981931174179],
            [-2.874107771409735, 51.931295591687],
            [-2.875422756228943, 51.93308869351545],
            [-2.882699393098963, 51.93434212576941],
            [-2.888440196906039, 51.933585411234716],
            [-2.889113799176104, 51.93190438275333],
            [-2.887046354197282, 51.92832982825085],
            [-2.892990777836716, 51.92520980215909],
            [-2.899729281980429, 51.92540391480471],
            [-2.900886889318803, 51.92590929524342],
            [-2.905097632106301, 51.924499523863346],
            [-2.908161424831682, 51.9211742301006],
            [-2.911816244912403, 51.91955537757051],
            [-2.912926777227762, 51.920110538281996],
            [-2.916243631776199, 51.91769209862747],
            [-2.92026446498127, 51.91743148181498],
            [-2.928313392092619, 51.91388944618438],
            [-2.930761139226192, 51.91488336097684],
            [-2.934134929231513, 51.91495102936726],
            [-2.935641912982613, 51.91261301179843],
            [-2.938880430063993, 51.911883103928645],
            [-2.942631248231647, 51.9093850349454],
            [-2.946805234917768, 51.908641113978256],
            [-2.948580362125149, 51.90940281215673],
            [-2.951958650589501, 51.90643977803062],
            [-2.953851721161517, 51.90611613379117],
            [-2.960781559725193, 51.90674578046711],
            [-2.965329467538382, 51.904751085118036],
            [-2.967863757151668, 51.90458105778429],
            [-2.97285122615351, 51.90620150528169],
            [-2.972894972485332, 51.908967781987045],
            [-2.97527146369531, 51.90968627131898],
            [-2.972382874332194, 51.910762213475905],
            [-2.973880247729221, 51.911432259701186],
            [-2.971172550172627, 51.91342011222454],
            [-2.97376827291832, 51.916669759264146],
            [-2.976205897566452, 51.92119015141704],
            [-2.974107350805892, 51.921248892176685],
            [-2.974614027254164, 51.92523687977871],
            [-2.976665511563386, 51.92749016624655],
            [-2.983661527454212, 51.92572984185138],
            [-2.987129417703553, 51.92576642352501],
            [-2.998894877858695, 51.92348857202273],
            [-3.002051484531344, 51.923923854417794],
            [-3.007927435024264, 51.9270125538818],
            [-3.010085811000294, 51.9305834283779],
            [-3.010289160762744, 51.932833984415886],
            [-3.008584527250466, 51.93627608705657],
            [-3.00849961592361, 51.938003097298306],
            [-3.010642401737243, 51.94058865516336],
            [-3.0130900337564, 51.94488428012565],
            [-3.021323497526861, 51.949728671208184],
            [-3.022388005876188, 51.9525688092031],
            [-3.025928423099907, 51.95727073924197],
            [-3.030059754139833, 51.95878560916874],
            [-3.035196259590851, 51.95969808253144],
            [-3.03832717318448, 51.96513260473423],
            [-3.042113811073351, 51.9680527142714],
            [-3.051393288761268, 51.97208810773507],
            [-3.0570289949295, 51.975260945599935],
            [-3.059590793994917, 51.97863205301118],
            [-3.062852120106693, 51.98016709937681],
            [-3.068313570420424, 51.98389479120458],
            [-3.069674076359827, 51.98978510616584],
            [-3.072333687815155, 51.99199338604976],
            [-3.075908369041186, 51.99608856866098],
            [-3.078902214567515, 51.99762921345554],
            [-3.082218771768185, 52.00239827713611],
            [-3.084226852356157, 52.00435511474595],
            [-3.08699319891014, 52.01402830455788],
            [-3.092471171604144, 52.01740230611976],
            [-3.099199086219327, 52.02268578101022],
            [-3.092700982461215, 52.0291020528966],
            [-3.092354638086207, 52.033189010740074],
            [-3.086268155829452, 52.040326643720014],
            [-3.086776744516072, 52.04163831378535],
            [-3.092738683836813, 52.04732214524311],
            [-3.092941652274734, 52.048707556173596],
            [-3.090781047890893, 52.050825261801194],
            [-3.097713027977182, 52.054836528183785],
            [-3.101416038422554, 52.058275224146236],
            [-3.105902830972891, 52.05928958471312],
            [-3.107926241124884, 52.0620164963733],
            [-3.111371170287962, 52.06481445206303],
            [-3.116413325852599, 52.065833149694384],
            [-3.118666415540594, 52.06866376558453],
            [-3.118186921113968, 52.06996753852581],
            [-3.120045185987949, 52.07170310943292],
            [-3.119597227289161, 52.072805242921504],
            [-3.121723816121575, 52.07481877330636],
            [-3.121204278654973, 52.07603575174879],
            [-3.125895793302966, 52.078310790377],
            [-3.122906563153588, 52.082245985178076],
            [-3.118804390227617, 52.08903925156983],
            [-3.121143345615937, 52.09451949932066],
            [-3.122721578493603, 52.102992810483904],
            [-3.12184167327266, 52.1037805510341],
            [-3.105933249626561, 52.10510500167539],
            [-3.104581504611446, 52.10641276702817],
            [-3.107744914081022, 52.113072281238516],
            [-3.107188709299773, 52.115200388659424],
            [-3.104922299933697, 52.11674186273781],
            [-3.106717494540532, 52.11873976807279],
            [-3.112626412418155, 52.12018918004254],
            [-3.117628068784536, 52.12202190244247],
            [-3.121576436132962, 52.1216202842761],
            [-3.124493281393623, 52.122198504532136],
            [-3.127841856952538, 52.12448357318572],
            [-3.130213598868673, 52.124403246052665],
            [-3.133993465246961, 52.12305606887197],
            [-3.136815024096316, 52.123320212899436],
            [-3.141660265361414, 52.127962252775376],
            [-3.141229741194933, 52.12992555727911],
            [-3.137205211640643, 52.13131945936105],
            [-3.135776160321996, 52.133268099222775],
            [-3.134137382339782, 52.13357788762924],
            [-3.13596816111591, 52.13783635275182],
            [-3.128188279862289, 52.13787598762805],
            [-3.124046036486535, 52.13875803508893],
            [-3.115354831085077, 52.13918041577134],
            [-3.107621261094748, 52.14163057763664],
            [-3.097993345761083, 52.143861309192864],
            [-3.093690237662702, 52.144305961170566],
            [-3.082618434045643, 52.148762492828354],
            [-3.078279011387594, 52.15221067231482],
            [-3.072538435807701, 52.155773195251015],
            [-3.071571678420598, 52.15818971170576],
            [-3.074526967365558, 52.16011293729698],
            [-3.084355603182119, 52.1631437199534],
            [-3.085720475107457, 52.16059121808118],
            [-3.089082999441287, 52.159092947408],
            [-3.09066367916603, 52.1573691022581],
            [-3.093123089334433, 52.156916595248006],
            [-3.094514587945729, 52.155179169964946],
            [-3.098896211684616, 52.154733852454555],
            [-3.101829073607236, 52.157427195140414],
            [-3.1051162943093, 52.157174333804],
            [-3.106419211411728, 52.15848916871564],
            [-3.112067456911682, 52.15900159585011],
            [-3.113386663045341, 52.160200251126824],
            [-3.116930722567388, 52.16044726930722],
            [-3.120407949581666, 52.1630998526622],
            [-3.122430649693472, 52.16341957445907],
            [-3.121995032300182, 52.1669168035442],
            [-3.112459520921932, 52.17023127250684],
            [-3.112489840924424, 52.1736233031781],
            [-3.10688752648168, 52.17639751768824],
            [-3.101597101928381, 52.17719694601344],
            [-3.097303541410492, 52.180069122581],
            [-3.094651221128743, 52.18374224525204],
            [-3.097186245832144, 52.18410627026984],
            [-3.097104864179733, 52.18674853100672],
            [-3.095642491840097, 52.18974707196849],
            [-3.096304141829244, 52.19458888979926],
            [-3.100140296172273, 52.19957821140273],
            [-3.100448395517968, 52.202283351604734],
            [-3.094443949256754, 52.203633981500815],
            [-3.090164577870694, 52.20612715229682],
            [-3.087071780374847, 52.20730475903268],
            [-3.083652083996606, 52.21015217652912],
            [-3.080935049181671, 52.210727373381616],
            [-3.077226580758189, 52.21316001504949],
            [-3.072091975426698, 52.213087250434256],
            [-3.072211293179262, 52.21500930719158],
            [-3.078010511418104, 52.21604259963198],
            [-3.077225129282655, 52.21909762463563],
            [-3.072133452832455, 52.22285277510093],
            [-3.073178738915724, 52.22370551867039],
            [-3.070373331126197, 52.22923787578827],
            [-3.07393841440174, 52.234644115977126],
            [-3.073036883438869, 52.2358768908604],
            [-3.067544422628452, 52.23674844214346],
            [-3.066707851083114, 52.23587758191676],
            [-3.063279718471607, 52.236299713874914],
            [-3.05868374339404, 52.23608210975475],
            [-3.054576929244424, 52.237965651001275],
            [-3.049158750751516, 52.23890319141964],
            [-3.04539183757431, 52.23857692836964],
            [-3.044146547474546, 52.23930549773693],
            [-3.045524233752813, 52.240785712554185],
            [-3.043822478949577, 52.241536299879286],
            [-3.042876161811873, 52.24421761503673],
            [-3.043679101625244, 52.24554213019833],
            [-3.04949264001616, 52.244867473957264],
            [-3.04528511686657, 52.24682258312671],
            [-3.048318277445222, 52.250232878317235],
            [-3.044153477626599, 52.253590102095664],
            [-3.038845236932318, 52.253615403337605],
            [-3.037138537037377, 52.25606606853979],
            [-3.02878790325531, 52.25802548195962],
            [-3.024839691994474, 52.25835116373068],
            [-3.023280443435353, 52.25941749794732],
            [-3.017007818383328, 52.26151181450574],
            [-3.011373619222875, 52.262454859950196],
            [-3.005776174129455, 52.26425947606781],
            [-2.998720340688863, 52.264169318942],
            [-2.995023003655044, 52.26106994950753],
            [-2.992926817091501, 52.26161800577064],
            [-2.989091049307297, 52.26050215419137],
            [-2.984772182839262, 52.262308513961145],
            [-2.978575380722669, 52.262361866175596],
            [-2.97750312465507, 52.25977333470513],
            [-2.967428607065852, 52.261445933702134],
            [-2.964542790065362, 52.26276152606067],
            [-2.964061210730387, 52.264137513617484],
            [-2.965038568685704, 52.26812496374739],
            [-2.961004286271236, 52.26873691098886],
            [-2.955639517849698, 52.27024601095742],
            [-2.949634935569529, 52.26946820370429],
            [-2.951456651674107, 52.27084085766696],
            [-2.956922432475321, 52.27197348177389],
            [-2.963408217566267, 52.27261935810957],
            [-2.963297367201994, 52.27372787920674],
            [-2.970011482767942, 52.27407136060863],
            [-2.974930730038409, 52.27327326164244],
            [-2.976899052354672, 52.27366417750882],
            [-2.984687943306238, 52.272945366039266],
            [-2.990338970144398, 52.27365896370222],
            [-2.994679013109485, 52.27342124446703],
            [-2.996213842109025, 52.27579930811861],
            [-2.99711670319836, 52.27493009437266],
            [-3.001387380051702, 52.274992467715364],
            [-3.011809220339868, 52.27749281034158],
            [-3.012523551110339, 52.27866825369221],
            [-3.009368862879305, 52.28285142610057],
            [-3.009453701499651, 52.28496985386668],
            [-3.011962523091986, 52.28808884954305],
            [-3.008168346826943, 52.29028811933114],
            [-3.005603465139531, 52.29064805213673],
            [-3.004747160100915, 52.29181069143754],
            [-3.005375871074994, 52.294262531441156],
            [-3.003791274175397, 52.29772488148628],
            [-3.00132053529917, 52.29994411212175],
            [-3.000551456256091, 52.30323761400723],
            [-3.00127147469109, 52.30642231440627],
            [-3.003559682615035, 52.30941482125701],
            [-3.003749794261642, 52.311336315541304],
            [-3.001511656167819, 52.31850838118732],
            [-3.002115988017278, 52.319998344732795],
            [-3.000866216313135, 52.32176577291198],
            [-2.997147317149344, 52.32452775397211],
            [-2.990462657193408, 52.324668509406706],
            [-2.986026811562191, 52.32346850969101],
            [-2.981530140570552, 52.32680202419585],
            [-2.977937762582499, 52.327986182751644],
            [-2.974847712280421, 52.32806746434394],
            [-2.971413260758451, 52.32937065030407],
            [-2.966801333863605, 52.32944904245183],
            [-2.966818370515713, 52.33237983992985],
            [-2.961650634278876, 52.33593558843956],
            [-2.960674725857478, 52.339188242110424],
            [-2.956468633197399, 52.34437679440389],
            [-2.954651533899733, 52.349154734211474],
            [-2.961122675732694, 52.349618342049865],
            [-2.963389152174988, 52.35142670213277],
            [-2.969396892647133, 52.35189273804606],
            [-2.970530311408496, 52.35135654694849],
            [-2.972653134717347, 52.3541549589337],
            [-2.974503433883654, 52.35470074204576],
            [-2.978677905688931, 52.353644904095056],
            [-2.981850765412289, 52.352118003884684],
            [-2.983434814018537, 52.35330329616129],
            [-2.985342887638822, 52.35109905755602],
            [-2.989589266374767, 52.35072730707299],
            [-2.990659975000378, 52.351664149182874],
            [-2.993891933439116, 52.35076847278604],
            [-2.996424018663404, 52.351858426891994],
            [-3.003390065260668, 52.35098934977713],
            [-3.0027247190962, 52.34994581679027],
            [-3.005847785288754, 52.34905612903772],
            [-3.010223735894315, 52.34954836083292],
            [-3.013225993415269, 52.348259447840995],
            [-3.02180539613715, 52.34653747224455],
            [-3.026476151850694, 52.346828821872776],
            [-3.031899973480903, 52.3456666766987],
            [-3.04132580885511, 52.34433874151145],
            [-3.046942452548383, 52.346638422869226],
            [-3.052037652269318, 52.347734023039806],
            [-3.0597048925858, 52.34794960898903],
            [-3.065214198405471, 52.350065940138265],
            [-3.065300530685036, 52.353344047975376],
            [-3.070557955635035, 52.35502368960803],
            [-3.070544343538836, 52.35597682948412],
            [-3.074188580374095, 52.35741556395462],
            [-3.083459568970097, 52.35948680738194],
            [-3.085340316987605, 52.36072824203506],
            [-3.092072847625041, 52.36266848832171],
            [-3.099003862255977, 52.36849315126122],
            [-3.101402494118218, 52.3685544050222],
            [-3.101654223902174, 52.371001137502006],
            [-3.104072629993323, 52.373792650275014],
            [-3.10562992211876, 52.373917404776314],
            [-3.110941487618375, 52.37724630438548],
            [-3.120212889479282, 52.37748063698431],
            [-3.125853346882739, 52.38033459172298],
            [-3.129333659545969, 52.38441640509614],
            [-3.134645222515898, 52.385158542155274],
            [-3.141247146255458, 52.386870569998415],
            [-3.148011305773024, 52.38745597142504],
            [-3.14910014074136, 52.38813774418464],
            [-3.152033062646711, 52.387400654104034],
            [-3.154446801178533, 52.387715141824565],
            [-3.155683054099835, 52.389648718263054],
            [-3.158395566682579, 52.39160458103159],
            [-3.160650384555914, 52.391342383942856],
            [-3.16198477616614, 52.39375049192074],
            [-3.160143863369732, 52.395453402027535],
            [-3.159209597690604, 52.39805285500825],
            [-3.160940997284293, 52.400067713343255],
            [-3.164356902068667, 52.40062660700025],
            [-3.166916625137109, 52.40248850439965],
            [-3.171639274861439, 52.40397919600364],
            [-3.173015162960972, 52.406588113328965],
            [-3.178892454370647, 52.40942661689751],
            [-3.18835442297246, 52.412172829378136],
            [-3.188036445268201, 52.41301683464093],
            [-3.191435939648068, 52.4143035900487],
            [-3.194619175779086, 52.41450686294131],
            [-3.198973063265015, 52.41694924310249],
            [-3.211719380195963, 52.418987801742645],
            [-3.214836916127882, 52.42023274470883],
            [-3.21912390992911, 52.4210736458766],
            [-3.220922967972487, 52.42511489388543],
            [-3.224879253695614, 52.42885230807346],
            [-3.230418716509889, 52.43040591586306],
            [-3.230823261499566, 52.4318877615021],
            [-3.22848700336821, 52.43962561294875],
            [-3.233553934322796, 52.439941598718995],
            [-3.235558094280251, 52.44256082844883],
            [-3.235075686524366, 52.44491827312284],
            [-3.233487551345445, 52.44616870498194],
            [-3.234227955658415, 52.448478791120074],
            [-3.233188738064074, 52.451494939009045],
            [-3.231613739473283, 52.453194136857896],
            [-3.222988334112876, 52.45715128821562],
            [-3.21970337313602, 52.45949308428541],
            [-3.21688085839968, 52.46271202679275],
            [-3.215887474104321, 52.46555159420323],
            [-3.212022298623765, 52.4681356057875],
            [-3.206169501305189, 52.47030287308001],
            [-3.202002128758274, 52.47280515145631],
            [-3.196851049745572, 52.4746123092115],
            [-3.197240352861265, 52.47598937709079],
            [-3.194430500576886, 52.476403463665925],
            [-3.180591995691971, 52.47383631396802],
            [-3.178699266450205, 52.47441433829506],
            [-3.17101638693646, 52.47872796537236],
            [-3.157318329966155, 52.48524875954236],
            [-3.148291301011051, 52.48742078458599],
            [-3.145107226273363, 52.48861047284563],
            [-3.142552453961133, 52.4908477437365],
            [-3.139392316352248, 52.4918420988205],
            [-3.12842327841783, 52.492058712556506],
            [-3.124872731097371, 52.49283690805656],
            [-3.120768425424094, 52.494486043598144],
            [-3.117839344978847, 52.4947457387261],
            [-3.116846653567442, 52.49614688241748],
            [-3.113270331507036, 52.49837335737506],
            [-3.108679729516988, 52.49923634109752],
            [-3.098540956187442, 52.499748954681635],
            [-3.093550452139981, 52.499056218630855],
            [-3.089957577296179, 52.49918195442916],
            [-3.085520827183556, 52.4985359064096],
            [-3.075764878064316, 52.49940453947896],
            [-3.055789365149536, 52.49997286876003],
            [-3.046364536266947, 52.4990622950026],
            [-3.044268798492388, 52.50014163996362],
            [-3.029202384065782, 52.50126799334888],
            [-3.030775270371315, 52.50307035617323],
            [-3.034576272152087, 52.505016809746905],
            [-3.032182697466102, 52.509756712141936],
            [-3.036442453216765, 52.51150496963785],
            [-3.036645715439004, 52.51313131116236],
            [-3.034351536129085, 52.51514818784493],
            [-3.033405895066247, 52.51742827113142],
            [-3.030796223645383, 52.51952152799968],
            [-3.032379133123241, 52.52373130757325],
            [-3.028711964281112, 52.523989827520495],
            [-3.024374627231672, 52.52356890700563],
            [-3.021340985821697, 52.52260262285305],
            [-3.020185277498429, 52.52316911071379],
            [-3.016113306585045, 52.521785444162724],
            [-3.013485350866894, 52.52210646453722],
            [-3.011095827388834, 52.52042329514392],
            [-3.006370944762589, 52.520434817846606],
            [-3.003873862886221, 52.519833005900836],
            [-3.003841378760143, 52.52125459140302],
            [-3.001473979049535, 52.522535082305346],
            [-3.001002080781463, 52.52453316729918],
            [-3.005075117950369, 52.529461177132056],
            [-3.001827743138263, 52.53198624027635],
            [-3.003877661912443, 52.53357546522692],
            [-3.001656570479919, 52.538530744071124],
            [-2.999709248266039, 52.541208355598826],
            [-2.997658980830209, 52.54819753923048],
            [-2.994506696160637, 52.55161787828036],
            [-2.994164182242907, 52.552910837415105],
            [-2.996503295101155, 52.55323458751544],
            [-2.99972047115036, 52.55493982505733],
            [-2.997909226439633, 52.558060325723645],
            [-2.999445052021722, 52.55898145044602],
            [-2.997603797415365, 52.56384363600547],
            [-3.000593653166179, 52.56667367544946],
            [-3.000565869619594, 52.56798106745026],
            [-3.006607282683608, 52.573890337041945],
            [-3.014145880263702, 52.57540376681451],
            [-3.02045079957054, 52.574614219351304],
            [-3.028335969826677, 52.572878244976216],
            [-3.036351940915025, 52.5718347122237],
            [-3.043328714331903, 52.568178288845296],
            [-3.047283949146135, 52.56369861687965],
            [-3.049549587996879, 52.56257181069191],
            [-3.049914868741936, 52.560692311826124],
            [-3.054435540291432, 52.55874980032561],
            [-3.057004359414601, 52.5585911747399],
            [-3.060481781470671, 52.55530914591592],
            [-3.065004051164611, 52.556829247416054],
            [-3.071623413811226, 52.55395105827197],
            [-3.074569305120338, 52.55372482417169],
            [-3.080671805007452, 52.55188377168888],
            [-3.0872760114684, 52.551331480560165],
            [-3.086099930350406, 52.54873962347808],
            [-3.090556876910686, 52.54856292320851],
            [-3.092311337731276, 52.54783015370897],
            [-3.093943428901586, 52.54490225493077],
            [-3.090560220424466, 52.54274793967443],
            [-3.083351123993995, 52.541379355689216],
            [-3.082795279145601, 52.53934900031374],
            [-3.080751105677955, 52.539143802962265],
            [-3.082547833821496, 52.53642136557121],
            [-3.088834295075679, 52.53366477088545],
            [-3.095225789934168, 52.532376805177925],
            [-3.098055755124811, 52.53258974114458],
            [-3.100147886741901, 52.530768631530144],
            [-3.106941119605642, 52.53036185941192],
            [-3.10834150611586, 52.52930590543363],
            [-3.113106827346142, 52.52933577491008],
            [-3.122175536870341, 52.527823402859916],
            [-3.128549199907396, 52.528266186487905],
            [-3.131491753586854, 52.52701359053888],
            [-3.134936108730526, 52.52842089154542],
            [-3.135134915879937, 52.530526344673945],
            [-3.137168892237081, 52.533936632659675],
            [-3.130079875684221, 52.53673034748976],
            [-3.128034827426873, 52.536153793840796],
            [-3.125815376052915, 52.53699757730333],
            [-3.117093806811372, 52.53837572091717],
            [-3.115387982207934, 52.53977807679027],
            [-3.11149560422281, 52.54136373219765],
            [-3.113231240911092, 52.543933993131866],
            [-3.117207826044426, 52.551518464579566],
            [-3.126151531326334, 52.56384473382451],
            [-3.127360389111653, 52.566050221215214],
            [-3.132374507498298, 52.56894313668639],
            [-3.134526882446412, 52.57195668649967],
            [-3.137708074078126, 52.57383397746761],
            [-3.138357974087538, 52.58273975740635],
            [-3.135425748929507, 52.58304482568561],
            [-3.139506517478045, 52.58525407173902],
            [-3.136027900316757, 52.58607050858899],
            [-3.134442450812612, 52.58491973713002],
            [-3.12918598378757, 52.58651362037227],
            [-3.127152238302547, 52.5860079377822],
            [-3.124049550586124, 52.58762420961365],
            [-3.121797662249032, 52.58758804495595],
            [-3.11915578411945, 52.58580688127985],
            [-3.113808805664991, 52.58874765002497],
            [-3.113680397022369, 52.590614339104796],
            [-3.111733378715187, 52.59119814061536],
            [-3.109803483507944, 52.59024620660393],
            [-3.105533765957444, 52.594916141697844],
            [-3.102056866360371, 52.59491529873723],
            [-3.100134047127343, 52.59771737266729],
            [-3.094751760088876, 52.59899442702273],
            [-3.094057997729832, 52.597993953749565],
            [-3.089337325480956, 52.59964581207823],
            [-3.08928555607887, 52.60333227848047],
            [-3.093622764080717, 52.609339053636155],
            [-3.088140672785562, 52.612140554560526],
            [-3.088116441891196, 52.61277008577077],
            [-3.082601104987568, 52.61563275017464],
            [-3.082731969684463, 52.61920329506178],
            [-3.079617692771554, 52.6233951093322],
            [-3.072370066889773, 52.62618039485396],
            [-3.07494685502333, 52.627034489163115],
            [-3.073187086008326, 52.62896263009327],
            [-3.069886604598011, 52.629157947153246],
            [-3.067823569607685, 52.630535833778495],
            [-3.064556656805042, 52.629985368327986],
            [-3.059820099595919, 52.63071029820593],
            [-3.063241109674089, 52.63380357364778],
            [-3.068206964377259, 52.63614759633802],
            [-3.069575706298885, 52.63749631530929],
            [-3.072294373746312, 52.63736029145019],
            [-3.074690213491769, 52.638943300962815],
            [-3.079034426972252, 52.63970037143373],
            [-3.081277155484608, 52.6393724577416],
            [-3.083566461722086, 52.64129248215921],
            [-3.081822400297658, 52.6411654313929],
            [-3.077188936730877, 52.643205314882394],
            [-3.073392050441915, 52.644157099742095],
            [-3.069591328378471, 52.64584413226208],
            [-3.061687217067264, 52.64541809551976],
            [-3.058125478414565, 52.647449455384134],
            [-3.051124521204208, 52.64737028866751],
            [-3.052101405678134, 52.651549915625864],
            [-3.049788600706666, 52.654369859905],
            [-3.047090828193447, 52.654543872651395],
            [-3.044932327529285, 52.65596934178407],
            [-3.04864108338302, 52.657572492701625],
            [-3.048742143135712, 52.66300258357971],
            [-3.044826677591638, 52.66554531652377],
            [-3.043030443456028, 52.667595385251154],
            [-3.04307735475619, 52.67211252357015],
            [-3.038580463626904, 52.6753731375565],
            [-3.045656777689574, 52.67546368021389],
            [-3.042577505964561, 52.67937546768109],
            [-3.043361496481216, 52.684527905464755],
            [-3.042673532744739, 52.686819288497944],
            [-3.046637984895113, 52.69008273318371],
            [-3.047019499916956, 52.69130830576556],
            [-3.041355804060371, 52.69274353099654],
            [-3.036024421419985, 52.692540406749316],
            [-3.033523489546723, 52.69421727828846],
            [-3.032119252858622, 52.69660012875739],
            [-3.03212294236636, 52.69988958271234],
            [-3.029068379724844, 52.70277674630097],
            [-3.025612964697714, 52.70373626396718],
            [-3.025427959884979, 52.70512498007775],
            [-3.022486138243263, 52.70666791645412],
            [-3.021750082650279, 52.71063347894824],
            [-3.025373803842248, 52.71474114962216],
            [-3.025328329484153, 52.71665280036456],
            [-3.020268794583864, 52.72149796077812],
            [-3.021477466537742, 52.72424478877457],
            [-3.019512579244232, 52.72487482158475],
            [-3.018193008774367, 52.72130909817373],
            [-3.011559059138972, 52.72062865545302],
            [-3.008367300987613, 52.722119438715],
            [-3.005607246002785, 52.72056515152655],
            [-3.000554832949908, 52.72027527942554],
            [-2.996863872460784, 52.72176906498158],
            [-2.984935294627818, 52.72285225631741],
            [-2.981012990623171, 52.726010574887894],
            [-2.977328066644826, 52.726373630378085],
            [-2.975408404462511, 52.722565148381655],
            [-2.977411641734092, 52.71971314156981],
            [-2.978103210331121, 52.71535729153658],
            [-2.965599705401715, 52.714407927392934],
            [-2.961100094811094, 52.71638721189939],
            [-2.962279050797772, 52.7199781495778],
            [-2.961100092744297, 52.72069969473351],
            [-2.961806085439527, 52.725731904330175],
            [-2.966698038777027, 52.725646266071436],
            [-2.965499995567142, 52.728319783661675],
            [-2.96663273493989, 52.729123183453495],
            [-2.965065876290419, 52.73226803053883],
            [-2.96904897718426, 52.73197211728668],
            [-2.971121759553751, 52.735478367092675],
            [-2.973652817082767, 52.73573531777244],
            [-2.979360036040291, 52.733852651646245],
            [-2.987068155647129, 52.733367945507624],
            [-2.99131994511227, 52.73381796902349],
            [-2.993626790131702, 52.73535571531332],
            [-2.996561696441499, 52.736110465964074],
            [-2.99666346023096, 52.739012426908324],
            [-2.992563471876774, 52.7385551213338],
            [-2.99320194570202, 52.74025242338748],
            [-2.990582754122478, 52.74219456241667],
            [-2.992318563594553, 52.743943003881256],
            [-2.997035442400929, 52.74388456473844],
            [-2.999795381712055, 52.74473696221497],
            [-3.00562020717002, 52.74769297884209],
            [-3.00828453123866, 52.74785198730965],
            [-3.009768940116824, 52.750346641168406],
            [-3.013751311737029, 52.749576420098],
            [-3.0160279947787, 52.74815805648156],
            [-3.018535900988844, 52.750876688732404],
            [-3.021781451301515, 52.75249659340168],
            [-3.016488342278127, 52.75335480667616],
            [-3.01488337315019, 52.75283093190495],
            [-3.012929613309856, 52.756840577097606],
            [-3.010815147732549, 52.75847409979794],
            [-3.010706869880567, 52.761943587132535],
            [-3.01313896749434, 52.76442795804133],
            [-3.017776247639343, 52.767760714923384],
            [-3.023114095323251, 52.76409456333374],
            [-3.026211847202202, 52.76498261031911],
            [-3.025740278833629, 52.76674870655007],
            [-3.028813862775751, 52.76584125565716],
            [-3.033189251770822, 52.76580088273835],
            [-3.033642335152427, 52.764174709976906],
            [-3.035846765368563, 52.764120056989405],
            [-3.036493600399295, 52.76557031818929],
            [-3.032846312058572, 52.766715623746556],
            [-3.03612923904877, 52.76901222592244],
            [-3.039579929496776, 52.77021068023802],
            [-3.04033901576527, 52.769111751869744],
            [-3.043713620795348, 52.76949779691039],
            [-3.046274374718825, 52.76712104944181],
            [-3.049789519707107, 52.76947105432896],
            [-3.052540577738408, 52.76858831696069],
            [-3.052719713101, 52.77042210555349],
            [-3.04779160332159, 52.77263554526421],
            [-3.050089402433121, 52.77231055648681],
            [-3.053907192647224, 52.773563775165094],
            [-3.057521313094433, 52.77375098653488],
            [-3.059217868393944, 52.77115846320073],
            [-3.061316815517101, 52.770732394823334],
            [-3.061169547941259, 52.76931065903654],
            [-3.063418888290233, 52.76916280269025],
            [-3.062906635852525, 52.770764892265056],
            [-3.066795774756639, 52.77378476661537],
            [-3.069556387243121, 52.7742220335414],
            [-3.071854888011711, 52.76991306997854],
            [-3.075039806818805, 52.76977729408687],
            [-3.079516250442163, 52.77151388250923],
            [-3.079684232411537, 52.77320970339976],
            [-3.077858052003312, 52.77375575740027],
            [-3.080512251786832, 52.7760600489315],
            [-3.080648769356095, 52.77744051853236],
            [-3.083870724103829, 52.77787864312902],
            [-3.088819827901243, 52.7775393359425],
            [-3.087780346962433, 52.77984666780302],
            [-3.091693801413911, 52.78675181805808],
            [-3.085738251461213, 52.79030353897353],
            [-3.08558761292274, 52.79336151192309],
            [-3.086632371752106, 52.79559312582767],
            [-3.090153800820682, 52.79632142213938],
            [-3.093461787997539, 52.79368563326404],
            [-3.097731127342023, 52.79137357262741],
            [-3.102390866737389, 52.7926123236518],
            [-3.106101271755665, 52.79295534738399],
            [-3.108466110596352, 52.791416654919665],
            [-3.107271522089457, 52.78969549493111],
            [-3.109707831537819, 52.78823070488194],
            [-3.109748463520691, 52.78668674256345],
            [-3.112189477628154, 52.78576586162162],
            [-3.113762056241641, 52.78654936593964],
            [-3.116418354637172, 52.78402877652356],
            [-3.118287021242106, 52.78358238529503],
            [-3.119533380259959, 52.785518738699814],
            [-3.11890989221511, 52.787223688004175],
            [-3.12211607693038, 52.78757914388548],
            [-3.125789389816577, 52.786956387757186],
            [-3.131062427080337, 52.78753193301582],
            [-3.142454469331165, 52.79032650960308],
            [-3.144552570888994, 52.788509163984514],
            [-3.14582853394893, 52.78887620474947],
            [-3.147314681599321, 52.79180971184133],
            [-3.156372315577439, 52.793577310037016],
            [-3.158425472594685, 52.793488076711704],
            [-3.160726573375846, 52.79563208987678],
            [-3.162034653177144, 52.798743307055695],
            [-3.159139273284267, 52.79968771616211],
            [-3.154120806409419, 52.80252084608913],
            [-3.153190826351219, 52.80577263330754],
            [-3.153816602726566, 52.80710692967831],
            [-3.156266302480294, 52.80801534391296],
            [-3.159031447090908, 52.80661733626873],
            [-3.161412408207977, 52.80357633548542],
            [-3.164443772406301, 52.80424586245882],
            [-3.168356984068093, 52.80822502803287],
            [-3.16546400076527, 52.81204635044863],
            [-3.165880902731597, 52.814813882492935],
            [-3.167628482961761, 52.8171286608586],
            [-3.167887720228838, 52.8192666435524],
            [-3.164899845033682, 52.82290006140641],
            [-3.161100630161099, 52.825850120791394],
            [-3.158197099146801, 52.82995905306046],
            [-3.155934965463218, 52.830179734151294],
            [-3.154065916172947, 52.83212626505662],
            [-3.156478775288202, 52.8370140216957],
            [-3.155329979915399, 52.83875402344519],
            [-3.152254631861847, 52.84029775674642],
            [-3.151260561211695, 52.84256485274172],
            [-3.158501428315617, 52.846625262310305],
            [-3.163014934014052, 52.84749091328001],
            [-3.161245380253452, 52.8493458006912],
            [-3.158191947514953, 52.85044540319802],
            [-3.154002066564866, 52.854284455251054],
            [-3.150726299041805, 52.8555910229283],
            [-3.147643766757035, 52.85573229463127],
            [-3.144562628296153, 52.85756452985435],
            [-3.142342084966252, 52.8601021749167],
            [-3.138551588346633, 52.861413325678],
            [-3.134673413689313, 52.86182349717874],
            [-3.127713059186365, 52.867103001328374],
            [-3.12883217696328, 52.8691240368683],
            [-3.133340489609224, 52.869607958110535],
            [-3.136304562331387, 52.87080856673315],
            [-3.139757213974637, 52.87357853540623],
            [-3.141826334904968, 52.87343734087695],
            [-3.151659632295293, 52.87804143074876],
            [-3.152535178268615, 52.87973288180689],
            [-3.1483054599653, 52.88123381581945],
            [-3.14670124477037, 52.88469960424056],
            [-3.14012729334108, 52.885588064420105],
            [-3.135566076536857, 52.88496560207491],
            [-3.136187346564402, 52.88621643971968],
            [-3.145755898569807, 52.88925932290153],
            [-3.147504123748138, 52.89016930859286],
            [-3.144695047842508, 52.89299673268163],
            [-3.138045054399669, 52.894835216033954],
            [-3.133395733299044, 52.8951420706049],
            [-3.129627099081702, 52.89427904587591],
            [-3.126655771370182, 52.89434679285731],
            [-3.121869314542662, 52.89544743565552],
            [-3.115335004071228, 52.89460634946449],
            [-3.113813490166457, 52.89532899124748],
            [-3.116881906680897, 52.89949577855214],
            [-3.114696391781393, 52.90453169449131],
            [-3.11275544173413, 52.906366734484465],
            [-3.112912243911095, 52.91149749188316],
            [-3.10850629543481, 52.920068126300905],
            [-3.106139165451174, 52.92132447559121],
            [-3.102522221781689, 52.92462491201777],
            [-3.099734063333859, 52.928006647199524],
            [-3.095953393614294, 52.930281821743435],
            [-3.094231872296714, 52.92968099620494],
            [-3.088288512795398, 52.9293850159843],
            [-3.085602245666403, 52.928394682183985],
            [-3.08435670410854, 52.92659101776668],
            [-3.076220195613197, 52.92547836667606],
            [-3.069770218005153, 52.92680149008554],
            [-3.06340282729525, 52.92654133860025],
            [-3.061514001080861, 52.92910779608883],
            [-3.056432417000468, 52.92802836212609],
            [-3.054922477804185, 52.92900098571411],
            [-3.051195930380592, 52.92919323690966],
            [-3.048176502524178, 52.92789835158134],
            [-3.045200990659684, 52.92914089892129],
            [-3.040829119319948, 52.92793493378274],
            [-3.03512365438524, 52.92946245418369],
            [-3.031320244797088, 52.931550705801875],
            [-3.031082720854604, 52.933812074472414],
            [-3.029109870817934, 52.93427607584526],
            [-3.02821575843068, 52.93682640124584],
            [-3.023868318843297, 52.93644136864695],
            [-3.025588984070518, 52.9382482021439],
            [-3.023029570455778, 52.94070920982864],
            [-3.024022227353973, 52.942251205405],
            [-3.020894427899264, 52.943321496336544],
            [-3.020999008614734, 52.944659171767015],
            [-3.017039292147064, 52.94870789365549],
            [-3.014320181672691, 52.94822350056583],
            [-3.012470281735512, 52.94968847383982],
            [-3.009936069585784, 52.955838322386526],
            [-3.003543958910108, 52.95795211130055],
            [-2.997540086616915, 52.95833352564182],
            [-2.993798596780389, 52.95812036506739],
            [-2.990171707707624, 52.959788577685316],
            [-2.985199798177086, 52.95869279969774],
            [-2.981656620968351, 52.9594736476883],
            [-2.979579152080689, 52.96266955004745],
            [-2.979493739053611, 52.965210734104765],
            [-2.9747702686677, 52.96895157122158],
            [-2.968486958403864, 52.96417555239882],
            [-2.972759341048322, 52.960368559103145],
            [-2.970573896349854, 52.95877181550939],
            [-2.968576414147518, 52.958921223884815],
            [-2.966076725232355, 52.95644334138047],
            [-2.961824305048971, 52.95565885848674],
            [-2.962401125156357, 52.953618961079904],
            [-2.959497834104065, 52.951029177295524],
            [-2.948733666722835, 52.94613715122743],
            [-2.943286157721676, 52.94481495308097],
            [-2.940705637003577, 52.94337555463582],
            [-2.937236059037648, 52.94258579053541],
            [-2.929207511141141, 52.93876177512919],
            [-2.927285715246756, 52.93879387406624],
            [-2.927445629452828, 52.94188689429129],
            [-2.918850319732606, 52.94356735286502],
            [-2.914157607482977, 52.94241152385507],
            [-2.908663738826915, 52.94192956477972],
            [-2.902400889460072, 52.944885549751135],
            [-2.901090017441048, 52.947898898364585],
            [-2.898292142048346, 52.950275423255874],
            [-2.892501253896302, 52.951159543287545],
            [-2.890307755097252, 52.95045505949666],
            [-2.88743151455419, 52.95252985453424],
            [-2.886047115937746, 52.948379721907024],
            [-2.883702910300791, 52.94669368789454],
            [-2.871637875610002, 52.9453012806118],
            [-2.869801151005287, 52.94477084324822],
            [-2.866856428425868, 52.94538478471969],
            [-2.854839069273603, 52.943725192908715],
            [-2.849824654714588, 52.94489199005078],
            [-2.842575617821602, 52.94205704709514],
            [-2.840275909691006, 52.942029289108696],
            [-2.840612942405712, 52.93907384462869],
            [-2.841851908477726, 52.93804828210458],
            [-2.838496237080026, 52.932183829708684],
            [-2.835872757099929, 52.9321572671167],
            [-2.834768689978711, 52.92982774099814],
            [-2.824865760324308, 52.92352407537535],
            [-2.822510590065565, 52.919890607053276],
            [-2.819095804025486, 52.91888041180281],
            [-2.817957036961334, 52.9176450014345],
            [-2.812385693851636, 52.91415664935743],
            [-2.813116953844169, 52.91024925948395],
            [-2.812282580452809, 52.90881489912432],
            [-2.807253684917787, 52.90658193479086],
            [-2.802732817224008, 52.901324103550124],
            [-2.801439882889443, 52.89676337469307],
            [-2.800446714112248, 52.89548581321242],
            [-2.794588923292567, 52.89720130788502],
            [-2.79273225154226, 52.8993999803404],
            [-2.793187716632863, 52.901220937935854],
            [-2.781661024658003, 52.90870018111757],
            [-2.776212287413883, 52.91174460668862],
            [-2.755326640545249, 52.92462801271078],
            [-2.744573247677816, 52.92443692754339],
            [-2.728541603141881, 52.92517808888669],
            [-2.726568146771077, 52.92795083048184],
            [-2.725839283869946, 52.93061789837703],
            [-2.727054197052265, 52.93430963180762],
            [-2.726516117485275, 52.93796804427831],
            [-2.727014086963664, 52.939800649749145],
            [-2.725605423304124, 52.94054185954929],
            [-2.726151548626321, 52.94594562867811],
            [-2.728172265705194, 52.94708304860243],
            [-2.72728274927008, 52.948257946580256],
            [-2.727802082794789, 52.953735650425884],
            [-2.724175550891491, 52.95645823111685],
            [-2.724326770644132, 52.95749196118664],
            [-2.727395890192069, 52.95931966598913],
            [-2.72806725232385, 52.9620590687426],
            [-2.72677761457974, 52.96531578911225],
            [-2.728258943663614, 52.96681697557239],
            [-2.73288407734968, 52.96754996726492],
            [-2.735293765222242, 52.96994615119753],
            [-2.730727656997876, 52.9748510439525],
            [-2.732079739715319, 52.9769553253764],
            [-2.72927198922472, 52.97887293537394],
            [-2.726587766649979, 52.981777668611876],
            [-2.727486332938302, 52.98401417947865],
            [-2.734787690941302, 52.98505448594843],
            [-2.737269707221444, 52.98473351232647],
            [-2.740959027151946, 52.98654183194204],
            [-2.743741573313661, 52.98714748363464],
            [-2.750775365507487, 52.98687772423735],
            [-2.753403001093407, 52.986187836527236],
            [-2.759940361108987, 52.98641963168476],
            [-2.76158167635063, 52.987423163503],
            [-2.761013824912316, 52.99096238092294],
            [-2.764411431579485, 52.99354760137885],
            [-2.768275538742738, 52.99486047875699],
            [-2.771226911872894, 52.99334821200415],
            [-2.773527672294582, 52.9947086651101],
            [-2.775972271942146, 52.99469006793064],
            [-2.779736049000122, 52.993381787633375],
            [-2.781586678449962, 52.99422189324254],
            [-2.78070048230152, 52.99572538444425],
            [-2.783407655403868, 52.9957201895343],
            [-2.78524180287133, 52.993916466335186],
            [-2.790048060961938, 52.99571222641023],
            [-2.793986213372691, 52.99320668712878],
            [-2.791937530778025, 52.991087110517064],
            [-2.794503015983147, 52.9907661552808],
            [-2.796102051526494, 52.991681393312845],
            [-2.798202002688547, 52.989469383129304],
            [-2.80118051945692, 52.99094523991238],
            [-2.802724176248566, 52.98975448580321],
            [-2.803712160231751, 52.99145766794167],
            [-2.810237046200143, 52.99175588165631],
            [-2.809910209014447, 52.99267594199492],
            [-2.814090943454523, 52.99277141454557],
            [-2.820820738571696, 52.99442862401987],
            [-2.824286689660872, 52.99336189713057],
            [-2.82786236278098, 52.994372623010946],
            [-2.832472705702899, 52.9966481023263],
            [-2.835995770191975, 52.99715011099914],
            [-2.834899519489789, 52.998254578071],
            [-2.836197591283333, 53.00157790077936],
            [-2.838042347483032, 53.00304092857488],
            [-2.839357058874593, 53.00635960590424],
            [-2.840621282212177, 53.007222677762904],
            [-2.840700515747775, 53.010457408528985],
            [-2.838598303396205, 53.01103590909065],
            [-2.840384473320032, 53.01351878619502],
            [-2.843163519504094, 53.015162146324876],
            [-2.844062197786045, 53.01766833169927],
            [-2.847913670447793, 53.019015398081365],
            [-2.851627477405266, 53.01698784062052],
            [-2.858617146700853, 53.01983757749067],
            [-2.861044479565492, 53.02284862018975],
            [-2.860073223719573, 53.025434710196194],
            [-2.860454375348474, 53.02877786765007],
            [-2.85639331881218, 53.032643857636515],
            [-2.855530082393105, 53.034463263626556],
            [-2.855737082124418, 53.037154068511406],
            [-2.858796287644416, 53.03890298124358],
            [-2.861873162317161, 53.03860384452679],
            [-2.866684998210692, 53.04070929737026],
            [-2.861026194251068, 53.042799932425766],
            [-2.862380076335353, 53.04419701919104],
            [-2.864185330291491, 53.04332270955521],
            [-2.866560068722744, 53.04407408338772],
            [-2.864998311196045, 53.045560550529075],
            [-2.869596024547163, 53.04454270400043],
            [-2.870109567411534, 53.04545587877008],
            [-2.863118897838014, 53.048622539748536],
            [-2.863007542858102, 53.05163393091538],
            [-2.864827200768979, 53.0518381976765],
            [-2.866082624823656, 53.05009326891762],
            [-2.868551857968437, 53.050550762016265],
            [-2.863732081062393, 53.053324926246596],
            [-2.861664442506617, 53.052212617638446],
            [-2.859913631173955, 53.052617286493835],
            [-2.860456611158043, 53.054782495842296],
            [-2.866498929329075, 53.05514224336826],
            [-2.867494889328478, 53.055999783665854],
            [-2.865598638683568, 53.05727209937007],
            [-2.863027284020379, 53.05657336356242],
            [-2.860886374636397, 53.05732515641725],
            [-2.863161375087184, 53.05865075894834],
            [-2.86567613121854, 53.05874842014946],
            [-2.86761491327617, 53.0570739959945],
            [-2.870287362538306, 53.05685758160317],
            [-2.872555014633621, 53.05861550460077],
            [-2.869679562185068, 53.05993998644097],
            [-2.868292992385594, 53.05955370733991],
            [-2.865160449018905, 53.06078559610982],
            [-2.862419284235393, 53.06011423483509],
            [-2.861604098306422, 53.060914745351866],
            [-2.864111535308503, 53.063322797685075],
            [-2.869626976329029, 53.063767095716685],
            [-2.870478672610534, 53.0646328496119],
            [-2.865818948171201, 53.06578514892355],
            [-2.867360851723746, 53.06669083535427],
            [-2.869153353596708, 53.06951386170749],
            [-2.87296789461578, 53.0702392034008],
            [-2.877652953158813, 53.06892018933022],
            [-2.87779862273092, 53.071016333403634],
            [-2.875671178263337, 53.073562472192314],
            [-2.88072711283177, 53.07394492891318],
            [-2.881782382319874, 53.07496545772494],
            [-2.879605177401597, 53.07616906384042],
            [-2.879007385882081, 53.07811243462552],
            [-2.876048641353412, 53.08060808647173],
            [-2.876048232963007, 53.08176322865932],
            [-2.879638920228432, 53.08345813042637],
            [-2.890865911467194, 53.08742606031096],
            [-2.893449904186298, 53.09150485847663],
            [-2.895789691719744, 53.09185581456078],
            [-2.900506404299716, 53.09075863504357],
            [-2.901999430770788, 53.09310523912645],
            [-2.899452314247251, 53.09384002709236],
            [-2.899519694235372, 53.09764013364811],
            [-2.897535713081898, 53.09889921496275],
            [-2.893914171981517, 53.09783153848529],
            [-2.897883045802259, 53.09657463672131],
            [-2.896791360780568, 53.09521474585185],
            [-2.893796405723063, 53.09611373558066],
            [-2.8903513377765, 53.09966778283403],
            [-2.88730395440486, 53.104422427879776],
            [-2.887492385951175, 53.10566602565806],
            [-2.892814532806964, 53.104081883170885],
            [-2.891817428705032, 53.10923750468517],
            [-2.889087748411399, 53.10885604191101],
            [-2.886831897193913, 53.11073363117549],
            [-2.883878999439977, 53.111343493685446],
            [-2.88413925698132, 53.11325085024542],
            [-2.881619812377813, 53.118255830650575],
            [-2.880942485788024, 53.12137470172364],
            [-2.88543163084643, 53.12044965463175],
            [-2.886499928958089, 53.121383768492116],
            [-2.888033617643854, 53.1198208037171],
            [-2.892347002569903, 53.11835393165827],
            [-2.895251060700131, 53.11638500443191],
            [-2.897066938933488, 53.11397488358271],
            [-2.899194376233831, 53.114113403215235],
            [-2.903391818063997, 53.11179750553178],
            [-2.908022465774225, 53.113114221427864],
            [-2.909637641154935, 53.11269560772153],
            [-2.917378587869725, 53.114833165216865],
            [-2.921314340056306, 53.11736467119567],
            [-2.928584445017886, 53.11983683441224],
            [-2.931925169585744, 53.120093898566],
            [-2.934410408288784, 53.121485764331815],
            [-2.938034930734881, 53.12097989190318],
            [-2.940601911533006, 53.122407828051905],
            [-2.942613218064641, 53.12138065752534],
            [-2.944980459800401, 53.12227780406416],
            [-2.946451663099698, 53.12686680953813],
            [-2.957940919204677, 53.13034729654921],
            [-2.96015863586503, 53.13248317450543],
            [-2.963895789345383, 53.13277030415618],
            [-2.979498209958147, 53.15062162901941],
            [-2.980345078566467, 53.1493983943561],
            [-2.984448732461022, 53.147792316836096],
            [-2.987699369773927, 53.15209557724799],
            [-2.995088493468779, 53.15419593344768],
            [-2.993059663126977, 53.15492489241745],
            [-2.992274261093717, 53.15666454263014],
            [-2.989956945901505, 53.157542335948534],
            [-2.988124306161747, 53.15692830057884],
            [-2.984640435529545, 53.15859499961331],
            [-2.981492088668483, 53.15629187864432],
            [-2.975574267400881, 53.15733740542991],
            [-2.970926148736983, 53.1607823656837],
            [-2.966263043172538, 53.15986472299901],
            [-2.962372567041454, 53.16232148023671],
            [-2.956784736643535, 53.16380572705842],
            [-2.953479110092359, 53.165351446988105],
            [-2.948907449490897, 53.16600732024905],
            [-2.946553313795628, 53.16711191941346],
            [-2.944041267746742, 53.165247691102316],
            [-2.933907451625108, 53.169388945624746],
            [-2.927838681377076, 53.171411380499805],
            [-2.926589542494455, 53.17335738099116],
            [-2.922850551568968, 53.17529122661464],
            [-2.920955974103256, 53.177085705624535],
            [-2.920332258485783, 53.18331561542352],
            [-2.922299474144674, 53.189292640871585],
            [-2.929238178185991, 53.19429068419609],
            [-2.935369747485983, 53.19632016113724],
            [-2.937566325776249, 53.19785894088232],
            [-2.943732343625113, 53.20400387856262],
            [-2.949215257998678, 53.21107524699294],
            [-2.953307469623907, 53.21309576658591],
            [-2.966163085103289, 53.21868960792778],
            [-2.977837083401857, 53.22539385517228],
            [-2.984911835180632, 53.228471012102744],
            [-2.992559341263562, 53.233015334478694],
            [-2.998378413415403, 53.23585860665535],
            [-3.008225103961502, 53.24019208624761],
            [-3.025462473875721, 53.248315034973764],
            [-3.036024312516703, 53.2518049487822],
            [-3.069136643946185, 53.25300473613202],
            [-3.080523154014559, 53.25494445590292],
            [-3.086035349112821, 53.25680097367891],
            [-3.090410699867145, 53.25890588802949],
            [-3.095091724497656, 53.2618159110174],
            [-3.099528676961114, 53.265350051082315],
            [-3.113709900742549, 53.277711725125414],
            [-3.121831951486635, 53.28283142556116],
            [-3.131026222371075, 53.28803919473142],
            [-3.144279015683546, 53.29647333515846],
            [-3.165791390203885, 53.31124826540474],
            [-3.170884259020438, 53.31394105459595],
            [-3.186797595466751, 53.32159288526026],
            [-3.216520009291337, 53.33847966269064],
            [-3.223255987408556, 53.335348838688894],
            [-3.225430442088843, 53.33706702029747],
            [-3.227091924637875, 53.3368073336348],
            [-3.22423942504536, 53.33498263380212],
            [-3.228994609875348, 53.332627658788034],
            [-3.231183146383903, 53.33446537967452],
            [-3.237118260506412, 53.33766000459421],
            [-3.242355963518321, 53.33860258370356],
            [-3.251983933641816, 53.34223043752392],
            [-3.255179388453564, 53.342190440245986],
            [-3.255830270124842, 53.340295423594775],
            [-3.25574727868973, 53.329626021349945],
            [-3.257143635805896, 53.325746619912294],
            [-3.25430962737843, 53.32099007355107],
            [-3.256617703755443, 53.319913752089114],
            [-3.259808925037223, 53.323934912803416],
            [-3.261241817266159, 53.323059730738855],
            [-3.258141230749268, 53.319217347598304],
            [-3.25983097535185, 53.31842838500539],
            [-3.263576736246915, 53.32398275341486],
            [-3.260862476642614, 53.325699210172836],
            [-3.26464768770606, 53.325721843261334],
            [-3.269493984007486, 53.32714258041403],
            [-3.273187931841618, 53.32911365196323],
            [-3.276421589563989, 53.3321322222858],
            [-3.277471730314838, 53.334548568578874],
            [-3.275964386355836, 53.34177430661665],
            [-3.27780475100278, 53.344431151060306],
            [-3.285940106953765, 53.34930188629744],
            [-3.293038670411243, 53.35424630683315],
            [-3.303499141630279, 53.358491596367756],
            [-3.310235564167147, 53.36004404829085],
            [-3.320543832949123, 53.36051051373866],
            [-3.3267029507749397, 53.36038048477342],
            [-3.3266149727431014, 53.39862758952373],
            [-4.078996859820563, 53.473399569631795],
            [-4.754480739305819, 53.43776035252631],
            [-4.9454403170510375, 53.136182860591674],
            [-4.506510676201202, 53.086554143982994],
            [-5.042345177399284, 52.73766531062367],
            [-4.6746767366664415, 52.59766240480573],
            [-4.255705722808159, 52.77906154368745],
            [-4.1958512869256595, 52.43462647924855],
            [-4.631924592394853, 52.20640856823323],
            [-5.498368049625327, 51.945399337501556],
            [-5.657976054904083, 51.63689369163981],
          ],
        ],
        type: "Polygon",
      },
    },
    {
      type: "Feature",
      properties: {
        country: "Wales",
      },
      geometry: {
        coordinates: [
          [
            [-2.782548119342657, 51.5247946818297],
            [-2.780272717119925, 51.52559024683192],
            [-2.780430346416984, 51.527473872105176],
            [-2.782548119342657, 51.5247946818297],
          ],
        ],
        type: "Polygon",
      },
    },
  ],
};
